import { __ } from '@wordpress/i18n';
import { applyFilters } from '@wordpress/hooks';

// accessibility
import {
    iconFontAwesomeAccessibilityAccessibleIcon,
    iconFontAwesomeAccessibilityAddressCard,
    iconFontAwesomeAccessibilityAudioDescription,
    iconFontAwesomeAccessibilityBraille,
    iconFontAwesomeAccessibilityCircleInfo,
    iconFontAwesomeAccessibilityCircleQuestion,
    iconFontAwesomeAccessibilityClosedCaptioning,
    iconFontAwesomeAccessibilityEarDeaf,
    iconFontAwesomeAccessibilityEarListen,
    iconFontAwesomeAccessibilityEye,
    iconFontAwesomeAccessibilityEyeLowVision,
    iconFontAwesomeAccessibilityFingerprint,
    iconFontAwesomeAccessibilityHandsAslInterpreting,
    iconFontAwesomeAccessibilityHandshakeAngle,
    iconFontAwesomeAccessibilityHands,
    iconFontAwesomeAccessibilityPersonCane,
    iconFontAwesomeAccessibilityPersonWalkingWithCane,
    iconFontAwesomeAccessibilityPhoneVolume,
    iconFontAwesomeAccessibilityQuestion,
    iconFontAwesomeAccessibilityTty,
    iconFontAwesomeAccessibilityUniversalAccess,
    iconFontAwesomeAccessibilityWheelchair,
    iconFontAwesomeAccessibilityWheelchairMove,
} from './accessibility';

// accessibility
const accessibilityIcons = [
    {
        name: 'iconFontAwesomeAccessibilityAccessibleIcon',
        title: __('Accessible Icon', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityAccessibleIcon,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityAddressCard',
        title: __('Address Card', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityAddressCard,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityAudioDescription',
        title: __('Audio Description', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityAudioDescription,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityBraille',
        title: __('Braille', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityBraille,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityCircleInfo',
        title: __('Circle Info', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityCircleInfo,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityCircleQuestion',
        title: __('Circle Question', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityCircleQuestion,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityClosedCaptioning',
        title: __('Closed Captioning', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityClosedCaptioning,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityEarDeaf',
        title: __('Ear Deaf', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityEarDeaf,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityEarListen',
        title: __('Ear Listen', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityEarListen,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityEye',
        title: __('Eye', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityEye,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityEyeLowVision',
        title: __('Eye Low Vision', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityEyeLowVision,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityFingerprint',
        title: __('Fingerprint', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityFingerprint,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityHandsAslInterpreting',
        title: __('Hands Asl Interpreting', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityHandsAslInterpreting,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityHandshakeAngle',
        title: __('Handshake Angle', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityHandshakeAngle,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityHands',
        title: __('Hands', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityHands,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityPersonCane',
        title: __('Person Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityPersonCane,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityPersonWalkingWithCane',
        title: __('Person Walking With Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityPersonWalkingWithCane,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityPhoneVolume',
        title: __('Phone Volume', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityPhoneVolume,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityQuestion',
        title: __('Question', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityQuestion,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityTty',
        title: __('Tty', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityTty,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityUniversalAccess',
        title: __('Universal Access', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityUniversalAccess,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityWheelchair',
        title: __('Wheelchair', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityWheelchair,
        categories: ['accessibility'],
    },
    {
        name: 'iconFontAwesomeAccessibilityWheelchairMove',
        title: __('Wheelchair Move', 'icon-font-awesome'),
        icon: iconFontAwesomeAccessibilityWheelchairMove,
        categories: ['accessibility'],
    },
];

// alert
import {
    iconFontAwesomeAlertBell,
    iconFontAwesomeAlertBellSlash,
    iconFontAwesomeAlertCircleExclamation,
    iconFontAwesomeAlertCircleRadiation,
    iconFontAwesomeAlertExclamation,
    iconFontAwesomeAlertQuestion,
    iconFontAwesomeAlertRadiation,
    iconFontAwesomeAlertSkullCrossbones,
    iconFontAwesomeAlertTriangleExclamation,
} from './alert';

// alert
const alertIcons = [
    {
        name: 'iconFontAwesomeAlertBell',
        title: __('Bell', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertBell,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertBellSlash',
        title: __('Bell Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertBellSlash,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertCircleExclamation',
        title: __('Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertCircleExclamation,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertCircleRadiation',
        title: __('Circle Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertCircleRadiation,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertExclamation',
        title: __('Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertExclamation,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertQuestion',
        title: __('Question', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertQuestion,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertRadiation',
        title: __('Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertRadiation,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertSkullCrossbones',
        title: __('Skull Crossbones', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertSkullCrossbones,
        categories: ['alert'],
    },
    {
        name: 'iconFontAwesomeAlertTriangleExclamation',
        title: __('Triangle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeAlertTriangleExclamation,
        categories: ['alert'],
    },
];

// alphabet
import {
    iconFontAwesomeAlphabetAddressCard,
    iconFontAwesomeAlphabetA,
    iconFontAwesomeAlphabetB,
    iconFontAwesomeAlphabetCircleH,
    iconFontAwesomeAlphabetC,
    iconFontAwesomeAlphabetD,
    iconFontAwesomeAlphabetE,
    iconFontAwesomeAlphabetF,
    iconFontAwesomeAlphabetG,
    iconFontAwesomeAlphabetH,
    iconFontAwesomeAlphabetI,
    iconFontAwesomeAlphabetJ,
    iconFontAwesomeAlphabetK,
    iconFontAwesomeAlphabetL,
    iconFontAwesomeAlphabetM,
    iconFontAwesomeAlphabetN,
    iconFontAwesomeAlphabetO,
    iconFontAwesomeAlphabetP,
    iconFontAwesomeAlphabetQ,
    iconFontAwesomeAlphabetR,
    iconFontAwesomeAlphabetS,
    iconFontAwesomeAlphabetSquareH,
    iconFontAwesomeAlphabetT,
    iconFontAwesomeAlphabetU,
    iconFontAwesomeAlphabetV,
    iconFontAwesomeAlphabetW,
    iconFontAwesomeAlphabetX,
    iconFontAwesomeAlphabetY,
    iconFontAwesomeAlphabetZ,
} from './alphabet';

// alphabet
const alphabetIcons = [
    {
        name: 'iconFontAwesomeAlphabetAddressCard',
        title: __('Address Card', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetAddressCard,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetA',
        title: __('A', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetA,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetB',
        title: __('B', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetB,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetCircleH',
        title: __('Circle H', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetCircleH,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetC',
        title: __('C', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetC,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetD',
        title: __('D', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetD,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetE',
        title: __('E', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetE,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetF',
        title: __('F', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetF,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetG',
        title: __('G', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetG,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetH',
        title: __('H', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetH,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetI',
        title: __('I', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetI,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetJ',
        title: __('J', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetJ,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetK',
        title: __('K', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetK,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetL',
        title: __('L', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetL,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetM',
        title: __('M', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetM,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetN',
        title: __('N', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetN,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetO',
        title: __('O', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetO,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetP',
        title: __('P', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetP,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetQ',
        title: __('Q', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetQ,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetR',
        title: __('R', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetR,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetS',
        title: __('S', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetS,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetSquareH',
        title: __('Square H', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetSquareH,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetT',
        title: __('T', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetT,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetU',
        title: __('U', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetU,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetV',
        title: __('V', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetV,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetW',
        title: __('W', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetW,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetX',
        title: __('X', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetX,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetY',
        title: __('Y', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetY,
        categories: ['alphabet'],
    },
    {
        name: 'iconFontAwesomeAlphabetZ',
        title: __('Z', 'icon-font-awesome'),
        icon: iconFontAwesomeAlphabetZ,
        categories: ['alphabet'],
    },
];

// animals
import {
    iconFontAwesomeAnimalsBugs,
    iconFontAwesomeAnimalsCat,
    iconFontAwesomeAnimalsCow,
    iconFontAwesomeAnimalsCrow,
    iconFontAwesomeAnimalsDog,
    iconFontAwesomeAnimalsDove,
    iconFontAwesomeAnimalsDragon,
    iconFontAwesomeAnimalsFeather,
    iconFontAwesomeAnimalsFeatherPointed,
    iconFontAwesomeAnimalsFishFins,
    iconFontAwesomeAnimalsFish,
    iconFontAwesomeAnimalsFrog,
    iconFontAwesomeAnimalsHippo,
    iconFontAwesomeAnimalsHorseHead,
    iconFontAwesomeAnimalsHorse,
    iconFontAwesomeAnimalsKiwiBird,
    iconFontAwesomeAnimalsLocust,
    iconFontAwesomeAnimalsMosquito,
    iconFontAwesomeAnimalsOtter,
    iconFontAwesomeAnimalsPaw,
    iconFontAwesomeAnimalsShieldCat,
    iconFontAwesomeAnimalsShieldDog,
    iconFontAwesomeAnimalsShrimp,
    iconFontAwesomeAnimalsSpider,
    iconFontAwesomeAnimalsWorm,
} from './animals';

// animals
const animalsIcons = [
    {
        name: 'iconFontAwesomeAnimalsBugs',
        title: __('Bugs', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsBugs,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsCat',
        title: __('Cat', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsCat,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsCow',
        title: __('Cow', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsCow,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsCrow',
        title: __('Crow', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsCrow,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsDog',
        title: __('Dog', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsDog,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsDove',
        title: __('Dove', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsDove,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsDragon',
        title: __('Dragon', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsDragon,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsFeather',
        title: __('Feather', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsFeather,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsFeatherPointed',
        title: __('Feather Pointed', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsFeatherPointed,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsFishFins',
        title: __('Fish Fins', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsFishFins,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsFish',
        title: __('Fish', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsFish,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsFrog',
        title: __('Frog', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsFrog,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsHippo',
        title: __('Hippo', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsHippo,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsHorseHead',
        title: __('Horse Head', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsHorseHead,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsHorse',
        title: __('Horse', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsHorse,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsKiwiBird',
        title: __('Kiwi Bird', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsKiwiBird,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsLocust',
        title: __('Locust', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsLocust,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsMosquito',
        title: __('Mosquito', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsMosquito,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsOtter',
        title: __('Otter', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsOtter,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsPaw',
        title: __('Paw', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsPaw,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsShieldCat',
        title: __('Shield Cat', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsShieldCat,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsShieldDog',
        title: __('Shield Dog', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsShieldDog,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsShrimp',
        title: __('Shrimp', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsShrimp,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsSpider',
        title: __('Spider', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsSpider,
        categories: ['animals'],
    },
    {
        name: 'iconFontAwesomeAnimalsWorm',
        title: __('Worm', 'icon-font-awesome'),
        icon: iconFontAwesomeAnimalsWorm,
        categories: ['animals'],
    },
];

// arrows
import {
    iconFontAwesomeArrowsAngleDown,
    iconFontAwesomeArrowsAngleLeft,
    iconFontAwesomeArrowsAngleRight,
    iconFontAwesomeArrowsAnglesDown,
    iconFontAwesomeArrowsAnglesLeft,
    iconFontAwesomeArrowsAnglesRight,
    iconFontAwesomeArrowsAnglesUp,
    iconFontAwesomeArrowsAngleUp,
    iconFontAwesomeArrowsArrowDown19,
    iconFontAwesomeArrowsArrowDown91,
    iconFontAwesomeArrowsArrowDownAZ,
    iconFontAwesomeArrowsArrowDown,
    iconFontAwesomeArrowsArrowDownLong,
    iconFontAwesomeArrowsArrowDownShortWide,
    iconFontAwesomeArrowsArrowDownUpAcrossLine,
    iconFontAwesomeArrowsArrowDownUpLock,
    iconFontAwesomeArrowsArrowDownWideShort,
    iconFontAwesomeArrowsArrowDownZA,
    iconFontAwesomeArrowsArrowLeft,
    iconFontAwesomeArrowsArrowLeftLong,
    iconFontAwesomeArrowsArrowPointer,
    iconFontAwesomeArrowsArrowRightArrowLeft,
    iconFontAwesomeArrowsArrowRightFromBracket,
    iconFontAwesomeArrowsArrowRight,
    iconFontAwesomeArrowsArrowRightLong,
    iconFontAwesomeArrowsArrowRightToBracket,
    iconFontAwesomeArrowsArrowRotateLeft,
    iconFontAwesomeArrowsArrowRotateRight,
    iconFontAwesomeArrowsArrowsDownToLine,
    iconFontAwesomeArrowsArrowsLeftRight,
    iconFontAwesomeArrowsArrowsLeftRightToLine,
    iconFontAwesomeArrowsArrowsRotate,
    iconFontAwesomeArrowsArrowsSpin,
    iconFontAwesomeArrowsArrowsSplitUpAndLeft,
    iconFontAwesomeArrowsArrowsToCircle,
    iconFontAwesomeArrowsArrowsToDot,
    iconFontAwesomeArrowsArrowsToEye,
    iconFontAwesomeArrowsArrowsTurnRight,
    iconFontAwesomeArrowsArrowsTurnToDots,
    iconFontAwesomeArrowsArrowsUpDown,
    iconFontAwesomeArrowsArrowsUpDownLeftRight,
    iconFontAwesomeArrowsArrowsUpToLine,
    iconFontAwesomeArrowsArrowTrendDown,
    iconFontAwesomeArrowsArrowTrendUp,
    iconFontAwesomeArrowsArrowTurnDown,
    iconFontAwesomeArrowsArrowTurnUp,
    iconFontAwesomeArrowsArrowUp19,
    iconFontAwesomeArrowsArrowUp91,
    iconFontAwesomeArrowsArrowUpAZ,
    iconFontAwesomeArrowsArrowUpFromBracket,
    iconFontAwesomeArrowsArrowUp,
    iconFontAwesomeArrowsArrowUpLong,
    iconFontAwesomeArrowsArrowUpRightDots,
    iconFontAwesomeArrowsArrowUpRightFromSquare,
    iconFontAwesomeArrowsArrowUpShortWide,
    iconFontAwesomeArrowsArrowUpWideShort,
    iconFontAwesomeArrowsArrowUpZA,
    iconFontAwesomeArrowsCaretDown,
    iconFontAwesomeArrowsCaretLeft,
    iconFontAwesomeArrowsCaretRight,
    iconFontAwesomeArrowsCaretUp,
    iconFontAwesomeArrowsChevronDown,
    iconFontAwesomeArrowsChevronLeft,
    iconFontAwesomeArrowsChevronRight,
    iconFontAwesomeArrowsChevronUp,
    iconFontAwesomeArrowsCircleArrowDown,
    iconFontAwesomeArrowsCircleArrowLeft,
    iconFontAwesomeArrowsCircleArrowRight,
    iconFontAwesomeArrowsCircleArrowUp,
    iconFontAwesomeArrowsCircleChevronDown,
    iconFontAwesomeArrowsCircleChevronLeft,
    iconFontAwesomeArrowsCircleChevronRight,
    iconFontAwesomeArrowsCircleChevronUp,
    iconFontAwesomeArrowsCircleDown,
    iconFontAwesomeArrowsCircleLeft,
    iconFontAwesomeArrowsCircleRight,
    iconFontAwesomeArrowsCircleUp,
    iconFontAwesomeArrowsClockRotateLeft,
    iconFontAwesomeArrowsCloudArrowDown,
    iconFontAwesomeArrowsCloudArrowUp,
    iconFontAwesomeArrowsDownLeftAndUpRightToCenter,
    iconFontAwesomeArrowsDownload,
    iconFontAwesomeArrowsDownLong,
    iconFontAwesomeArrowsLeftLong,
    iconFontAwesomeArrowsLeftRight,
    iconFontAwesomeArrowsLocationArrow,
    iconFontAwesomeArrowsMaximize,
    iconFontAwesomeArrowsRecycle,
    iconFontAwesomeArrowsRepeat,
    iconFontAwesomeArrowsReplyAll,
    iconFontAwesomeArrowsReply,
    iconFontAwesomeArrowsRetweet,
    iconFontAwesomeArrowsRightFromBracket,
    iconFontAwesomeArrowsRightLeft,
    iconFontAwesomeArrowsRightLong,
    iconFontAwesomeArrowsRightToBracket,
    iconFontAwesomeArrowsRotate,
    iconFontAwesomeArrowsRotateLeft,
    iconFontAwesomeArrowsRotateRight,
    iconFontAwesomeArrowsShareFromSquare,
    iconFontAwesomeArrowsShare,
    iconFontAwesomeArrowsShuffle,
    iconFontAwesomeArrowsSortDown,
    iconFontAwesomeArrowsSort,
    iconFontAwesomeArrowsSortUp,
    iconFontAwesomeArrowsSquareArrowUpRight,
    iconFontAwesomeArrowsSquareCaretDown,
    iconFontAwesomeArrowsSquareCaretLeft,
    iconFontAwesomeArrowsSquareCaretRight,
    iconFontAwesomeArrowsSquareCaretUp,
    iconFontAwesomeArrowsSquareUpRight,
    iconFontAwesomeArrowsTurnDown,
    iconFontAwesomeArrowsTurnUp,
    iconFontAwesomeArrowsUpDown,
    iconFontAwesomeArrowsUpDownLeftRight,
    iconFontAwesomeArrowsUpload,
    iconFontAwesomeArrowsUpLong,
    iconFontAwesomeArrowsUpRightAndDownLeftFromCenter,
    iconFontAwesomeArrowsUpRightFromSquare,
} from './arrows';

// arrows
const arrowsIcons = [
    {
        name: 'iconFontAwesomeArrowsAngleDown',
        title: __('Angle Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAngleDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsAngleLeft',
        title: __('Angle Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAngleLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsAngleRight',
        title: __('Angle Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAngleRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsAnglesDown',
        title: __('Angles Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAnglesDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsAnglesLeft',
        title: __('Angles Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAnglesLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsAnglesRight',
        title: __('Angles Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAnglesRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsAnglesUp',
        title: __('Angles Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAnglesUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsAngleUp',
        title: __('Angle Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsAngleUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDown19',
        title: __('Arrow Down19', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDown19,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDown91',
        title: __('Arrow Down91', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDown91,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDownAZ',
        title: __('Arrow Down AZ', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDownAZ,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDown',
        title: __('Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDownLong',
        title: __('Arrow Down Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDownLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDownShortWide',
        title: __('Arrow Down Short Wide', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDownShortWide,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDownUpAcrossLine',
        title: __('Arrow Down Up Across Line', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDownUpAcrossLine,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDownUpLock',
        title: __('Arrow Down Up Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDownUpLock,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDownWideShort',
        title: __('Arrow Down Wide Short', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDownWideShort,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowDownZA',
        title: __('Arrow Down ZA', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowDownZA,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowLeft',
        title: __('Arrow Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowLeftLong',
        title: __('Arrow Left Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowLeftLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowPointer',
        title: __('Arrow Pointer', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowPointer,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowRightArrowLeft',
        title: __('Arrow Right Arrow Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowRightArrowLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowRightFromBracket',
        title: __('Arrow Right From Bracket', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowRightFromBracket,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowRight',
        title: __('Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowRightLong',
        title: __('Arrow Right Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowRightLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowRightToBracket',
        title: __('Arrow Right To Bracket', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowRightToBracket,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowRotateLeft',
        title: __('Arrow Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowRotateLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowRotateRight',
        title: __('Arrow Rotate Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowRotateRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsDownToLine',
        title: __('Down To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsDownToLine,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsLeftRight',
        title: __('Left Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsLeftRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsLeftRightToLine',
        title: __('Left Right To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsLeftRightToLine,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsRotate',
        title: __('Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsRotate,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsSpin',
        title: __('Spin', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsSpin,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsSplitUpAndLeft',
        title: __('Split Up And Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsSplitUpAndLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsToCircle',
        title: __('To Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsToCircle,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsToDot',
        title: __('To Dot', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsToDot,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsToEye',
        title: __('To Eye', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsToEye,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsTurnRight',
        title: __('Turn Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsTurnRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsTurnToDots',
        title: __('Turn To Dots', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsTurnToDots,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsUpDown',
        title: __('Up Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsUpDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsUpDownLeftRight',
        title: __('Up Down Left Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsUpDownLeftRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowsUpToLine',
        title: __('Up To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowsUpToLine,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowTrendDown',
        title: __('Arrow Trend Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowTrendDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowTrendUp',
        title: __('Arrow Trend Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowTrendUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowTurnDown',
        title: __('Arrow Turn Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowTurnDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowTurnUp',
        title: __('Arrow Turn Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowTurnUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUp19',
        title: __('Arrow Up19', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUp19,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUp91',
        title: __('Arrow Up91', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUp91,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpAZ',
        title: __('Arrow Up AZ', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpAZ,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpFromBracket',
        title: __('Arrow Up From Bracket', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpFromBracket,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUp',
        title: __('Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpLong',
        title: __('Arrow Up Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpRightDots',
        title: __('Arrow Up Right Dots', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpRightDots,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpRightFromSquare',
        title: __('Arrow Up Right From Square', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpRightFromSquare,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpShortWide',
        title: __('Arrow Up Short Wide', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpShortWide,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpWideShort',
        title: __('Arrow Up Wide Short', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpWideShort,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsArrowUpZA',
        title: __('Arrow Up ZA', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsArrowUpZA,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCaretDown',
        title: __('Caret Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCaretDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCaretLeft',
        title: __('Caret Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCaretLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCaretRight',
        title: __('Caret Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCaretRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCaretUp',
        title: __('Caret Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCaretUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsChevronDown',
        title: __('Chevron Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsChevronDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsChevronLeft',
        title: __('Chevron Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsChevronLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsChevronRight',
        title: __('Chevron Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsChevronRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsChevronUp',
        title: __('Chevron Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsChevronUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleArrowDown',
        title: __('Circle Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleArrowDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleArrowLeft',
        title: __('Circle Arrow Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleArrowLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleArrowRight',
        title: __('Circle Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleArrowRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleArrowUp',
        title: __('Circle Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleArrowUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleChevronDown',
        title: __('Circle Chevron Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleChevronDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleChevronLeft',
        title: __('Circle Chevron Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleChevronLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleChevronRight',
        title: __('Circle Chevron Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleChevronRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleChevronUp',
        title: __('Circle Chevron Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleChevronUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleDown',
        title: __('Circle Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleLeft',
        title: __('Circle Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleRight',
        title: __('Circle Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCircleUp',
        title: __('Circle Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCircleUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsClockRotateLeft',
        title: __('Clock Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsClockRotateLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCloudArrowDown',
        title: __('Cloud Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCloudArrowDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsCloudArrowUp',
        title: __('Cloud Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsCloudArrowUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsDownLeftAndUpRightToCenter',
        title: __('Down Left And Up Right To Center', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsDownLeftAndUpRightToCenter,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsDownload',
        title: __('Download', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsDownload,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsDownLong',
        title: __('Down Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsDownLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsLeftLong',
        title: __('Left Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsLeftLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsLeftRight',
        title: __('Left Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsLeftRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsLocationArrow',
        title: __('Location Arrow', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsLocationArrow,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsMaximize',
        title: __('Maximize', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsMaximize,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRecycle',
        title: __('Recycle', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRecycle,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRepeat',
        title: __('Repeat', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRepeat,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsReplyAll',
        title: __('Reply All', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsReplyAll,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsReply',
        title: __('Reply', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsReply,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRetweet',
        title: __('Retweet', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRetweet,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRightFromBracket',
        title: __('Right From Bracket', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRightFromBracket,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRightLeft',
        title: __('Right Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRightLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRightLong',
        title: __('Right Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRightLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRightToBracket',
        title: __('Right To Bracket', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRightToBracket,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRotate',
        title: __('Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRotate,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRotateLeft',
        title: __('Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRotateLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsRotateRight',
        title: __('Rotate Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsRotateRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsShareFromSquare',
        title: __('Share From Square', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsShareFromSquare,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsShare',
        title: __('Share', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsShare,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsShuffle',
        title: __('Shuffle', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsShuffle,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSortDown',
        title: __('Sort Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSortDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSort',
        title: __('Sort', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSort,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSortUp',
        title: __('Sort Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSortUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSquareArrowUpRight',
        title: __('Square Arrow Up Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSquareArrowUpRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSquareCaretDown',
        title: __('Square Caret Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSquareCaretDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSquareCaretLeft',
        title: __('Square Caret Left', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSquareCaretLeft,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSquareCaretRight',
        title: __('Square Caret Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSquareCaretRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSquareCaretUp',
        title: __('Square Caret Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSquareCaretUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsSquareUpRight',
        title: __('Square Up Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsSquareUpRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsTurnDown',
        title: __('Turn Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsTurnDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsTurnUp',
        title: __('Turn Up', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsTurnUp,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsUpDown',
        title: __('Up Down', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsUpDown,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsUpDownLeftRight',
        title: __('Up Down Left Right', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsUpDownLeftRight,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsUpload',
        title: __('Upload', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsUpload,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsUpLong',
        title: __('Up Long', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsUpLong,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsUpRightAndDownLeftFromCenter',
        title: __('Up Right And Down Left From Center', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsUpRightAndDownLeftFromCenter,
        categories: ['arrows'],
    },
    {
        name: 'iconFontAwesomeArrowsUpRightFromSquare',
        title: __('Up Right From Square', 'icon-font-awesome'),
        icon: iconFontAwesomeArrowsUpRightFromSquare,
        categories: ['arrows'],
    },
];

// astronomy
import {
    iconFontAwesomeAstronomyBinoculars,
    iconFontAwesomeAstronomyGlobe,
    iconFontAwesomeAstronomyMeteor,
    iconFontAwesomeAstronomyMoon,
    iconFontAwesomeAstronomySatelliteDish,
    iconFontAwesomeAstronomySatellite,
    iconFontAwesomeAstronomyShuttleSpace,
    iconFontAwesomeAstronomyUserAstronaut,
} from './astronomy';

// astronomy
const astronomyIcons = [
    {
        name: 'iconFontAwesomeAstronomyBinoculars',
        title: __('Binoculars', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomyBinoculars,
        categories: ['astronomy'],
    },
    {
        name: 'iconFontAwesomeAstronomyGlobe',
        title: __('Globe', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomyGlobe,
        categories: ['astronomy'],
    },
    {
        name: 'iconFontAwesomeAstronomyMeteor',
        title: __('Meteor', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomyMeteor,
        categories: ['astronomy'],
    },
    {
        name: 'iconFontAwesomeAstronomyMoon',
        title: __('Moon', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomyMoon,
        categories: ['astronomy'],
    },
    {
        name: 'iconFontAwesomeAstronomySatelliteDish',
        title: __('Satellite Dish', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomySatelliteDish,
        categories: ['astronomy'],
    },
    {
        name: 'iconFontAwesomeAstronomySatellite',
        title: __('Satellite', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomySatellite,
        categories: ['astronomy'],
    },
    {
        name: 'iconFontAwesomeAstronomyShuttleSpace',
        title: __('Shuttle Space', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomyShuttleSpace,
        categories: ['astronomy'],
    },
    {
        name: 'iconFontAwesomeAstronomyUserAstronaut',
        title: __('User Astronaut', 'icon-font-awesome'),
        icon: iconFontAwesomeAstronomyUserAstronaut,
        categories: ['astronomy'],
    },
];

// automotive
import {
    iconFontAwesomeAutomotiveBus,
    iconFontAwesomeAutomotiveBusSimple,
    iconFontAwesomeAutomotiveCaravan,
    iconFontAwesomeAutomotiveCarBattery,
    iconFontAwesomeAutomotiveCarBurst,
    iconFontAwesomeAutomotiveCar,
    iconFontAwesomeAutomotiveCarOn,
    iconFontAwesomeAutomotiveCarRear,
    iconFontAwesomeAutomotiveCarSide,
    iconFontAwesomeAutomotiveCarTunnel,
    iconFontAwesomeAutomotiveChargingStation,
    iconFontAwesomeAutomotiveGasPump,
    iconFontAwesomeAutomotiveGaugeHigh,
    iconFontAwesomeAutomotiveGauge,
    iconFontAwesomeAutomotiveGaugeSimpleHigh,
    iconFontAwesomeAutomotiveGaugeSimple,
    iconFontAwesomeAutomotiveMotorcycle,
    iconFontAwesomeAutomotiveOilCan,
    iconFontAwesomeAutomotiveSprayCanSparkles,
    iconFontAwesomeAutomotiveTaxi,
    iconFontAwesomeAutomotiveTrailer,
    iconFontAwesomeAutomotiveTruckField,
    iconFontAwesomeAutomotiveTruckFieldUn,
    iconFontAwesomeAutomotiveTruck,
    iconFontAwesomeAutomotiveTruckMedical,
    iconFontAwesomeAutomotiveTruckMonster,
    iconFontAwesomeAutomotiveTruckPickup,
    iconFontAwesomeAutomotiveVanShuttle,
} from './automotive';

// automotive
const automotiveIcons = [
    {
        name: 'iconFontAwesomeAutomotiveBus',
        title: __('Bus', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveBus,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveBusSimple',
        title: __('Bus Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveBusSimple,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCaravan',
        title: __('Caravan', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCaravan,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCarBattery',
        title: __('Car Battery', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCarBattery,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCarBurst',
        title: __('Car Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCarBurst,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCar',
        title: __('Car', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCar,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCarOn',
        title: __('Car On', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCarOn,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCarRear',
        title: __('Car Rear', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCarRear,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCarSide',
        title: __('Car Side', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCarSide,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveCarTunnel',
        title: __('Car Tunnel', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveCarTunnel,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveChargingStation',
        title: __('Charging Station', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveChargingStation,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveGasPump',
        title: __('Gas Pump', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveGasPump,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveGaugeHigh',
        title: __('Gauge High', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveGaugeHigh,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveGauge',
        title: __('Gauge', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveGauge,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveGaugeSimpleHigh',
        title: __('Gauge Simple High', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveGaugeSimpleHigh,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveGaugeSimple',
        title: __('Gauge Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveGaugeSimple,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveMotorcycle',
        title: __('Motorcycle', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveMotorcycle,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveOilCan',
        title: __('Oil Can', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveOilCan,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveSprayCanSparkles',
        title: __('Spray Can Sparkles', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveSprayCanSparkles,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTaxi',
        title: __('Taxi', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTaxi,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTrailer',
        title: __('Trailer', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTrailer,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTruckField',
        title: __('Truck Field', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTruckField,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTruckFieldUn',
        title: __('Truck Field Un', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTruckFieldUn,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTruck',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTruck,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTruckMedical',
        title: __('Truck Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTruckMedical,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTruckMonster',
        title: __('Truck Monster', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTruckMonster,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveTruckPickup',
        title: __('Truck Pickup', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveTruckPickup,
        categories: ['automotive'],
    },
    {
        name: 'iconFontAwesomeAutomotiveVanShuttle',
        title: __('Van Shuttle', 'icon-font-awesome'),
        icon: iconFontAwesomeAutomotiveVanShuttle,
        categories: ['automotive'],
    },
];

// buildings
import {
    iconFontAwesomeBuildingsArchway,
    iconFontAwesomeBuildingsArrowRightToCity,
    iconFontAwesomeBuildingsBuildingCircleArrowRight,
    iconFontAwesomeBuildingsBuildingCircleCheck,
    iconFontAwesomeBuildingsBuildingCircleExclamation,
    iconFontAwesomeBuildingsBuildingCircleXmark,
    iconFontAwesomeBuildingsBuildingColumns,
    iconFontAwesomeBuildingsBuildingFlag,
    iconFontAwesomeBuildingsBuilding,
    iconFontAwesomeBuildingsBuildingLock,
    iconFontAwesomeBuildingsBuildingNgo,
    iconFontAwesomeBuildingsBuildingShield,
    iconFontAwesomeBuildingsBuildingUn,
    iconFontAwesomeBuildingsBuildingUser,
    iconFontAwesomeBuildingsBuildingWheat,
    iconFontAwesomeBuildingsCampground,
    iconFontAwesomeBuildingsChurch,
    iconFontAwesomeBuildingsCity,
    iconFontAwesomeBuildingsDungeon,
    iconFontAwesomeBuildingsGopuram,
    iconFontAwesomeBuildingsHospital,
    iconFontAwesomeBuildingsHospitalUser,
    iconFontAwesomeBuildingsHotel,
    iconFontAwesomeBuildingsHouseChimneyCrack,
    iconFontAwesomeBuildingsHouseChimney,
    iconFontAwesomeBuildingsHouseChimneyMedical,
    iconFontAwesomeBuildingsHouseChimneyWindow,
    iconFontAwesomeBuildingsHouseCircleCheck,
    iconFontAwesomeBuildingsHouseCircleExclamation,
    iconFontAwesomeBuildingsHouseCircleXmark,
    iconFontAwesomeBuildingsHouseCrack,
    iconFontAwesomeBuildingsHouseFire,
    iconFontAwesomeBuildingsHouseFlag,
    iconFontAwesomeBuildingsHouse,
    iconFontAwesomeBuildingsHouseLock,
    iconFontAwesomeBuildingsHouseMedicalCircleCheck,
    iconFontAwesomeBuildingsHouseMedicalCircleExclamation,
    iconFontAwesomeBuildingsHouseMedicalCircleXmark,
    iconFontAwesomeBuildingsHouseMedicalFlag,
    iconFontAwesomeBuildingsHouseMedical,
    iconFontAwesomeBuildingsIgloo,
    iconFontAwesomeBuildingsIndustry,
    iconFontAwesomeBuildingsKaaba,
    iconFontAwesomeBuildingsLandmarkDome,
    iconFontAwesomeBuildingsLandmarkFlag,
    iconFontAwesomeBuildingsLandmark,
    iconFontAwesomeBuildingsMonument,
    iconFontAwesomeBuildingsMosque,
    iconFontAwesomeBuildingsMountainCity,
    iconFontAwesomeBuildingsOilWell,
    iconFontAwesomeBuildingsPlaceOfWorship,
    iconFontAwesomeBuildingsSchoolCircleCheck,
    iconFontAwesomeBuildingsSchoolCircleExclamation,
    iconFontAwesomeBuildingsSchoolCircleXmark,
    iconFontAwesomeBuildingsSchoolFlag,
    iconFontAwesomeBuildingsSchool,
    iconFontAwesomeBuildingsSchoolLock,
    iconFontAwesomeBuildingsShop,
    iconFontAwesomeBuildingsShopLock,
    iconFontAwesomeBuildingsStore,
    iconFontAwesomeBuildingsSynagogue,
    iconFontAwesomeBuildingsTentArrowDownToLine,
    iconFontAwesomeBuildingsTentArrowLeftRight,
    iconFontAwesomeBuildingsTentArrowsDown,
    iconFontAwesomeBuildingsTentArrowTurnLeft,
    iconFontAwesomeBuildingsTent,
    iconFontAwesomeBuildingsTents,
    iconFontAwesomeBuildingsToiletPortable,
    iconFontAwesomeBuildingsToiletsPortable,
    iconFontAwesomeBuildingsToriiGate,
    iconFontAwesomeBuildingsTowerObservation,
    iconFontAwesomeBuildingsTreeCity,
    iconFontAwesomeBuildingsVihara,
    iconFontAwesomeBuildingsWarehouse,
} from './buildings';

// buildings
const buildingsIcons = [
    {
        name: 'iconFontAwesomeBuildingsArchway',
        title: __('Archway', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsArchway,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsArrowRightToCity',
        title: __('Arrow Right To City', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsArrowRightToCity,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingCircleArrowRight',
        title: __('Building Circle Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingCircleArrowRight,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingCircleCheck',
        title: __('Building Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingCircleCheck,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingCircleExclamation',
        title: __('Building Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingCircleExclamation,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingCircleXmark',
        title: __('Building Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingCircleXmark,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingColumns',
        title: __('Building Columns', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingColumns,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingFlag',
        title: __('Building Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingFlag,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuilding',
        title: __('Building', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuilding,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingLock',
        title: __('Building Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingLock,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingNgo',
        title: __('Building Ngo', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingNgo,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingShield',
        title: __('Building Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingShield,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingUn',
        title: __('Building Un', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingUn,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingUser',
        title: __('Building User', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingUser,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsBuildingWheat',
        title: __('Building Wheat', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsBuildingWheat,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsCampground',
        title: __('Campground', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsCampground,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsChurch',
        title: __('Church', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsChurch,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsCity',
        title: __('City', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsCity,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsDungeon',
        title: __('Dungeon', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsDungeon,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsGopuram',
        title: __('Gopuram', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsGopuram,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHospital',
        title: __('Hospital', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHospital,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHospitalUser',
        title: __('Hospital User', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHospitalUser,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHotel',
        title: __('Hotel', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHotel,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseChimneyCrack',
        title: __('House Chimney Crack', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseChimneyCrack,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseChimney',
        title: __('House Chimney', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseChimney,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseChimneyMedical',
        title: __('House Chimney Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseChimneyMedical,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseChimneyWindow',
        title: __('House Chimney Window', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseChimneyWindow,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseCircleCheck',
        title: __('House Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseCircleCheck,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseCircleExclamation',
        title: __('House Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseCircleExclamation,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseCircleXmark',
        title: __('House Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseCircleXmark,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseCrack',
        title: __('House Crack', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseCrack,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseFire',
        title: __('House Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseFire,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseFlag',
        title: __('House Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseFlag,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouse',
        title: __('House', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouse,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseLock',
        title: __('House Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseLock,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseMedicalCircleCheck',
        title: __('House Medical Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseMedicalCircleCheck,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseMedicalCircleExclamation',
        title: __('House Medical Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseMedicalCircleExclamation,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseMedicalCircleXmark',
        title: __('House Medical Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseMedicalCircleXmark,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseMedicalFlag',
        title: __('House Medical Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseMedicalFlag,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsHouseMedical',
        title: __('House Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsHouseMedical,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsIgloo',
        title: __('Igloo', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsIgloo,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsIndustry',
        title: __('Industry', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsIndustry,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsKaaba',
        title: __('Kaaba', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsKaaba,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsLandmarkDome',
        title: __('Landmark Dome', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsLandmarkDome,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsLandmarkFlag',
        title: __('Landmark Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsLandmarkFlag,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsLandmark',
        title: __('Landmark', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsLandmark,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsMonument',
        title: __('Monument', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsMonument,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsMosque',
        title: __('Mosque', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsMosque,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsMountainCity',
        title: __('Mountain City', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsMountainCity,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsOilWell',
        title: __('Oil Well', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsOilWell,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsPlaceOfWorship',
        title: __('Place Of Worship', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsPlaceOfWorship,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsSchoolCircleCheck',
        title: __('School Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsSchoolCircleCheck,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsSchoolCircleExclamation',
        title: __('School Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsSchoolCircleExclamation,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsSchoolCircleXmark',
        title: __('School Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsSchoolCircleXmark,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsSchoolFlag',
        title: __('School Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsSchoolFlag,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsSchool',
        title: __('School', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsSchool,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsSchoolLock',
        title: __('School Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsSchoolLock,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsShop',
        title: __('Shop', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsShop,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsShopLock',
        title: __('Shop Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsShopLock,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsStore',
        title: __('Store', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsStore,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsSynagogue',
        title: __('Synagogue', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsSynagogue,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTentArrowDownToLine',
        title: __('Tent Arrow Down To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTentArrowDownToLine,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTentArrowLeftRight',
        title: __('Tent Arrow Left Right', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTentArrowLeftRight,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTentArrowsDown',
        title: __('Tent Arrows Down', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTentArrowsDown,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTentArrowTurnLeft',
        title: __('Tent Arrow Turn Left', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTentArrowTurnLeft,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTent',
        title: __('Tent', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTent,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTents',
        title: __('Tents', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTents,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsToiletPortable',
        title: __('Toilet Portable', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsToiletPortable,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsToiletsPortable',
        title: __('Toilets Portable', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsToiletsPortable,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsToriiGate',
        title: __('Torii Gate', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsToriiGate,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTowerObservation',
        title: __('Tower Observation', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTowerObservation,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsTreeCity',
        title: __('Tree City', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsTreeCity,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsVihara',
        title: __('Vihara', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsVihara,
        categories: ['buildings'],
    },
    {
        name: 'iconFontAwesomeBuildingsWarehouse',
        title: __('Warehouse', 'icon-font-awesome'),
        icon: iconFontAwesomeBuildingsWarehouse,
        categories: ['buildings'],
    },
];

// camping
import {
    iconFontAwesomeCampingBinoculars,
    iconFontAwesomeCampingBottleWater,
    iconFontAwesomeCampingBucket,
    iconFontAwesomeCampingCampground,
    iconFontAwesomeCampingCaravan,
    iconFontAwesomeCampingCompass,
    iconFontAwesomeCampingFaucetDrip,
    iconFontAwesomeCampingFaucet,
    iconFontAwesomeCampingFireBurner,
    iconFontAwesomeCampingFireFlameCurved,
    iconFontAwesomeCampingFire,
    iconFontAwesomeCampingFrog,
    iconFontAwesomeCampingKitMedical,
    iconFontAwesomeCampingMap,
    iconFontAwesomeCampingMapLocationDot,
    iconFontAwesomeCampingMapLocation,
    iconFontAwesomeCampingMattressPillow,
    iconFontAwesomeCampingMosquito,
    iconFontAwesomeCampingMosquitoNet,
    iconFontAwesomeCampingMountain,
    iconFontAwesomeCampingMountainSun,
    iconFontAwesomeCampingPeopleRoof,
    iconFontAwesomeCampingPersonHiking,
    iconFontAwesomeCampingPersonShelter,
    iconFontAwesomeCampingRoute,
    iconFontAwesomeCampingSignsPost,
    iconFontAwesomeCampingTarpDroplet,
    iconFontAwesomeCampingTarp,
    iconFontAwesomeCampingTentArrowDownToLine,
    iconFontAwesomeCampingTentArrowLeftRight,
    iconFontAwesomeCampingTentArrowsDown,
    iconFontAwesomeCampingTentArrowTurnLeft,
    iconFontAwesomeCampingTent,
    iconFontAwesomeCampingTents,
    iconFontAwesomeCampingToiletPaper,
    iconFontAwesomeCampingTrailer,
    iconFontAwesomeCampingTree,
} from './camping';

// camping
const campingIcons = [
    {
        name: 'iconFontAwesomeCampingBinoculars',
        title: __('Binoculars', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingBinoculars,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingBottleWater',
        title: __('Bottle Water', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingBottleWater,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingBucket',
        title: __('Bucket', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingBucket,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingCampground',
        title: __('Campground', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingCampground,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingCaravan',
        title: __('Caravan', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingCaravan,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingCompass',
        title: __('Compass', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingCompass,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingFaucetDrip',
        title: __('Faucet Drip', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingFaucetDrip,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingFaucet',
        title: __('Faucet', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingFaucet,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingFireBurner',
        title: __('Fire Burner', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingFireBurner,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingFireFlameCurved',
        title: __('Fire Flame Curved', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingFireFlameCurved,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingFire',
        title: __('Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingFire,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingFrog',
        title: __('Frog', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingFrog,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingKitMedical',
        title: __('Kit Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingKitMedical,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMap',
        title: __('Map', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMap,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMapLocationDot',
        title: __('Map Location Dot', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMapLocationDot,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMapLocation',
        title: __('Map Location', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMapLocation,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMattressPillow',
        title: __('Mattress Pillow', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMattressPillow,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMosquito',
        title: __('Mosquito', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMosquito,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMosquitoNet',
        title: __('Mosquito Net', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMosquitoNet,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMountain',
        title: __('Mountain', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMountain,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingMountainSun',
        title: __('Mountain Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingMountainSun,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingPeopleRoof',
        title: __('People Roof', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingPeopleRoof,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingPersonHiking',
        title: __('Person Hiking', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingPersonHiking,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingPersonShelter',
        title: __('Person Shelter', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingPersonShelter,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingRoute',
        title: __('Route', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingRoute,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingSignsPost',
        title: __('Signs Post', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingSignsPost,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTarpDroplet',
        title: __('Tarp Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTarpDroplet,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTarp',
        title: __('Tarp', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTarp,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTentArrowDownToLine',
        title: __('Tent Arrow Down To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTentArrowDownToLine,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTentArrowLeftRight',
        title: __('Tent Arrow Left Right', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTentArrowLeftRight,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTentArrowsDown',
        title: __('Tent Arrows Down', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTentArrowsDown,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTentArrowTurnLeft',
        title: __('Tent Arrow Turn Left', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTentArrowTurnLeft,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTent',
        title: __('Tent', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTent,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTents',
        title: __('Tents', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTents,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingToiletPaper',
        title: __('Toilet Paper', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingToiletPaper,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTrailer',
        title: __('Trailer', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTrailer,
        categories: ['camping'],
    },
    {
        name: 'iconFontAwesomeCampingTree',
        title: __('Tree', 'icon-font-awesome'),
        icon: iconFontAwesomeCampingTree,
        categories: ['camping'],
    },
];

// charity
import {
    iconFontAwesomeCharityCircleDollarToSlot,
    iconFontAwesomeCharityDollarSign,
    iconFontAwesomeCharityDove,
    iconFontAwesomeCharityGift,
    iconFontAwesomeCharityGlobe,
    iconFontAwesomeCharityHandHoldingDollar,
    iconFontAwesomeCharityHandHoldingDroplet,
    iconFontAwesomeCharityHandHoldingHand,
    iconFontAwesomeCharityHandHoldingHeart,
    iconFontAwesomeCharityHandshakeAngle,
    iconFontAwesomeCharityHandshake,
    iconFontAwesomeCharityHandshakeSimple,
    iconFontAwesomeCharityHandsHoldingChild,
    iconFontAwesomeCharityHandsHoldingCircle,
    iconFontAwesomeCharityHeart,
    iconFontAwesomeCharityLeaf,
    iconFontAwesomeCharityParachuteBox,
    iconFontAwesomeCharityPiggyBank,
    iconFontAwesomeCharityRibbon,
    iconFontAwesomeCharitySeedling,
} from './charity';

// charity
const charityIcons = [
    {
        name: 'iconFontAwesomeCharityCircleDollarToSlot',
        title: __('Circle Dollar To Slot', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityCircleDollarToSlot,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityDollarSign',
        title: __('Dollar Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityDollarSign,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityDove',
        title: __('Dove', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityDove,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityGift',
        title: __('Gift', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityGift,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityGlobe',
        title: __('Globe', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityGlobe,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandHoldingDollar',
        title: __('Hand Holding Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandHoldingDollar,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandHoldingDroplet',
        title: __('Hand Holding Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandHoldingDroplet,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandHoldingHand',
        title: __('Hand Holding Hand', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandHoldingHand,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandHoldingHeart',
        title: __('Hand Holding Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandHoldingHeart,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandshakeAngle',
        title: __('Handshake Angle', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandshakeAngle,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandshake',
        title: __('Handshake', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandshake,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandshakeSimple',
        title: __('Handshake Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandshakeSimple,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandsHoldingChild',
        title: __('Hands Holding Child', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandsHoldingChild,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHandsHoldingCircle',
        title: __('Hands Holding Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHandsHoldingCircle,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityHeart,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityLeaf',
        title: __('Leaf', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityLeaf,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityParachuteBox',
        title: __('Parachute Box', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityParachuteBox,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityPiggyBank',
        title: __('Piggy Bank', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityPiggyBank,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharityRibbon',
        title: __('Ribbon', 'icon-font-awesome'),
        icon: iconFontAwesomeCharityRibbon,
        categories: ['charity'],
    },
    {
        name: 'iconFontAwesomeCharitySeedling',
        title: __('Seedling', 'icon-font-awesome'),
        icon: iconFontAwesomeCharitySeedling,
        categories: ['charity'],
    },
];

// charts+diagrams
import {
    iconFontAwesomeChartsDiagramsBarsProgress,
    iconFontAwesomeChartsDiagramsChartArea,
    iconFontAwesomeChartsDiagramsChartBar,
    iconFontAwesomeChartsDiagramsChartColumn,
    iconFontAwesomeChartsDiagramsChartGantt,
    iconFontAwesomeChartsDiagramsChartLine,
    iconFontAwesomeChartsDiagramsChartPie,
    iconFontAwesomeChartsDiagramsChartSimple,
    iconFontAwesomeChartsDiagramsCircleHalfStroke,
    iconFontAwesomeChartsDiagramsDiagramNext,
    iconFontAwesomeChartsDiagramsDiagramPredecessor,
    iconFontAwesomeChartsDiagramsDiagramProject,
    iconFontAwesomeChartsDiagramsDiagramSuccessor,
    iconFontAwesomeChartsDiagramsSquarePollHorizontal,
    iconFontAwesomeChartsDiagramsSquarePollVertical,
} from './charts+diagrams';

// charts+diagrams
const chartsDiagramsIcons = [
    {
        name: 'iconFontAwesomeChartsDiagramsBarsProgress',
        title: __('Bars Progress', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsBarsProgress,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsChartArea',
        title: __('Chart Area', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsChartArea,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsChartBar',
        title: __('Chart Bar', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsChartBar,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsChartColumn',
        title: __('Chart Column', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsChartColumn,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsChartGantt',
        title: __('Chart Gantt', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsChartGantt,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsChartLine',
        title: __('Chart Line', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsChartLine,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsChartPie',
        title: __('Chart Pie', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsChartPie,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsChartSimple',
        title: __('Chart Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsChartSimple,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsCircleHalfStroke',
        title: __('Circle Half Stroke', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsCircleHalfStroke,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsDiagramNext',
        title: __('Diagram Next', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsDiagramNext,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsDiagramPredecessor',
        title: __('Diagram Predecessor', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsDiagramPredecessor,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsDiagramProject',
        title: __('Diagram Project', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsDiagramProject,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsDiagramSuccessor',
        title: __('Diagram Successor', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsDiagramSuccessor,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsSquarePollHorizontal',
        title: __('Square Poll Horizontal', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsSquarePollHorizontal,
        categories: ['charts+diagrams'],
    },
    {
        name: 'iconFontAwesomeChartsDiagramsSquarePollVertical',
        title: __('Square Poll Vertical', 'icon-font-awesome'),
        icon: iconFontAwesomeChartsDiagramsSquarePollVertical,
        categories: ['charts+diagrams'],
    },
];

// childhood
import {
    iconFontAwesomeChildhoodAppleWhole,
    iconFontAwesomeChildhoodBabyCarriage,
    iconFontAwesomeChildhoodBaby,
    iconFontAwesomeChildhoodBaseballBatBall,
    iconFontAwesomeChildhoodBath,
    iconFontAwesomeChildhoodBucket,
    iconFontAwesomeChildhoodCakeCandles,
    iconFontAwesomeChildhoodChildDress,
    iconFontAwesomeChildhoodChild,
    iconFontAwesomeChildhoodChildReaching,
    iconFontAwesomeChildhoodChildren,
    iconFontAwesomeChildhoodCookieBite,
    iconFontAwesomeChildhoodCookie,
    iconFontAwesomeChildhoodCubesStacked,
    iconFontAwesomeChildhoodGamepad,
    iconFontAwesomeChildhoodHandsHoldingChild,
    iconFontAwesomeChildhoodIceCream,
    iconFontAwesomeChildhoodMitten,
    iconFontAwesomeChildhoodPersonBiking,
    iconFontAwesomeChildhoodPersonBreastfeeding,
    iconFontAwesomeChildhoodPuzzlePiece,
    iconFontAwesomeChildhoodRobot,
    iconFontAwesomeChildhoodSchool,
    iconFontAwesomeChildhoodShapes,
    iconFontAwesomeChildhoodSnowman,
} from './childhood';

// childhood
const childhoodIcons = [
    {
        name: 'iconFontAwesomeChildhoodAppleWhole',
        title: __('Apple Whole', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodAppleWhole,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodBabyCarriage',
        title: __('Baby Carriage', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodBabyCarriage,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodBaby',
        title: __('Baby', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodBaby,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodBaseballBatBall',
        title: __('Baseball Bat Ball', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodBaseballBatBall,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodBath',
        title: __('Bath', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodBath,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodBucket',
        title: __('Bucket', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodBucket,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodCakeCandles',
        title: __('Cake Candles', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodCakeCandles,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodChildDress',
        title: __('Child Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodChildDress,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodChild',
        title: __('Child', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodChild,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodChildReaching',
        title: __('Child Reaching', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodChildReaching,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodChildren',
        title: __('Children', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodChildren,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodCookieBite',
        title: __('Cookie Bite', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodCookieBite,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodCookie',
        title: __('Cookie', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodCookie,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodCubesStacked',
        title: __('Cubes Stacked', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodCubesStacked,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodGamepad',
        title: __('Gamepad', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodGamepad,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodHandsHoldingChild',
        title: __('Hands Holding Child', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodHandsHoldingChild,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodIceCream',
        title: __('Ice Cream', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodIceCream,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodMitten',
        title: __('Mitten', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodMitten,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodPersonBiking',
        title: __('Person Biking', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodPersonBiking,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodPersonBreastfeeding',
        title: __('Person Breastfeeding', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodPersonBreastfeeding,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodPuzzlePiece',
        title: __('Puzzle Piece', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodPuzzlePiece,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodRobot',
        title: __('Robot', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodRobot,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodSchool',
        title: __('School', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodSchool,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodShapes',
        title: __('Shapes', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodShapes,
        categories: ['childhood'],
    },
    {
        name: 'iconFontAwesomeChildhoodSnowman',
        title: __('Snowman', 'icon-font-awesome'),
        icon: iconFontAwesomeChildhoodSnowman,
        categories: ['childhood'],
    },
];

// clothing+fashion
import {
    iconFontAwesomeClothingFashionGlasses,
    iconFontAwesomeClothingFashionGraduationCap,
    iconFontAwesomeClothingFashionHatCowboy,
    iconFontAwesomeClothingFashionHatCowboySide,
    iconFontAwesomeClothingFashionHatWizard,
    iconFontAwesomeClothingFashionMitten,
    iconFontAwesomeClothingFashionShirt,
    iconFontAwesomeClothingFashionShoePrints,
    iconFontAwesomeClothingFashionSocks,
    iconFontAwesomeClothingFashionUserTie,
    iconFontAwesomeClothingFashionVest,
    iconFontAwesomeClothingFashionVestPatches,
} from './clothing+fashion';

// clothing+fashion
const clothingFashionIcons = [
    {
        name: 'iconFontAwesomeClothingFashionGlasses',
        title: __('Glasses', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionGlasses,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionGraduationCap',
        title: __('Graduation Cap', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionGraduationCap,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionHatCowboy',
        title: __('Hat Cowboy', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionHatCowboy,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionHatCowboySide',
        title: __('Hat Cowboy Side', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionHatCowboySide,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionHatWizard',
        title: __('Hat Wizard', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionHatWizard,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionMitten',
        title: __('Mitten', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionMitten,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionShirt',
        title: __('Shirt', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionShirt,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionShoePrints',
        title: __('Shoe Prints', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionShoePrints,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionSocks',
        title: __('Socks', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionSocks,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionUserTie',
        title: __('User Tie', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionUserTie,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionVest',
        title: __('Vest', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionVest,
        categories: ['clothing+fashion'],
    },
    {
        name: 'iconFontAwesomeClothingFashionVestPatches',
        title: __('Vest Patches', 'icon-font-awesome'),
        icon: iconFontAwesomeClothingFashionVestPatches,
        categories: ['clothing+fashion'],
    },
];

// coding
import {
    iconFontAwesomeCodingBarcode,
    iconFontAwesomeCodingBars,
    iconFontAwesomeCodingBarsStaggered,
    iconFontAwesomeCodingBath,
    iconFontAwesomeCodingBoxArchive,
    iconFontAwesomeCodingBug,
    iconFontAwesomeCodingBugSlash,
    iconFontAwesomeCodingCircleNodes,
    iconFontAwesomeCodingCodeBranch,
    iconFontAwesomeCodingCodeCommit,
    iconFontAwesomeCodingCodeCompare,
    iconFontAwesomeCodingCodeFork,
    iconFontAwesomeCodingCode,
    iconFontAwesomeCodingCodeMerge,
    iconFontAwesomeCodingCodePullRequest,
    iconFontAwesomeCodingCube,
    iconFontAwesomeCodingCubes,
    iconFontAwesomeCodingDiagramProject,
    iconFontAwesomeCodingFileCode,
    iconFontAwesomeCodingFile,
    iconFontAwesomeCodingFileLines,
    iconFontAwesomeCodingFilter,
    iconFontAwesomeCodingFireExtinguisher,
    iconFontAwesomeCodingFolder,
    iconFontAwesomeCodingFolderOpen,
    iconFontAwesomeCodingFontAwesome,
    iconFontAwesomeCodingGear,
    iconFontAwesomeCodingGears,
    iconFontAwesomeCodingKeyboard,
    iconFontAwesomeCodingLaptopCode,
    iconFontAwesomeCodingMicrochip,
    iconFontAwesomeCodingMugSaucer,
    iconFontAwesomeCodingNetworkWired,
    iconFontAwesomeCodingNotdef,
    iconFontAwesomeCodingQrcode,
    iconFontAwesomeCodingRectangleXmark,
    iconFontAwesomeCodingShieldHalved,
    iconFontAwesomeCodingShield,
    iconFontAwesomeCodingSitemap,
    iconFontAwesomeCodingTerminal,
    iconFontAwesomeCodingUserSecret,
    iconFontAwesomeCodingWebAwesome,
    iconFontAwesomeCodingWindowMaximize,
    iconFontAwesomeCodingWindowMinimize,
    iconFontAwesomeCodingWindowRestore,
} from './coding';

// coding
const codingIcons = [
    {
        name: 'iconFontAwesomeCodingBarcode',
        title: __('Barcode', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingBarcode,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingBars',
        title: __('Bars', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingBars,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingBarsStaggered',
        title: __('Bars Staggered', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingBarsStaggered,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingBath',
        title: __('Bath', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingBath,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingBoxArchive',
        title: __('Box Archive', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingBoxArchive,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingBug',
        title: __('Bug', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingBug,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingBugSlash',
        title: __('Bug Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingBugSlash,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCircleNodes',
        title: __('Circle Nodes', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCircleNodes,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCodeBranch',
        title: __('Code Branch', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCodeBranch,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCodeCommit',
        title: __('Code Commit', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCodeCommit,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCodeCompare',
        title: __('Code Compare', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCodeCompare,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCodeFork',
        title: __('Code Fork', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCodeFork,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCode',
        title: __('Code', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCode,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCodeMerge',
        title: __('Code Merge', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCodeMerge,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCodePullRequest',
        title: __('Code Pull Request', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCodePullRequest,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCube',
        title: __('Cube', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCube,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingCubes',
        title: __('Cubes', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingCubes,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingDiagramProject',
        title: __('Diagram Project', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingDiagramProject,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFileCode',
        title: __('File Code', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFileCode,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFile',
        title: __('File', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFile,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFileLines',
        title: __('File Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFileLines,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFilter',
        title: __('Filter', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFilter,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFireExtinguisher',
        title: __('Fire Extinguisher', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFireExtinguisher,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFolder',
        title: __('Folder', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFolder,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFolderOpen',
        title: __('Folder Open', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFolderOpen,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingFontAwesome',
        title: __('Font Awesome', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingFontAwesome,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingGear',
        title: __('Gear', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingGear,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingGears',
        title: __('Gears', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingGears,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingKeyboard',
        title: __('Keyboard', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingKeyboard,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingLaptopCode',
        title: __('Laptop Code', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingLaptopCode,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingMicrochip',
        title: __('Microchip', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingMicrochip,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingMugSaucer',
        title: __('Mug Saucer', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingMugSaucer,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingNetworkWired',
        title: __('Network Wired', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingNetworkWired,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingNotdef',
        title: __('Notdef', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingNotdef,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingQrcode',
        title: __('Qrcode', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingQrcode,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingRectangleXmark',
        title: __('Rectangle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingRectangleXmark,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingShieldHalved',
        title: __('Shield Halved', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingShieldHalved,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingShield',
        title: __('Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingShield,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingSitemap',
        title: __('Sitemap', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingSitemap,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingTerminal',
        title: __('Terminal', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingTerminal,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingUserSecret',
        title: __('User Secret', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingUserSecret,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingWebAwesome',
        title: __('Web Awesome', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingWebAwesome,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingWindowMaximize',
        title: __('Window Maximize', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingWindowMaximize,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingWindowMinimize',
        title: __('Window Minimize', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingWindowMinimize,
        categories: ['coding'],
    },
    {
        name: 'iconFontAwesomeCodingWindowRestore',
        title: __('Window Restore', 'icon-font-awesome'),
        icon: iconFontAwesomeCodingWindowRestore,
        categories: ['coding'],
    },
];

// communication
import {
    iconFontAwesomeCommunicationAddressBook,
    iconFontAwesomeCommunicationAddressCard,
    iconFontAwesomeCommunicationAt,
    iconFontAwesomeCommunicationBlenderPhone,
    iconFontAwesomeCommunicationBluetoothB,
    iconFontAwesomeCommunicationBullhorn,
    iconFontAwesomeCommunicationCommentDots,
    iconFontAwesomeCommunicationComment,
    iconFontAwesomeCommunicationCommentMedical,
    iconFontAwesomeCommunicationComments,
    iconFontAwesomeCommunicationCommentSlash,
    iconFontAwesomeCommunicationCommentSms,
    iconFontAwesomeCommunicationEarListen,
    iconFontAwesomeCommunicationEnvelopeCircleCheck,
    iconFontAwesomeCommunicationEnvelope,
    iconFontAwesomeCommunicationEnvelopeOpen,
    iconFontAwesomeCommunicationFaceFrown,
    iconFontAwesomeCommunicationFaceMeh,
    iconFontAwesomeCommunicationFaceSmile,
    iconFontAwesomeCommunicationFax,
    iconFontAwesomeCommunicationHandsAslInterpreting,
    iconFontAwesomeCommunicationIcons,
    iconFontAwesomeCommunicationInbox,
    iconFontAwesomeCommunicationLanguage,
    iconFontAwesomeCommunicationMessage,
    iconFontAwesomeCommunicationMicrophone,
    iconFontAwesomeCommunicationMicrophoneLines,
    iconFontAwesomeCommunicationMicrophoneLinesSlash,
    iconFontAwesomeCommunicationMicrophoneSlash,
    iconFontAwesomeCommunicationMobileButton,
    iconFontAwesomeCommunicationMobile,
    iconFontAwesomeCommunicationMobileRetro,
    iconFontAwesomeCommunicationMobileScreenButton,
    iconFontAwesomeCommunicationMobileScreen,
    iconFontAwesomeCommunicationPaperPlane,
    iconFontAwesomeCommunicationPhoneFlip,
    iconFontAwesomeCommunicationPhone,
    iconFontAwesomeCommunicationPhoneSlash,
    iconFontAwesomeCommunicationPhoneVolume,
    iconFontAwesomeCommunicationPoo,
    iconFontAwesomeCommunicationQuoteLeft,
    iconFontAwesomeCommunicationQuoteRight,
    iconFontAwesomeCommunicationSquareEnvelope,
    iconFontAwesomeCommunicationSquarePhoneFlip,
    iconFontAwesomeCommunicationSquarePhone,
    iconFontAwesomeCommunicationSquareRss,
    iconFontAwesomeCommunicationTowerCell,
    iconFontAwesomeCommunicationTty,
    iconFontAwesomeCommunicationVideo,
    iconFontAwesomeCommunicationVideoSlash,
    iconFontAwesomeCommunicationVoicemail,
    iconFontAwesomeCommunicationWalkieTalkie,
} from './communication';

// communication
const communicationIcons = [
    {
        name: 'iconFontAwesomeCommunicationAddressBook',
        title: __('Address Book', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationAddressBook,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationAddressCard',
        title: __('Address Card', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationAddressCard,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationAt',
        title: __('At', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationAt,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationBlenderPhone',
        title: __('Blender Phone', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationBlenderPhone,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationBluetoothB',
        title: __('Bluetooth B', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationBluetoothB,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationBullhorn',
        title: __('Bullhorn', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationBullhorn,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationCommentDots',
        title: __('Comment Dots', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationCommentDots,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationComment',
        title: __('Comment', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationComment,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationCommentMedical',
        title: __('Comment Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationCommentMedical,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationComments',
        title: __('Comments', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationComments,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationCommentSlash',
        title: __('Comment Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationCommentSlash,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationCommentSms',
        title: __('Comment Sms', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationCommentSms,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationEarListen',
        title: __('Ear Listen', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationEarListen,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationEnvelopeCircleCheck',
        title: __('Envelope Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationEnvelopeCircleCheck,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationEnvelope',
        title: __('Envelope', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationEnvelope,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationEnvelopeOpen',
        title: __('Envelope Open', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationEnvelopeOpen,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationFaceFrown',
        title: __('Face Frown', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationFaceFrown,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationFaceMeh',
        title: __('Face Meh', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationFaceMeh,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationFaceSmile',
        title: __('Face Smile', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationFaceSmile,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationFax',
        title: __('Fax', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationFax,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationHandsAslInterpreting',
        title: __('Hands Asl Interpreting', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationHandsAslInterpreting,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationIcons',
        title: __('Icons', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationIcons,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationInbox',
        title: __('Inbox', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationInbox,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationLanguage',
        title: __('Language', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationLanguage,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMessage',
        title: __('Message', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMessage,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMicrophone',
        title: __('Microphone', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMicrophone,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMicrophoneLines',
        title: __('Microphone Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMicrophoneLines,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMicrophoneLinesSlash',
        title: __('Microphone Lines Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMicrophoneLinesSlash,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMicrophoneSlash',
        title: __('Microphone Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMicrophoneSlash,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMobileButton',
        title: __('Mobile Button', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMobileButton,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMobile',
        title: __('Mobile', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMobile,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMobileRetro',
        title: __('Mobile Retro', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMobileRetro,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMobileScreenButton',
        title: __('Mobile Screen Button', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMobileScreenButton,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationMobileScreen',
        title: __('Mobile Screen', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationMobileScreen,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationPaperPlane',
        title: __('Paper Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationPaperPlane,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationPhoneFlip',
        title: __('Phone Flip', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationPhoneFlip,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationPhone',
        title: __('Phone', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationPhone,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationPhoneSlash',
        title: __('Phone Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationPhoneSlash,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationPhoneVolume',
        title: __('Phone Volume', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationPhoneVolume,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationPoo',
        title: __('Poo', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationPoo,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationQuoteLeft',
        title: __('Quote Left', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationQuoteLeft,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationQuoteRight',
        title: __('Quote Right', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationQuoteRight,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationSquareEnvelope',
        title: __('Square Envelope', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationSquareEnvelope,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationSquarePhoneFlip',
        title: __('Square Phone Flip', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationSquarePhoneFlip,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationSquarePhone',
        title: __('Square Phone', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationSquarePhone,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationSquareRss',
        title: __('Square Rss', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationSquareRss,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationTowerCell',
        title: __('Tower Cell', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationTowerCell,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationTty',
        title: __('Tty', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationTty,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationVideo',
        title: __('Video', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationVideo,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationVideoSlash',
        title: __('Video Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationVideoSlash,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationVoicemail',
        title: __('Voicemail', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationVoicemail,
        categories: ['communication'],
    },
    {
        name: 'iconFontAwesomeCommunicationWalkieTalkie',
        title: __('Walkie Talkie', 'icon-font-awesome'),
        icon: iconFontAwesomeCommunicationWalkieTalkie,
        categories: ['communication'],
    },
];

// connectivity
import {
    iconFontAwesomeConnectivityBluetooth,
    iconFontAwesomeConnectivityCircleNodes,
    iconFontAwesomeConnectivityCloudArrowDown,
    iconFontAwesomeConnectivityCloudArrowUp,
    iconFontAwesomeConnectivityCloud,
    iconFontAwesomeConnectivityEthernet,
    iconFontAwesomeConnectivityGlobe,
    iconFontAwesomeConnectivityHouseSignal,
    iconFontAwesomeConnectivityRss,
    iconFontAwesomeConnectivitySatelliteDish,
    iconFontAwesomeConnectivitySignal,
    iconFontAwesomeConnectivityTowerBroadcast,
    iconFontAwesomeConnectivityTowerCell,
    iconFontAwesomeConnectivityWifi,
} from './connectivity';

// connectivity
const connectivityIcons = [
    {
        name: 'iconFontAwesomeConnectivityBluetooth',
        title: __('Bluetooth', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityBluetooth,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityCircleNodes',
        title: __('Circle Nodes', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityCircleNodes,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityCloudArrowDown',
        title: __('Cloud Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityCloudArrowDown,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityCloudArrowUp',
        title: __('Cloud Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityCloudArrowUp,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityCloud',
        title: __('Cloud', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityCloud,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityEthernet',
        title: __('Ethernet', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityEthernet,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityGlobe',
        title: __('Globe', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityGlobe,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityHouseSignal',
        title: __('House Signal', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityHouseSignal,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityRss',
        title: __('Rss', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityRss,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivitySatelliteDish',
        title: __('Satellite Dish', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivitySatelliteDish,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivitySignal',
        title: __('Signal', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivitySignal,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityTowerBroadcast',
        title: __('Tower Broadcast', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityTowerBroadcast,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityTowerCell',
        title: __('Tower Cell', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityTowerCell,
        categories: ['connectivity'],
    },
    {
        name: 'iconFontAwesomeConnectivityWifi',
        title: __('Wifi', 'icon-font-awesome'),
        icon: iconFontAwesomeConnectivityWifi,
        categories: ['connectivity'],
    },
];

// construction
import {
    iconFontAwesomeConstructionArrowUpFromGroundWater,
    iconFontAwesomeConstructionBoreHole,
    iconFontAwesomeConstructionBrush,
    iconFontAwesomeConstructionBucket,
    iconFontAwesomeConstructionCompassDrafting,
    iconFontAwesomeConstructionDumpsterFire,
    iconFontAwesomeConstructionDumpster,
    iconFontAwesomeConstructionHammer,
    iconFontAwesomeConstructionHelmetSafety,
    iconFontAwesomeConstructionMound,
    iconFontAwesomeConstructionPaintRoller,
    iconFontAwesomeConstructionPencil,
    iconFontAwesomeConstructionPenRuler,
    iconFontAwesomeConstructionPersonDigging,
    iconFontAwesomeConstructionRulerCombined,
    iconFontAwesomeConstructionRulerHorizontal,
    iconFontAwesomeConstructionRuler,
    iconFontAwesomeConstructionRulerVertical,
    iconFontAwesomeConstructionScrewdriver,
    iconFontAwesomeConstructionScrewdriverWrench,
    iconFontAwesomeConstructionSheetPlastic,
    iconFontAwesomeConstructionTarpDroplet,
    iconFontAwesomeConstructionTarp,
    iconFontAwesomeConstructionToiletPortable,
    iconFontAwesomeConstructionToiletsPortable,
    iconFontAwesomeConstructionToolbox,
    iconFontAwesomeConstructionTrowelBricks,
    iconFontAwesomeConstructionTrowel,
    iconFontAwesomeConstructionTruckPickup,
    iconFontAwesomeConstructionWrench,
} from './construction';

// construction
const constructionIcons = [
    {
        name: 'iconFontAwesomeConstructionArrowUpFromGroundWater',
        title: __('Arrow Up From Ground Water', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionArrowUpFromGroundWater,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionBoreHole',
        title: __('Bore Hole', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionBoreHole,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionBrush',
        title: __('Brush', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionBrush,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionBucket',
        title: __('Bucket', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionBucket,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionCompassDrafting',
        title: __('Compass Drafting', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionCompassDrafting,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionDumpsterFire',
        title: __('Dumpster Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionDumpsterFire,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionDumpster',
        title: __('Dumpster', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionDumpster,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionHammer',
        title: __('Hammer', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionHammer,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionHelmetSafety',
        title: __('Helmet Safety', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionHelmetSafety,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionMound',
        title: __('Mound', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionMound,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionPaintRoller',
        title: __('Paint Roller', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionPaintRoller,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionPencil',
        title: __('Pencil', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionPencil,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionPenRuler',
        title: __('Pen Ruler', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionPenRuler,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionPersonDigging',
        title: __('Person Digging', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionPersonDigging,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionRulerCombined',
        title: __('Ruler Combined', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionRulerCombined,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionRulerHorizontal',
        title: __('Ruler Horizontal', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionRulerHorizontal,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionRuler',
        title: __('Ruler', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionRuler,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionRulerVertical',
        title: __('Ruler Vertical', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionRulerVertical,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionScrewdriver',
        title: __('Screwdriver', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionScrewdriver,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionScrewdriverWrench',
        title: __('Screwdriver Wrench', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionScrewdriverWrench,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionSheetPlastic',
        title: __('Sheet Plastic', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionSheetPlastic,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionTarpDroplet',
        title: __('Tarp Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionTarpDroplet,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionTarp',
        title: __('Tarp', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionTarp,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionToiletPortable',
        title: __('Toilet Portable', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionToiletPortable,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionToiletsPortable',
        title: __('Toilets Portable', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionToiletsPortable,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionToolbox',
        title: __('Toolbox', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionToolbox,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionTrowelBricks',
        title: __('Trowel Bricks', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionTrowelBricks,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionTrowel',
        title: __('Trowel', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionTrowel,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionTruckPickup',
        title: __('Truck Pickup', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionTruckPickup,
        categories: ['construction'],
    },
    {
        name: 'iconFontAwesomeConstructionWrench',
        title: __('Wrench', 'icon-font-awesome'),
        icon: iconFontAwesomeConstructionWrench,
        categories: ['construction'],
    },
];

// design
import {
    iconFontAwesomeDesignBezierCurve,
    iconFontAwesomeDesignBrush,
    iconFontAwesomeDesignCircleHalfStroke,
    iconFontAwesomeDesignCircleNodes,
    iconFontAwesomeDesignClone,
    iconFontAwesomeDesignCompassDrafting,
    iconFontAwesomeDesignCopy,
    iconFontAwesomeDesignCrop,
    iconFontAwesomeDesignCropSimple,
    iconFontAwesomeDesignCrosshairs,
    iconFontAwesomeDesignCube,
    iconFontAwesomeDesignCubes,
    iconFontAwesomeDesignDrawPolygon,
    iconFontAwesomeDesignDroplet,
    iconFontAwesomeDesignDropletSlash,
    iconFontAwesomeDesignEraser,
    iconFontAwesomeDesignEyeDropper,
    iconFontAwesomeDesignEye,
    iconFontAwesomeDesignEyeSlash,
    iconFontAwesomeDesignFillDrip,
    iconFontAwesomeDesignFill,
    iconFontAwesomeDesignFloppyDisk,
    iconFontAwesomeDesignFontAwesome,
    iconFontAwesomeDesignHighlighter,
    iconFontAwesomeDesignIcons,
    iconFontAwesomeDesignLayerGroup,
    iconFontAwesomeDesignLinesLeaning,
    iconFontAwesomeDesignMarker,
    iconFontAwesomeDesignObjectGroup,
    iconFontAwesomeDesignObjectUngroup,
    iconFontAwesomeDesignPaintbrush,
    iconFontAwesomeDesignPaintRoller,
    iconFontAwesomeDesignPalette,
    iconFontAwesomeDesignPaste,
    iconFontAwesomeDesignPencil,
    iconFontAwesomeDesignPenClip,
    iconFontAwesomeDesignPenFancy,
    iconFontAwesomeDesignPen,
    iconFontAwesomeDesignPenNib,
    iconFontAwesomeDesignPenRuler,
    iconFontAwesomeDesignPenToSquare,
    iconFontAwesomeDesignRulerCombined,
    iconFontAwesomeDesignRulerHorizontal,
    iconFontAwesomeDesignRulerVertical,
    iconFontAwesomeDesignScissors,
    iconFontAwesomeDesignSplotch,
    iconFontAwesomeDesignSprayCan,
    iconFontAwesomeDesignStamp,
    iconFontAwesomeDesignStapler,
    iconFontAwesomeDesignSwatchbook,
    iconFontAwesomeDesignVectorSquare,
    iconFontAwesomeDesignWandMagic,
    iconFontAwesomeDesignWandMagicSparkles,
    iconFontAwesomeDesignWebAwesome,
} from './design';

// design
const designIcons = [
    {
        name: 'iconFontAwesomeDesignBezierCurve',
        title: __('Bezier Curve', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignBezierCurve,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignBrush',
        title: __('Brush', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignBrush,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCircleHalfStroke',
        title: __('Circle Half Stroke', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCircleHalfStroke,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCircleNodes',
        title: __('Circle Nodes', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCircleNodes,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignClone',
        title: __('Clone', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignClone,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCompassDrafting',
        title: __('Compass Drafting', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCompassDrafting,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCopy',
        title: __('Copy', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCopy,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCrop',
        title: __('Crop', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCrop,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCropSimple',
        title: __('Crop Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCropSimple,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCrosshairs',
        title: __('Crosshairs', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCrosshairs,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCube',
        title: __('Cube', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCube,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignCubes',
        title: __('Cubes', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignCubes,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignDrawPolygon',
        title: __('Draw Polygon', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignDrawPolygon,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignDroplet',
        title: __('Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignDroplet,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignDropletSlash',
        title: __('Droplet Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignDropletSlash,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignEraser',
        title: __('Eraser', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignEraser,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignEyeDropper',
        title: __('Eye Dropper', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignEyeDropper,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignEye',
        title: __('Eye', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignEye,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignEyeSlash',
        title: __('Eye Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignEyeSlash,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignFillDrip',
        title: __('Fill Drip', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignFillDrip,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignFill',
        title: __('Fill', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignFill,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignFloppyDisk',
        title: __('Floppy Disk', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignFloppyDisk,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignFontAwesome',
        title: __('Font Awesome', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignFontAwesome,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignHighlighter',
        title: __('Highlighter', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignHighlighter,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignIcons',
        title: __('Icons', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignIcons,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignLayerGroup',
        title: __('Layer Group', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignLayerGroup,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignLinesLeaning',
        title: __('Lines Leaning', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignLinesLeaning,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignMarker',
        title: __('Marker', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignMarker,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignObjectGroup',
        title: __('Object Group', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignObjectGroup,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignObjectUngroup',
        title: __('Object Ungroup', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignObjectUngroup,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPaintbrush',
        title: __('Paintbrush', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPaintbrush,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPaintRoller',
        title: __('Paint Roller', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPaintRoller,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPalette',
        title: __('Palette', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPalette,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPaste',
        title: __('Paste', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPaste,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPencil',
        title: __('Pencil', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPencil,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPenClip',
        title: __('Pen Clip', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPenClip,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPenFancy',
        title: __('Pen Fancy', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPenFancy,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPen',
        title: __('Pen', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPen,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPenNib',
        title: __('Pen Nib', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPenNib,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPenRuler',
        title: __('Pen Ruler', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPenRuler,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignPenToSquare',
        title: __('Pen To Square', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignPenToSquare,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignRulerCombined',
        title: __('Ruler Combined', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignRulerCombined,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignRulerHorizontal',
        title: __('Ruler Horizontal', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignRulerHorizontal,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignRulerVertical',
        title: __('Ruler Vertical', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignRulerVertical,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignScissors',
        title: __('Scissors', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignScissors,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignSplotch',
        title: __('Splotch', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignSplotch,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignSprayCan',
        title: __('Spray Can', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignSprayCan,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignStamp',
        title: __('Stamp', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignStamp,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignStapler',
        title: __('Stapler', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignStapler,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignSwatchbook',
        title: __('Swatchbook', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignSwatchbook,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignVectorSquare',
        title: __('Vector Square', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignVectorSquare,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignWandMagic',
        title: __('Wand Magic', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignWandMagic,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignWandMagicSparkles',
        title: __('Wand Magic Sparkles', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignWandMagicSparkles,
        categories: ['design'],
    },
    {
        name: 'iconFontAwesomeDesignWebAwesome',
        title: __('Web Awesome', 'icon-font-awesome'),
        icon: iconFontAwesomeDesignWebAwesome,
        categories: ['design'],
    },
];

// devices+hardware
import {
    iconFontAwesomeDevicesHardwareBlenderPhone,
    iconFontAwesomeDevicesHardwareCamera,
    iconFontAwesomeDevicesHardwareCameraRetro,
    iconFontAwesomeDevicesHardwareCarBattery,
    iconFontAwesomeDevicesHardwareCompactDisc,
    iconFontAwesomeDevicesHardwareComputer,
    iconFontAwesomeDevicesHardwareComputerMouse,
    iconFontAwesomeDevicesHardwareDatabase,
    iconFontAwesomeDevicesHardwareDesktop,
    iconFontAwesomeDevicesHardwareDisplay,
    iconFontAwesomeDevicesHardwareDownload,
    iconFontAwesomeDevicesHardwareEthernet,
    iconFontAwesomeDevicesHardwareFax,
    iconFontAwesomeDevicesHardwareFloppyDisk,
    iconFontAwesomeDevicesHardwareGamepad,
    iconFontAwesomeDevicesHardwareHardDrive,
    iconFontAwesomeDevicesHardwareHeadphones,
    iconFontAwesomeDevicesHardwareHouseLaptop,
    iconFontAwesomeDevicesHardwareKeyboard,
    iconFontAwesomeDevicesHardwareLaptopFile,
    iconFontAwesomeDevicesHardwareLaptop,
    iconFontAwesomeDevicesHardwareMemory,
    iconFontAwesomeDevicesHardwareMicrochip,
    iconFontAwesomeDevicesHardwareMobileButton,
    iconFontAwesomeDevicesHardwareMobile,
    iconFontAwesomeDevicesHardwareMobileRetro,
    iconFontAwesomeDevicesHardwareMobileScreenButton,
    iconFontAwesomeDevicesHardwareMobileScreen,
    iconFontAwesomeDevicesHardwarePlug,
    iconFontAwesomeDevicesHardwarePowerOff,
    iconFontAwesomeDevicesHardwarePrint,
    iconFontAwesomeDevicesHardwareSatelliteDish,
    iconFontAwesomeDevicesHardwareSatellite,
    iconFontAwesomeDevicesHardwareSdCard,
    iconFontAwesomeDevicesHardwareServer,
    iconFontAwesomeDevicesHardwareSimCard,
    iconFontAwesomeDevicesHardwareTabletButton,
    iconFontAwesomeDevicesHardwareTablet,
    iconFontAwesomeDevicesHardwareTabletScreenButton,
    iconFontAwesomeDevicesHardwareTachographDigital,
    iconFontAwesomeDevicesHardwareTv,
    iconFontAwesomeDevicesHardwareUpload,
    iconFontAwesomeDevicesHardwareWalkieTalkie,
} from './devices+hardware';

// devices+hardware
const devicesHardwareIcons = [
    {
        name: 'iconFontAwesomeDevicesHardwareBlenderPhone',
        title: __('Blender Phone', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareBlenderPhone,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareCamera',
        title: __('Camera', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareCamera,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareCameraRetro',
        title: __('Camera Retro', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareCameraRetro,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareCarBattery',
        title: __('Car Battery', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareCarBattery,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareCompactDisc',
        title: __('Compact Disc', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareCompactDisc,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareComputer',
        title: __('Computer', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareComputer,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareComputerMouse',
        title: __('Computer Mouse', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareComputerMouse,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareDatabase',
        title: __('Database', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareDatabase,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareDesktop',
        title: __('Desktop', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareDesktop,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareDisplay',
        title: __('Display', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareDisplay,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareDownload',
        title: __('Download', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareDownload,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareEthernet',
        title: __('Ethernet', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareEthernet,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareFax',
        title: __('Fax', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareFax,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareFloppyDisk',
        title: __('Floppy Disk', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareFloppyDisk,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareGamepad',
        title: __('Gamepad', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareGamepad,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareHardDrive',
        title: __('Hard Drive', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareHardDrive,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareHeadphones',
        title: __('Headphones', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareHeadphones,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareHouseLaptop',
        title: __('House Laptop', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareHouseLaptop,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareKeyboard',
        title: __('Keyboard', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareKeyboard,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareLaptopFile',
        title: __('Laptop File', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareLaptopFile,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareLaptop',
        title: __('Laptop', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareLaptop,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareMemory',
        title: __('Memory', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareMemory,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareMicrochip',
        title: __('Microchip', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareMicrochip,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareMobileButton',
        title: __('Mobile Button', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareMobileButton,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareMobile',
        title: __('Mobile', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareMobile,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareMobileRetro',
        title: __('Mobile Retro', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareMobileRetro,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareMobileScreenButton',
        title: __('Mobile Screen Button', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareMobileScreenButton,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareMobileScreen',
        title: __('Mobile Screen', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareMobileScreen,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwarePlug',
        title: __('Plug', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwarePlug,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwarePowerOff',
        title: __('Power Off', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwarePowerOff,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwarePrint',
        title: __('Print', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwarePrint,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareSatelliteDish',
        title: __('Satellite Dish', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareSatelliteDish,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareSatellite',
        title: __('Satellite', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareSatellite,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareSdCard',
        title: __('Sd Card', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareSdCard,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareServer',
        title: __('Server', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareServer,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareSimCard',
        title: __('Sim Card', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareSimCard,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareTabletButton',
        title: __('Tablet Button', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareTabletButton,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareTablet',
        title: __('Tablet', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareTablet,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareTabletScreenButton',
        title: __('Tablet Screen Button', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareTabletScreenButton,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareTachographDigital',
        title: __('Tachograph Digital', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareTachographDigital,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareTv',
        title: __('Tv', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareTv,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareUpload',
        title: __('Upload', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareUpload,
        categories: ['devices+hardware'],
    },
    {
        name: 'iconFontAwesomeDevicesHardwareWalkieTalkie',
        title: __('Walkie Talkie', 'icon-font-awesome'),
        icon: iconFontAwesomeDevicesHardwareWalkieTalkie,
        categories: ['devices+hardware'],
    },
];

// disaster+crisis
import {
    iconFontAwesomeDisasterCrisisBiohazard,
    iconFontAwesomeDisasterCrisisBugs,
    iconFontAwesomeDisasterCrisisBurst,
    iconFontAwesomeDisasterCrisisChildCombatant,
    iconFontAwesomeDisasterCrisisCircleRadiation,
    iconFontAwesomeDisasterCrisisCloudBolt,
    iconFontAwesomeDisasterCrisisCloudShowersHeavy,
    iconFontAwesomeDisasterCrisisCloudShowersWater,
    iconFontAwesomeDisasterCrisisHelmetUn,
    iconFontAwesomeDisasterCrisisHillAvalanche,
    iconFontAwesomeDisasterCrisisHillRockslide,
    iconFontAwesomeDisasterCrisisHouseChimneyCrack,
    iconFontAwesomeDisasterCrisisHouseCrack,
    iconFontAwesomeDisasterCrisisHouseFire,
    iconFontAwesomeDisasterCrisisHouseFloodWaterCircleArrowRight,
    iconFontAwesomeDisasterCrisisHouseFloodWater,
    iconFontAwesomeDisasterCrisisHouseTsunami,
    iconFontAwesomeDisasterCrisisHurricane,
    iconFontAwesomeDisasterCrisisLocust,
    iconFontAwesomeDisasterCrisisMosquito,
    iconFontAwesomeDisasterCrisisPersonDrowning,
    iconFontAwesomeDisasterCrisisPersonRifle,
    iconFontAwesomeDisasterCrisisPersonWalkingArrowLoopLeft,
    iconFontAwesomeDisasterCrisisPersonWalkingArrowRight,
    iconFontAwesomeDisasterCrisisPersonWalkingDashedLineArrowRight,
    iconFontAwesomeDisasterCrisisPlantWilt,
    iconFontAwesomeDisasterCrisisRadiation,
    iconFontAwesomeDisasterCrisisSnowflake,
    iconFontAwesomeDisasterCrisisSunPlantWilt,
    iconFontAwesomeDisasterCrisisTemperatureArrowDown,
    iconFontAwesomeDisasterCrisisTemperatureArrowUp,
    iconFontAwesomeDisasterCrisisTornado,
    iconFontAwesomeDisasterCrisisVolcano,
    iconFontAwesomeDisasterCrisisWheatAwnCircleExclamation,
    iconFontAwesomeDisasterCrisisWind,
    iconFontAwesomeDisasterCrisisWorm,
    iconFontAwesomeDisasterCrisisXmarksLines,
} from './disaster+crisis';

// disaster+crisis
const disasterCrisisIcons = [
    {
        name: 'iconFontAwesomeDisasterCrisisBiohazard',
        title: __('Biohazard', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisBiohazard,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisBugs',
        title: __('Bugs', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisBugs,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisBurst',
        title: __('Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisBurst,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisChildCombatant',
        title: __('Child Combatant', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisChildCombatant,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisCircleRadiation',
        title: __('Circle Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisCircleRadiation,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisCloudBolt',
        title: __('Cloud Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisCloudBolt,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisCloudShowersHeavy',
        title: __('Cloud Showers Heavy', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisCloudShowersHeavy,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisCloudShowersWater',
        title: __('Cloud Showers Water', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisCloudShowersWater,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHelmetUn',
        title: __('Helmet Un', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHelmetUn,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHillAvalanche',
        title: __('Hill Avalanche', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHillAvalanche,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHillRockslide',
        title: __('Hill Rockslide', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHillRockslide,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHouseChimneyCrack',
        title: __('House Chimney Crack', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHouseChimneyCrack,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHouseCrack',
        title: __('House Crack', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHouseCrack,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHouseFire',
        title: __('House Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHouseFire,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHouseFloodWaterCircleArrowRight',
        title: __('House Flood Water Circle Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHouseFloodWaterCircleArrowRight,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHouseFloodWater',
        title: __('House Flood Water', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHouseFloodWater,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHouseTsunami',
        title: __('House Tsunami', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHouseTsunami,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisHurricane',
        title: __('Hurricane', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisHurricane,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisLocust',
        title: __('Locust', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisLocust,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisMosquito',
        title: __('Mosquito', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisMosquito,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisPersonDrowning',
        title: __('Person Drowning', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisPersonDrowning,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisPersonRifle',
        title: __('Person Rifle', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisPersonRifle,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisPersonWalkingArrowLoopLeft',
        title: __('Person Walking Arrow Loop Left', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisPersonWalkingArrowLoopLeft,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisPersonWalkingArrowRight',
        title: __('Person Walking Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisPersonWalkingArrowRight,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisPersonWalkingDashedLineArrowRight',
        title: __('Person Walking Dashed Line Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisPersonWalkingDashedLineArrowRight,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisPlantWilt',
        title: __('Plant Wilt', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisPlantWilt,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisRadiation',
        title: __('Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisRadiation,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisSnowflake',
        title: __('Snowflake', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisSnowflake,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisSunPlantWilt',
        title: __('Sun Plant Wilt', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisSunPlantWilt,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisTemperatureArrowDown',
        title: __('Temperature Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisTemperatureArrowDown,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisTemperatureArrowUp',
        title: __('Temperature Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisTemperatureArrowUp,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisTornado',
        title: __('Tornado', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisTornado,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisVolcano',
        title: __('Volcano', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisVolcano,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisWheatAwnCircleExclamation',
        title: __('Wheat Awn Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisWheatAwnCircleExclamation,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisWind',
        title: __('Wind', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisWind,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisWorm',
        title: __('Worm', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisWorm,
        categories: ['disaster+crisis'],
    },
    {
        name: 'iconFontAwesomeDisasterCrisisXmarksLines',
        title: __('Xmarks Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeDisasterCrisisXmarksLines,
        categories: ['disaster+crisis'],
    },
];

// editing
import {
    iconFontAwesomeEditingArrowsRotate,
    iconFontAwesomeEditingBandage,
    iconFontAwesomeEditingBars,
    iconFontAwesomeEditingBrush,
    iconFontAwesomeEditingChartSimple,
    iconFontAwesomeEditingCheckDouble,
    iconFontAwesomeEditingCheck,
    iconFontAwesomeEditingCircleCheck,
    iconFontAwesomeEditingCircleHalfStroke,
    iconFontAwesomeEditingCrop,
    iconFontAwesomeEditingCropSimple,
    iconFontAwesomeEditingCube,
    iconFontAwesomeEditingDeleteLeft,
    iconFontAwesomeEditingEllipsis,
    iconFontAwesomeEditingEllipsisVertical,
    iconFontAwesomeEditingEyeDropper,
    iconFontAwesomeEditingEyeSlash,
    iconFontAwesomeEditingGear,
    iconFontAwesomeEditingGrip,
    iconFontAwesomeEditingGripLines,
    iconFontAwesomeEditingGripLinesVertical,
    iconFontAwesomeEditingGripVertical,
    iconFontAwesomeEditingLink,
    iconFontAwesomeEditingLinkSlash,
    iconFontAwesomeEditingMinus,
    iconFontAwesomeEditingPaintbrush,
    iconFontAwesomeEditingPencil,
    iconFontAwesomeEditingPenClip,
    iconFontAwesomeEditingPenFancy,
    iconFontAwesomeEditingPen,
    iconFontAwesomeEditingPenNib,
    iconFontAwesomeEditingPenRuler,
    iconFontAwesomeEditingPenToSquare,
    iconFontAwesomeEditingPlus,
    iconFontAwesomeEditingRotate,
    iconFontAwesomeEditingScissors,
    iconFontAwesomeEditingSignature,
    iconFontAwesomeEditingSliders,
    iconFontAwesomeEditingSquareCheck,
    iconFontAwesomeEditingSquarePen,
    iconFontAwesomeEditingTrashArrowUp,
    iconFontAwesomeEditingTrashCanArrowUp,
    iconFontAwesomeEditingTrashCan,
    iconFontAwesomeEditingTrash,
    iconFontAwesomeEditingWandMagic,
    iconFontAwesomeEditingWandMagicSparkles,
    iconFontAwesomeEditingXmark,
} from './editing';

// editing
const editingIcons = [
    {
        name: 'iconFontAwesomeEditingArrowsRotate',
        title: __('Arrows Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingArrowsRotate,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingBandage',
        title: __('Bandage', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingBandage,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingBars',
        title: __('Bars', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingBars,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingBrush',
        title: __('Brush', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingBrush,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingChartSimple',
        title: __('Chart Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingChartSimple,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingCheckDouble',
        title: __('Check Double', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingCheckDouble,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingCheck',
        title: __('Check', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingCheck,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingCircleCheck',
        title: __('Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingCircleCheck,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingCircleHalfStroke',
        title: __('Circle Half Stroke', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingCircleHalfStroke,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingCrop',
        title: __('Crop', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingCrop,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingCropSimple',
        title: __('Crop Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingCropSimple,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingCube',
        title: __('Cube', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingCube,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingDeleteLeft',
        title: __('Delete Left', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingDeleteLeft,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingEllipsis',
        title: __('Ellipsis', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingEllipsis,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingEllipsisVertical',
        title: __('Ellipsis Vertical', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingEllipsisVertical,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingEyeDropper',
        title: __('Eye Dropper', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingEyeDropper,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingEyeSlash',
        title: __('Eye Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingEyeSlash,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingGear',
        title: __('Gear', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingGear,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingGrip',
        title: __('Grip', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingGrip,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingGripLines',
        title: __('Grip Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingGripLines,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingGripLinesVertical',
        title: __('Grip Lines Vertical', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingGripLinesVertical,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingGripVertical',
        title: __('Grip Vertical', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingGripVertical,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingLink',
        title: __('Link', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingLink,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingLinkSlash',
        title: __('Link Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingLinkSlash,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingMinus',
        title: __('Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingMinus,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPaintbrush',
        title: __('Paintbrush', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPaintbrush,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPencil',
        title: __('Pencil', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPencil,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPenClip',
        title: __('Pen Clip', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPenClip,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPenFancy',
        title: __('Pen Fancy', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPenFancy,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPen',
        title: __('Pen', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPen,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPenNib',
        title: __('Pen Nib', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPenNib,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPenRuler',
        title: __('Pen Ruler', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPenRuler,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPenToSquare',
        title: __('Pen To Square', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPenToSquare,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingPlus',
        title: __('Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingPlus,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingRotate',
        title: __('Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingRotate,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingScissors',
        title: __('Scissors', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingScissors,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingSignature',
        title: __('Signature', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingSignature,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingSliders',
        title: __('Sliders', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingSliders,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingSquareCheck',
        title: __('Square Check', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingSquareCheck,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingSquarePen',
        title: __('Square Pen', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingSquarePen,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingTrashArrowUp',
        title: __('Trash Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingTrashArrowUp,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingTrashCanArrowUp',
        title: __('Trash Can Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingTrashCanArrowUp,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingTrashCan',
        title: __('Trash Can', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingTrashCan,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingTrash',
        title: __('Trash', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingTrash,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingWandMagic',
        title: __('Wand Magic', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingWandMagic,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingWandMagicSparkles',
        title: __('Wand Magic Sparkles', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingWandMagicSparkles,
        categories: ['editing'],
    },
    {
        name: 'iconFontAwesomeEditingXmark',
        title: __('Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeEditingXmark,
        categories: ['editing'],
    },
];

// education
import {
    iconFontAwesomeEducationAppleWhole,
    iconFontAwesomeEducationAtom,
    iconFontAwesomeEducationAward,
    iconFontAwesomeEducationBell,
    iconFontAwesomeEducationBellSlash,
    iconFontAwesomeEducationBookOpen,
    iconFontAwesomeEducationBookOpenReader,
    iconFontAwesomeEducationChalkboard,
    iconFontAwesomeEducationChalkboardUser,
    iconFontAwesomeEducationGraduationCap,
    iconFontAwesomeEducationLaptopCode,
    iconFontAwesomeEducationLaptopFile,
    iconFontAwesomeEducationMasksTheater,
    iconFontAwesomeEducationMicroscope,
    iconFontAwesomeEducationMusic,
    iconFontAwesomeEducationPersonChalkboard,
    iconFontAwesomeEducationSchoolCircleCheck,
    iconFontAwesomeEducationSchoolCircleExclamation,
    iconFontAwesomeEducationSchoolCircleXmark,
    iconFontAwesomeEducationSchoolFlag,
    iconFontAwesomeEducationSchool,
    iconFontAwesomeEducationSchoolLock,
    iconFontAwesomeEducationShapes,
    iconFontAwesomeEducationUserGraduate,
} from './education';

// education
const educationIcons = [
    {
        name: 'iconFontAwesomeEducationAppleWhole',
        title: __('Apple Whole', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationAppleWhole,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationAtom',
        title: __('Atom', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationAtom,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationAward',
        title: __('Award', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationAward,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationBell',
        title: __('Bell', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationBell,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationBellSlash',
        title: __('Bell Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationBellSlash,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationBookOpen',
        title: __('Book Open', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationBookOpen,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationBookOpenReader',
        title: __('Book Open Reader', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationBookOpenReader,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationChalkboard',
        title: __('Chalkboard', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationChalkboard,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationChalkboardUser',
        title: __('Chalkboard User', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationChalkboardUser,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationGraduationCap',
        title: __('Graduation Cap', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationGraduationCap,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationLaptopCode',
        title: __('Laptop Code', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationLaptopCode,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationLaptopFile',
        title: __('Laptop File', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationLaptopFile,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationMasksTheater',
        title: __('Masks Theater', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationMasksTheater,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationMicroscope',
        title: __('Microscope', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationMicroscope,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationMusic',
        title: __('Music', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationMusic,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationPersonChalkboard',
        title: __('Person Chalkboard', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationPersonChalkboard,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationSchoolCircleCheck',
        title: __('School Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationSchoolCircleCheck,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationSchoolCircleExclamation',
        title: __('School Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationSchoolCircleExclamation,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationSchoolCircleXmark',
        title: __('School Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationSchoolCircleXmark,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationSchoolFlag',
        title: __('School Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationSchoolFlag,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationSchool',
        title: __('School', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationSchool,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationSchoolLock',
        title: __('School Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationSchoolLock,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationShapes',
        title: __('Shapes', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationShapes,
        categories: ['education'],
    },
    {
        name: 'iconFontAwesomeEducationUserGraduate',
        title: __('User Graduate', 'icon-font-awesome'),
        icon: iconFontAwesomeEducationUserGraduate,
        categories: ['education'],
    },
];

// emoji
import {
    iconFontAwesomeEmojiFaceAngry,
    iconFontAwesomeEmojiFaceDizzy,
    iconFontAwesomeEmojiFaceFlushed,
    iconFontAwesomeEmojiFaceFrown,
    iconFontAwesomeEmojiFaceFrownOpen,
    iconFontAwesomeEmojiFaceGrimace,
    iconFontAwesomeEmojiFaceGrinBeam,
    iconFontAwesomeEmojiFaceGrinBeamSweat,
    iconFontAwesomeEmojiFaceGrinHearts,
    iconFontAwesomeEmojiFaceGrin,
    iconFontAwesomeEmojiFaceGrinSquint,
    iconFontAwesomeEmojiFaceGrinSquintTears,
    iconFontAwesomeEmojiFaceGrinStars,
    iconFontAwesomeEmojiFaceGrinTears,
    iconFontAwesomeEmojiFaceGrinTongue,
    iconFontAwesomeEmojiFaceGrinTongueSquint,
    iconFontAwesomeEmojiFaceGrinTongueWink,
    iconFontAwesomeEmojiFaceGrinWide,
    iconFontAwesomeEmojiFaceGrinWink,
    iconFontAwesomeEmojiFaceKissBeam,
    iconFontAwesomeEmojiFaceKiss,
    iconFontAwesomeEmojiFaceKissWinkHeart,
    iconFontAwesomeEmojiFaceLaughBeam,
    iconFontAwesomeEmojiFaceLaugh,
    iconFontAwesomeEmojiFaceLaughSquint,
    iconFontAwesomeEmojiFaceLaughWink,
    iconFontAwesomeEmojiFaceMehBlank,
    iconFontAwesomeEmojiFaceMeh,
    iconFontAwesomeEmojiFaceRollingEyes,
    iconFontAwesomeEmojiFaceSadCry,
    iconFontAwesomeEmojiFaceSadTear,
    iconFontAwesomeEmojiFaceSmileBeam,
    iconFontAwesomeEmojiFaceSmile,
    iconFontAwesomeEmojiFaceSmileWink,
    iconFontAwesomeEmojiFaceSurprise,
    iconFontAwesomeEmojiFaceTired,
} from './emoji';

// emoji
const emojiIcons = [
    {
        name: 'iconFontAwesomeEmojiFaceAngry',
        title: __('Face Angry', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceAngry,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceDizzy',
        title: __('Face Dizzy', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceDizzy,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceFlushed',
        title: __('Face Flushed', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceFlushed,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceFrown',
        title: __('Face Frown', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceFrown,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceFrownOpen',
        title: __('Face Frown Open', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceFrownOpen,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrimace',
        title: __('Face Grimace', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrimace,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinBeam',
        title: __('Face Grin Beam', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinBeam,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinBeamSweat',
        title: __('Face Grin Beam Sweat', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinBeamSweat,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinHearts',
        title: __('Face Grin Hearts', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinHearts,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrin',
        title: __('Face Grin', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrin,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinSquint',
        title: __('Face Grin Squint', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinSquint,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinSquintTears',
        title: __('Face Grin Squint Tears', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinSquintTears,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinStars',
        title: __('Face Grin Stars', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinStars,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinTears',
        title: __('Face Grin Tears', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinTears,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinTongue',
        title: __('Face Grin Tongue', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinTongue,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinTongueSquint',
        title: __('Face Grin Tongue Squint', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinTongueSquint,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinTongueWink',
        title: __('Face Grin Tongue Wink', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinTongueWink,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinWide',
        title: __('Face Grin Wide', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinWide,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceGrinWink',
        title: __('Face Grin Wink', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceGrinWink,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceKissBeam',
        title: __('Face Kiss Beam', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceKissBeam,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceKiss',
        title: __('Face Kiss', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceKiss,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceKissWinkHeart',
        title: __('Face Kiss Wink Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceKissWinkHeart,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceLaughBeam',
        title: __('Face Laugh Beam', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceLaughBeam,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceLaugh',
        title: __('Face Laugh', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceLaugh,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceLaughSquint',
        title: __('Face Laugh Squint', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceLaughSquint,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceLaughWink',
        title: __('Face Laugh Wink', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceLaughWink,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceMehBlank',
        title: __('Face Meh Blank', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceMehBlank,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceMeh',
        title: __('Face Meh', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceMeh,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceRollingEyes',
        title: __('Face Rolling Eyes', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceRollingEyes,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceSadCry',
        title: __('Face Sad Cry', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceSadCry,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceSadTear',
        title: __('Face Sad Tear', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceSadTear,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceSmileBeam',
        title: __('Face Smile Beam', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceSmileBeam,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceSmile',
        title: __('Face Smile', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceSmile,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceSmileWink',
        title: __('Face Smile Wink', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceSmileWink,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceSurprise',
        title: __('Face Surprise', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceSurprise,
        categories: ['emoji'],
    },
    {
        name: 'iconFontAwesomeEmojiFaceTired',
        title: __('Face Tired', 'icon-font-awesome'),
        icon: iconFontAwesomeEmojiFaceTired,
        categories: ['emoji'],
    },
];

// energy
import {
    iconFontAwesomeEnergyArrowUpFromGroundWater,
    iconFontAwesomeEnergyAtom,
    iconFontAwesomeEnergyBatteryEmpty,
    iconFontAwesomeEnergyBatteryFull,
    iconFontAwesomeEnergyBatteryHalf,
    iconFontAwesomeEnergyBatteryQuarter,
    iconFontAwesomeEnergyBatteryThreeQuarters,
    iconFontAwesomeEnergyBolt,
    iconFontAwesomeEnergyCarBattery,
    iconFontAwesomeEnergyChargingStation,
    iconFontAwesomeEnergyCircleRadiation,
    iconFontAwesomeEnergyExplosion,
    iconFontAwesomeEnergyFan,
    iconFontAwesomeEnergyFireFlameCurved,
    iconFontAwesomeEnergyFireFlameSimple,
    iconFontAwesomeEnergyFire,
    iconFontAwesomeEnergyGasPump,
    iconFontAwesomeEnergyIndustry,
    iconFontAwesomeEnergyLeaf,
    iconFontAwesomeEnergyLightbulb,
    iconFontAwesomeEnergyOilWell,
    iconFontAwesomeEnergyPlugCircleBolt,
    iconFontAwesomeEnergyPlugCircleCheck,
    iconFontAwesomeEnergyPlugCircleExclamation,
    iconFontAwesomeEnergyPlugCircleMinus,
    iconFontAwesomeEnergyPlugCirclePlus,
    iconFontAwesomeEnergyPlugCircleXmark,
    iconFontAwesomeEnergyPlug,
    iconFontAwesomeEnergyPoop,
    iconFontAwesomeEnergyPowerOff,
    iconFontAwesomeEnergyRadiation,
    iconFontAwesomeEnergySeedling,
    iconFontAwesomeEnergySolarPanel,
    iconFontAwesomeEnergySun,
    iconFontAwesomeEnergyTowerBroadcast,
    iconFontAwesomeEnergyWater,
    iconFontAwesomeEnergyWind,
} from './energy';

// energy
const energyIcons = [
    {
        name: 'iconFontAwesomeEnergyArrowUpFromGroundWater',
        title: __('Arrow Up From Ground Water', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyArrowUpFromGroundWater,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyAtom',
        title: __('Atom', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyAtom,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyBatteryEmpty',
        title: __('Battery Empty', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyBatteryEmpty,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyBatteryFull',
        title: __('Battery Full', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyBatteryFull,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyBatteryHalf',
        title: __('Battery Half', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyBatteryHalf,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyBatteryQuarter',
        title: __('Battery Quarter', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyBatteryQuarter,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyBatteryThreeQuarters',
        title: __('Battery Three Quarters', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyBatteryThreeQuarters,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyBolt',
        title: __('Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyBolt,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyCarBattery',
        title: __('Car Battery', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyCarBattery,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyChargingStation',
        title: __('Charging Station', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyChargingStation,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyCircleRadiation',
        title: __('Circle Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyCircleRadiation,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyExplosion',
        title: __('Explosion', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyExplosion,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyFan',
        title: __('Fan', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyFan,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyFireFlameCurved',
        title: __('Fire Flame Curved', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyFireFlameCurved,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyFireFlameSimple',
        title: __('Fire Flame Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyFireFlameSimple,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyFire',
        title: __('Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyFire,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyGasPump',
        title: __('Gas Pump', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyGasPump,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyIndustry',
        title: __('Industry', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyIndustry,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyLeaf',
        title: __('Leaf', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyLeaf,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyLightbulb',
        title: __('Lightbulb', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyLightbulb,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyOilWell',
        title: __('Oil Well', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyOilWell,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPlugCircleBolt',
        title: __('Plug Circle Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPlugCircleBolt,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPlugCircleCheck',
        title: __('Plug Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPlugCircleCheck,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPlugCircleExclamation',
        title: __('Plug Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPlugCircleExclamation,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPlugCircleMinus',
        title: __('Plug Circle Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPlugCircleMinus,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPlugCirclePlus',
        title: __('Plug Circle Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPlugCirclePlus,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPlugCircleXmark',
        title: __('Plug Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPlugCircleXmark,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPlug',
        title: __('Plug', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPlug,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPoop',
        title: __('Poop', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPoop,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyPowerOff',
        title: __('Power Off', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyPowerOff,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyRadiation',
        title: __('Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyRadiation,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergySeedling',
        title: __('Seedling', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergySeedling,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergySolarPanel',
        title: __('Solar Panel', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergySolarPanel,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergySun',
        title: __('Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergySun,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyTowerBroadcast',
        title: __('Tower Broadcast', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyTowerBroadcast,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyWater',
        title: __('Water', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyWater,
        categories: ['energy'],
    },
    {
        name: 'iconFontAwesomeEnergyWind',
        title: __('Wind', 'icon-font-awesome'),
        icon: iconFontAwesomeEnergyWind,
        categories: ['energy'],
    },
];

// files
import {
    iconFontAwesomeFilesBoxArchive,
    iconFontAwesomeFilesClone,
    iconFontAwesomeFilesCopy,
    iconFontAwesomeFilesFileArrowDown,
    iconFontAwesomeFilesFileArrowUp,
    iconFontAwesomeFilesFileAudio,
    iconFontAwesomeFilesFileCircleCheck,
    iconFontAwesomeFilesFileCircleExclamation,
    iconFontAwesomeFilesFileCircleMinus,
    iconFontAwesomeFilesFileCirclePlus,
    iconFontAwesomeFilesFileCircleQuestion,
    iconFontAwesomeFilesFileCircleXmark,
    iconFontAwesomeFilesFileCode,
    iconFontAwesomeFilesFileCsv,
    iconFontAwesomeFilesFileExcel,
    iconFontAwesomeFilesFileExport,
    iconFontAwesomeFilesFileImage,
    iconFontAwesomeFilesFileImport,
    iconFontAwesomeFilesFile,
    iconFontAwesomeFilesFileLines,
    iconFontAwesomeFilesFilePdf,
    iconFontAwesomeFilesFilePen,
    iconFontAwesomeFilesFilePowerpoint,
    iconFontAwesomeFilesFileShield,
    iconFontAwesomeFilesFileVideo,
    iconFontAwesomeFilesFileWord,
    iconFontAwesomeFilesFileZipper,
    iconFontAwesomeFilesFloppyDisk,
    iconFontAwesomeFilesFolderClosed,
    iconFontAwesomeFilesFolder,
    iconFontAwesomeFilesFolderOpen,
    iconFontAwesomeFilesNoteSticky,
    iconFontAwesomeFilesPaste,
    iconFontAwesomeFilesPhotoFilm,
    iconFontAwesomeFilesScissors,
} from './files';

// files
const filesIcons = [
    {
        name: 'iconFontAwesomeFilesBoxArchive',
        title: __('Box Archive', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesBoxArchive,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesClone',
        title: __('Clone', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesClone,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesCopy',
        title: __('Copy', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesCopy,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileArrowDown',
        title: __('File Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileArrowDown,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileArrowUp',
        title: __('File Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileArrowUp,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileAudio',
        title: __('File Audio', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileAudio,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCircleCheck',
        title: __('File Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCircleCheck,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCircleExclamation',
        title: __('File Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCircleExclamation,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCircleMinus',
        title: __('File Circle Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCircleMinus,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCirclePlus',
        title: __('File Circle Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCirclePlus,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCircleQuestion',
        title: __('File Circle Question', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCircleQuestion,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCircleXmark',
        title: __('File Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCircleXmark,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCode',
        title: __('File Code', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCode,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileCsv',
        title: __('File Csv', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileCsv,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileExcel',
        title: __('File Excel', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileExcel,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileExport',
        title: __('File Export', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileExport,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileImage',
        title: __('File Image', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileImage,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileImport',
        title: __('File Import', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileImport,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFile',
        title: __('File', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFile,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileLines',
        title: __('File Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileLines,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFilePdf',
        title: __('File Pdf', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFilePdf,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFilePen',
        title: __('File Pen', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFilePen,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFilePowerpoint',
        title: __('File Powerpoint', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFilePowerpoint,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileShield',
        title: __('File Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileShield,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileVideo',
        title: __('File Video', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileVideo,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileWord',
        title: __('File Word', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileWord,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFileZipper',
        title: __('File Zipper', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFileZipper,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFloppyDisk',
        title: __('Floppy Disk', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFloppyDisk,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFolderClosed',
        title: __('Folder Closed', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFolderClosed,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFolder',
        title: __('Folder', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFolder,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesFolderOpen',
        title: __('Folder Open', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesFolderOpen,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesNoteSticky',
        title: __('Note Sticky', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesNoteSticky,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesPaste',
        title: __('Paste', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesPaste,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesPhotoFilm',
        title: __('Photo Film', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesPhotoFilm,
        categories: ['files'],
    },
    {
        name: 'iconFontAwesomeFilesScissors',
        title: __('Scissors', 'icon-font-awesome'),
        icon: iconFontAwesomeFilesScissors,
        categories: ['files'],
    },
];

// film+video
import {
    iconFontAwesomeFilmVideoAudioDescription,
    iconFontAwesomeFilmVideoCircle,
    iconFontAwesomeFilmVideoClapperboard,
    iconFontAwesomeFilmVideoClosedCaptioning,
    iconFontAwesomeFilmVideoCompactDisc,
    iconFontAwesomeFilmVideoFileAudio,
    iconFontAwesomeFilmVideoFileVideo,
    iconFontAwesomeFilmVideoFilm,
    iconFontAwesomeFilmVideoHeadphones,
    iconFontAwesomeFilmVideoMicrophone,
    iconFontAwesomeFilmVideoMicrophoneLines,
    iconFontAwesomeFilmVideoMicrophoneLinesSlash,
    iconFontAwesomeFilmVideoMicrophoneSlash,
    iconFontAwesomeFilmVideoPhotoFilm,
    iconFontAwesomeFilmVideoPodcast,
    iconFontAwesomeFilmVideoSquareRss,
    iconFontAwesomeFilmVideoTicket,
    iconFontAwesomeFilmVideoTowerBroadcast,
    iconFontAwesomeFilmVideoTowerCell,
    iconFontAwesomeFilmVideoTv,
    iconFontAwesomeFilmVideoVideo,
    iconFontAwesomeFilmVideoVideoSlash,
    iconFontAwesomeFilmVideoYoutube,
} from './film+video';

// film+video
const filmVideoIcons = [
    {
        name: 'iconFontAwesomeFilmVideoAudioDescription',
        title: __('Audio Description', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoAudioDescription,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoCircle',
        title: __('Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoCircle,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoClapperboard',
        title: __('Clapperboard', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoClapperboard,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoClosedCaptioning',
        title: __('Closed Captioning', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoClosedCaptioning,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoCompactDisc',
        title: __('Compact Disc', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoCompactDisc,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoFileAudio',
        title: __('File Audio', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoFileAudio,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoFileVideo',
        title: __('File Video', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoFileVideo,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoFilm',
        title: __('Film', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoFilm,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoHeadphones',
        title: __('Headphones', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoHeadphones,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoMicrophone',
        title: __('Microphone', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoMicrophone,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoMicrophoneLines',
        title: __('Microphone Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoMicrophoneLines,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoMicrophoneLinesSlash',
        title: __('Microphone Lines Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoMicrophoneLinesSlash,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoMicrophoneSlash',
        title: __('Microphone Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoMicrophoneSlash,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoPhotoFilm',
        title: __('Photo Film', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoPhotoFilm,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoPodcast',
        title: __('Podcast', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoPodcast,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoSquareRss',
        title: __('Square Rss', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoSquareRss,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoTicket',
        title: __('Ticket', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoTicket,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoTowerBroadcast',
        title: __('Tower Broadcast', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoTowerBroadcast,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoTowerCell',
        title: __('Tower Cell', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoTowerCell,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoTv',
        title: __('Tv', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoTv,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoVideo',
        title: __('Video', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoVideo,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoVideoSlash',
        title: __('Video Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoVideoSlash,
        categories: ['film+video'],
    },
    {
        name: 'iconFontAwesomeFilmVideoYoutube',
        title: __('Youtube', 'icon-font-awesome'),
        icon: iconFontAwesomeFilmVideoYoutube,
        categories: ['film+video'],
    },
];

// food+beverage
import {
    iconFontAwesomeFoodBeverageAppleWhole,
    iconFontAwesomeFoodBeverageBacon,
    iconFontAwesomeFoodBeverageBeerMugEmpty,
    iconFontAwesomeFoodBeverageBlender,
    iconFontAwesomeFoodBeverageBone,
    iconFontAwesomeFoodBeverageBottleDroplet,
    iconFontAwesomeFoodBeverageBottleWater,
    iconFontAwesomeFoodBeverageBowlFood,
    iconFontAwesomeFoodBeverageBowlRice,
    iconFontAwesomeFoodBeverageBreadSlice,
    iconFontAwesomeFoodBeverageBurger,
    iconFontAwesomeFoodBeverageCakeCandles,
    iconFontAwesomeFoodBeverageCandyCane,
    iconFontAwesomeFoodBeverageCarrot,
    iconFontAwesomeFoodBeverageChampagneGlasses,
    iconFontAwesomeFoodBeverageCheese,
    iconFontAwesomeFoodBeverageCloudMeatball,
    iconFontAwesomeFoodBeverageCookie,
    iconFontAwesomeFoodBeverageCubesStacked,
    iconFontAwesomeFoodBeverageDrumstickBite,
    iconFontAwesomeFoodBeverageEgg,
    iconFontAwesomeFoodBeverageFishFins,
    iconFontAwesomeFoodBeverageFish,
    iconFontAwesomeFoodBeverageFlask,
    iconFontAwesomeFoodBeverageGlassWaterDroplet,
    iconFontAwesomeFoodBeverageGlassWater,
    iconFontAwesomeFoodBeverageHotdog,
    iconFontAwesomeFoodBeverageIceCream,
    iconFontAwesomeFoodBeverageJar,
    iconFontAwesomeFoodBeverageJarWheat,
    iconFontAwesomeFoodBeverageLemon,
    iconFontAwesomeFoodBeverageMartiniGlassCitrus,
    iconFontAwesomeFoodBeverageMartiniGlassEmpty,
    iconFontAwesomeFoodBeverageMartiniGlass,
    iconFontAwesomeFoodBeverageMugHot,
    iconFontAwesomeFoodBeverageMugSaucer,
    iconFontAwesomeFoodBeveragePepperHot,
    iconFontAwesomeFoodBeveragePizzaSlice,
    iconFontAwesomeFoodBeveragePlateWheat,
    iconFontAwesomeFoodBeverageSeedling,
    iconFontAwesomeFoodBeverageShrimp,
    iconFontAwesomeFoodBeverageStroopwafel,
    iconFontAwesomeFoodBeverageWheatAwnCircleExclamation,
    iconFontAwesomeFoodBeverageWheatAwn,
    iconFontAwesomeFoodBeverageWhiskeyGlass,
    iconFontAwesomeFoodBeverageWineBottle,
    iconFontAwesomeFoodBeverageWineGlassEmpty,
    iconFontAwesomeFoodBeverageWineGlass,
} from './food+beverage';

// food+beverage
const foodBeverageIcons = [
    {
        name: 'iconFontAwesomeFoodBeverageAppleWhole',
        title: __('Apple Whole', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageAppleWhole,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBacon',
        title: __('Bacon', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBacon,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBeerMugEmpty',
        title: __('Beer Mug Empty', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBeerMugEmpty,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBlender',
        title: __('Blender', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBlender,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBone',
        title: __('Bone', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBone,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBottleDroplet',
        title: __('Bottle Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBottleDroplet,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBottleWater',
        title: __('Bottle Water', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBottleWater,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBowlFood',
        title: __('Bowl Food', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBowlFood,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBowlRice',
        title: __('Bowl Rice', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBowlRice,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBreadSlice',
        title: __('Bread Slice', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBreadSlice,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageBurger',
        title: __('Burger', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageBurger,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageCakeCandles',
        title: __('Cake Candles', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageCakeCandles,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageCandyCane',
        title: __('Candy Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageCandyCane,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageCarrot',
        title: __('Carrot', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageCarrot,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageChampagneGlasses',
        title: __('Champagne Glasses', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageChampagneGlasses,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageCheese',
        title: __('Cheese', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageCheese,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageCloudMeatball',
        title: __('Cloud Meatball', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageCloudMeatball,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageCookie',
        title: __('Cookie', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageCookie,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageCubesStacked',
        title: __('Cubes Stacked', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageCubesStacked,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageDrumstickBite',
        title: __('Drumstick Bite', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageDrumstickBite,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageEgg',
        title: __('Egg', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageEgg,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageFishFins',
        title: __('Fish Fins', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageFishFins,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageFish',
        title: __('Fish', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageFish,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageFlask',
        title: __('Flask', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageFlask,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageGlassWaterDroplet',
        title: __('Glass Water Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageGlassWaterDroplet,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageGlassWater',
        title: __('Glass Water', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageGlassWater,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageHotdog',
        title: __('Hotdog', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageHotdog,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageIceCream',
        title: __('Ice Cream', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageIceCream,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageJar',
        title: __('Jar', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageJar,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageJarWheat',
        title: __('Jar Wheat', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageJarWheat,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageLemon',
        title: __('Lemon', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageLemon,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageMartiniGlassCitrus',
        title: __('Martini Glass Citrus', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageMartiniGlassCitrus,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageMartiniGlassEmpty',
        title: __('Martini Glass Empty', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageMartiniGlassEmpty,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageMartiniGlass',
        title: __('Martini Glass', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageMartiniGlass,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageMugHot',
        title: __('Mug Hot', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageMugHot,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageMugSaucer',
        title: __('Mug Saucer', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageMugSaucer,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeveragePepperHot',
        title: __('Pepper Hot', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeveragePepperHot,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeveragePizzaSlice',
        title: __('Pizza Slice', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeveragePizzaSlice,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeveragePlateWheat',
        title: __('Plate Wheat', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeveragePlateWheat,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageSeedling',
        title: __('Seedling', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageSeedling,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageShrimp',
        title: __('Shrimp', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageShrimp,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageStroopwafel',
        title: __('Stroopwafel', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageStroopwafel,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageWheatAwnCircleExclamation',
        title: __('Wheat Awn Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageWheatAwnCircleExclamation,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageWheatAwn',
        title: __('Wheat Awn', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageWheatAwn,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageWhiskeyGlass',
        title: __('Whiskey Glass', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageWhiskeyGlass,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageWineBottle',
        title: __('Wine Bottle', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageWineBottle,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageWineGlassEmpty',
        title: __('Wine Glass Empty', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageWineGlassEmpty,
        categories: ['food+beverage'],
    },
    {
        name: 'iconFontAwesomeFoodBeverageWineGlass',
        title: __('Wine Glass', 'icon-font-awesome'),
        icon: iconFontAwesomeFoodBeverageWineGlass,
        categories: ['food+beverage'],
    },
];

// fruits+vegetables
import {
    iconFontAwesomeFruitsVegetablesAppleWhole,
    iconFontAwesomeFruitsVegetablesCarrot,
    iconFontAwesomeFruitsVegetablesLeaf,
    iconFontAwesomeFruitsVegetablesLemon,
    iconFontAwesomeFruitsVegetablesPepperHot,
    iconFontAwesomeFruitsVegetablesSeedling,
} from './fruits+vegetables';

// fruits+vegetables
const fruitsVegetablesIcons = [
    {
        name: 'iconFontAwesomeFruitsVegetablesAppleWhole',
        title: __('Apple Whole', 'icon-font-awesome'),
        icon: iconFontAwesomeFruitsVegetablesAppleWhole,
        categories: ['fruits+vegetables'],
    },
    {
        name: 'iconFontAwesomeFruitsVegetablesCarrot',
        title: __('Carrot', 'icon-font-awesome'),
        icon: iconFontAwesomeFruitsVegetablesCarrot,
        categories: ['fruits+vegetables'],
    },
    {
        name: 'iconFontAwesomeFruitsVegetablesLeaf',
        title: __('Leaf', 'icon-font-awesome'),
        icon: iconFontAwesomeFruitsVegetablesLeaf,
        categories: ['fruits+vegetables'],
    },
    {
        name: 'iconFontAwesomeFruitsVegetablesLemon',
        title: __('Lemon', 'icon-font-awesome'),
        icon: iconFontAwesomeFruitsVegetablesLemon,
        categories: ['fruits+vegetables'],
    },
    {
        name: 'iconFontAwesomeFruitsVegetablesPepperHot',
        title: __('Pepper Hot', 'icon-font-awesome'),
        icon: iconFontAwesomeFruitsVegetablesPepperHot,
        categories: ['fruits+vegetables'],
    },
    {
        name: 'iconFontAwesomeFruitsVegetablesSeedling',
        title: __('Seedling', 'icon-font-awesome'),
        icon: iconFontAwesomeFruitsVegetablesSeedling,
        categories: ['fruits+vegetables'],
    },
];

// gaming
import {
    iconFontAwesomeGamingBookSkull,
    iconFontAwesomeGamingChessBishop,
    iconFontAwesomeGamingChessBoard,
    iconFontAwesomeGamingChess,
    iconFontAwesomeGamingChessKing,
    iconFontAwesomeGamingChessKnight,
    iconFontAwesomeGamingChessPawn,
    iconFontAwesomeGamingChessQueen,
    iconFontAwesomeGamingChessRook,
    iconFontAwesomeGamingCriticalRole,
    iconFontAwesomeGamingDAndDBeyond,
    iconFontAwesomeGamingDAndD,
    iconFontAwesomeGamingDiamond,
    iconFontAwesomeGamingDiceD20,
    iconFontAwesomeGamingDiceD6,
    iconFontAwesomeGamingDiceFive,
    iconFontAwesomeGamingDiceFour,
    iconFontAwesomeGamingDice,
    iconFontAwesomeGamingDiceOne,
    iconFontAwesomeGamingDiceSix,
    iconFontAwesomeGamingDiceThree,
    iconFontAwesomeGamingDiceTwo,
    iconFontAwesomeGamingDragon,
    iconFontAwesomeGamingDungeon,
    iconFontAwesomeGamingFantasyFlightGames,
    iconFontAwesomeGamingGamepad,
    iconFontAwesomeGamingGhost,
    iconFontAwesomeGamingHandFist,
    iconFontAwesomeGamingHatWizard,
    iconFontAwesomeGamingHeadset,
    iconFontAwesomeGamingHeart,
    iconFontAwesomeGamingPlaystation,
    iconFontAwesomeGamingPuzzlePiece,
    iconFontAwesomeGamingRing,
    iconFontAwesomeGamingScroll,
    iconFontAwesomeGamingShieldHalved,
    iconFontAwesomeGamingSkullCrossbones,
    iconFontAwesomeGamingSquareFull,
    iconFontAwesomeGamingSquareSteam,
    iconFontAwesomeGamingSteam,
    iconFontAwesomeGamingSteamSymbol,
    iconFontAwesomeGamingTwitch,
    iconFontAwesomeGamingVrCardboard,
    iconFontAwesomeGamingWandSparkles,
    iconFontAwesomeGamingWizardsOfTheCoast,
    iconFontAwesomeGamingXbox,
} from './gaming';

// gaming
const gamingIcons = [
    {
        name: 'iconFontAwesomeGamingBookSkull',
        title: __('Book Skull', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingBookSkull,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChessBishop',
        title: __('Chess Bishop', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChessBishop,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChessBoard',
        title: __('Chess Board', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChessBoard,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChess',
        title: __('Chess', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChess,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChessKing',
        title: __('Chess King', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChessKing,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChessKnight',
        title: __('Chess Knight', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChessKnight,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChessPawn',
        title: __('Chess Pawn', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChessPawn,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChessQueen',
        title: __('Chess Queen', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChessQueen,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingChessRook',
        title: __('Chess Rook', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingChessRook,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingCriticalRole',
        title: __('Critical Role', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingCriticalRole,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDAndDBeyond',
        title: __('DAnd DBeyond', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDAndDBeyond,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDAndD',
        title: __('DAnd D', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDAndD,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiamond',
        title: __('Diamond', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiamond,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceD20',
        title: __('Dice D20', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceD20,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceD6',
        title: __('Dice D6', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceD6,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceFive',
        title: __('Dice Five', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceFive,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceFour',
        title: __('Dice Four', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceFour,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDice',
        title: __('Dice', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDice,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceOne',
        title: __('Dice One', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceOne,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceSix',
        title: __('Dice Six', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceSix,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceThree',
        title: __('Dice Three', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceThree,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDiceTwo',
        title: __('Dice Two', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDiceTwo,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDragon',
        title: __('Dragon', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDragon,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingDungeon',
        title: __('Dungeon', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingDungeon,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingFantasyFlightGames',
        title: __('Fantasy Flight Games', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingFantasyFlightGames,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingGamepad',
        title: __('Gamepad', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingGamepad,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingGhost',
        title: __('Ghost', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingGhost,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingHandFist',
        title: __('Hand Fist', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingHandFist,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingHatWizard',
        title: __('Hat Wizard', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingHatWizard,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingHeadset',
        title: __('Headset', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingHeadset,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingHeart,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingPlaystation',
        title: __('Playstation', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingPlaystation,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingPuzzlePiece',
        title: __('Puzzle Piece', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingPuzzlePiece,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingRing',
        title: __('Ring', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingRing,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingScroll',
        title: __('Scroll', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingScroll,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingShieldHalved',
        title: __('Shield Halved', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingShieldHalved,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingSkullCrossbones',
        title: __('Skull Crossbones', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingSkullCrossbones,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingSquareFull',
        title: __('Square Full', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingSquareFull,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingSquareSteam',
        title: __('Square Steam', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingSquareSteam,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingSteam',
        title: __('Steam', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingSteam,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingSteamSymbol',
        title: __('Steam Symbol', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingSteamSymbol,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingTwitch',
        title: __('Twitch', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingTwitch,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingVrCardboard',
        title: __('Vr Cardboard', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingVrCardboard,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingWandSparkles',
        title: __('Wand Sparkles', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingWandSparkles,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingWizardsOfTheCoast',
        title: __('Wizards Of The Coast', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingWizardsOfTheCoast,
        categories: ['gaming'],
    },
    {
        name: 'iconFontAwesomeGamingXbox',
        title: __('Xbox', 'icon-font-awesome'),
        icon: iconFontAwesomeGamingXbox,
        categories: ['gaming'],
    },
];

// genders
import {
    iconFontAwesomeGendersGenderless,
    iconFontAwesomeGendersMarsAndVenus,
    iconFontAwesomeGendersMarsDouble,
    iconFontAwesomeGendersMars,
    iconFontAwesomeGendersMarsStroke,
    iconFontAwesomeGendersMarsStrokeRight,
    iconFontAwesomeGendersMarsStrokeUp,
    iconFontAwesomeGendersMercury,
    iconFontAwesomeGendersNeuter,
    iconFontAwesomeGendersPersonHalfDress,
    iconFontAwesomeGendersTransgender,
    iconFontAwesomeGendersVenusDouble,
    iconFontAwesomeGendersVenus,
    iconFontAwesomeGendersVenusMars,
} from './genders';

// genders
const gendersIcons = [
    {
        name: 'iconFontAwesomeGendersGenderless',
        title: __('Genderless', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersGenderless,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersMarsAndVenus',
        title: __('Mars And Venus', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersMarsAndVenus,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersMarsDouble',
        title: __('Mars Double', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersMarsDouble,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersMars',
        title: __('Mars', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersMars,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersMarsStroke',
        title: __('Mars Stroke', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersMarsStroke,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersMarsStrokeRight',
        title: __('Mars Stroke Right', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersMarsStrokeRight,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersMarsStrokeUp',
        title: __('Mars Stroke Up', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersMarsStrokeUp,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersMercury',
        title: __('Mercury', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersMercury,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersNeuter',
        title: __('Neuter', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersNeuter,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersPersonHalfDress',
        title: __('Person Half Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersPersonHalfDress,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersTransgender',
        title: __('Transgender', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersTransgender,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersVenusDouble',
        title: __('Venus Double', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersVenusDouble,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersVenus',
        title: __('Venus', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersVenus,
        categories: ['genders'],
    },
    {
        name: 'iconFontAwesomeGendersVenusMars',
        title: __('Venus Mars', 'icon-font-awesome'),
        icon: iconFontAwesomeGendersVenusMars,
        categories: ['genders'],
    },
];

// halloween
import {
    iconFontAwesomeHalloweenBookSkull,
    iconFontAwesomeHalloweenBroom,
    iconFontAwesomeHalloweenCat,
    iconFontAwesomeHalloweenCloudMoon,
    iconFontAwesomeHalloweenCrow,
    iconFontAwesomeHalloweenGhost,
    iconFontAwesomeHalloweenHatWizard,
    iconFontAwesomeHalloweenMask,
    iconFontAwesomeHalloweenSkullCrossbones,
    iconFontAwesomeHalloweenSkull,
    iconFontAwesomeHalloweenSpider,
    iconFontAwesomeHalloweenToiletPaper,
    iconFontAwesomeHalloweenWandSparkles,
} from './halloween';

// halloween
const halloweenIcons = [
    {
        name: 'iconFontAwesomeHalloweenBookSkull',
        title: __('Book Skull', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenBookSkull,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenBroom',
        title: __('Broom', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenBroom,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenCat',
        title: __('Cat', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenCat,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenCloudMoon',
        title: __('Cloud Moon', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenCloudMoon,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenCrow',
        title: __('Crow', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenCrow,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenGhost',
        title: __('Ghost', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenGhost,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenHatWizard',
        title: __('Hat Wizard', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenHatWizard,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenMask',
        title: __('Mask', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenMask,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenSkullCrossbones',
        title: __('Skull Crossbones', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenSkullCrossbones,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenSkull',
        title: __('Skull', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenSkull,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenSpider',
        title: __('Spider', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenSpider,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenToiletPaper',
        title: __('Toilet Paper', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenToiletPaper,
        categories: ['halloween'],
    },
    {
        name: 'iconFontAwesomeHalloweenWandSparkles',
        title: __('Wand Sparkles', 'icon-font-awesome'),
        icon: iconFontAwesomeHalloweenWandSparkles,
        categories: ['halloween'],
    },
];

// hands
import {
    iconFontAwesomeHandsHandBackFist,
    iconFontAwesomeHandsHandDots,
    iconFontAwesomeHandsHandFist,
    iconFontAwesomeHandsHandHoldingDollar,
    iconFontAwesomeHandsHandHoldingDroplet,
    iconFontAwesomeHandsHandHoldingHand,
    iconFontAwesomeHandsHandHoldingHeart,
    iconFontAwesomeHandsHandHolding,
    iconFontAwesomeHandsHandHoldingMedical,
    iconFontAwesomeHandsHand,
    iconFontAwesomeHandsHandLizard,
    iconFontAwesomeHandsHandMiddleFinger,
    iconFontAwesomeHandsHandPeace,
    iconFontAwesomeHandsHandPointDown,
    iconFontAwesomeHandsHandPointer,
    iconFontAwesomeHandsHandPointLeft,
    iconFontAwesomeHandsHandPointRight,
    iconFontAwesomeHandsHandPointUp,
    iconFontAwesomeHandsHandsBound,
    iconFontAwesomeHandsHandsBubbles,
    iconFontAwesomeHandsHandScissors,
    iconFontAwesomeHandsHandsClapping,
    iconFontAwesomeHandsHandshakeAngle,
    iconFontAwesomeHandsHandshake,
    iconFontAwesomeHandsHandshakeSimple,
    iconFontAwesomeHandsHandshakeSimpleSlash,
    iconFontAwesomeHandsHandshakeSlash,
    iconFontAwesomeHandsHandsHoldingChild,
    iconFontAwesomeHandsHandsHoldingCircle,
    iconFontAwesomeHandsHandsHolding,
    iconFontAwesomeHandsHandSparkles,
    iconFontAwesomeHandsHandSpock,
    iconFontAwesomeHandsHandsPraying,
    iconFontAwesomeHandsThumbsDown,
    iconFontAwesomeHandsThumbsUp,
} from './hands';

// hands
const handsIcons = [
    {
        name: 'iconFontAwesomeHandsHandBackFist',
        title: __('Hand Back Fist', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandBackFist,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandDots',
        title: __('Hand Dots', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandDots,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandFist',
        title: __('Hand Fist', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandFist,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandHoldingDollar',
        title: __('Hand Holding Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandHoldingDollar,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandHoldingDroplet',
        title: __('Hand Holding Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandHoldingDroplet,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandHoldingHand',
        title: __('Hand Holding Hand', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandHoldingHand,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandHoldingHeart',
        title: __('Hand Holding Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandHoldingHeart,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandHolding',
        title: __('Hand Holding', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandHolding,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandHoldingMedical',
        title: __('Hand Holding Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandHoldingMedical,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHand',
        title: __('Hand', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHand,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandLizard',
        title: __('Hand Lizard', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandLizard,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandMiddleFinger',
        title: __('Hand Middle Finger', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandMiddleFinger,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandPeace',
        title: __('Hand Peace', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandPeace,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandPointDown',
        title: __('Hand Point Down', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandPointDown,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandPointer',
        title: __('Hand Pointer', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandPointer,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandPointLeft',
        title: __('Hand Point Left', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandPointLeft,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandPointRight',
        title: __('Hand Point Right', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandPointRight,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandPointUp',
        title: __('Hand Point Up', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandPointUp,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandsBound',
        title: __('Bound', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandsBound,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandsBubbles',
        title: __('Bubbles', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandsBubbles,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandScissors',
        title: __('Hand Scissors', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandScissors,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandsClapping',
        title: __('Clapping', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandsClapping,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandshakeAngle',
        title: __('hake Angle', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandshakeAngle,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandshake',
        title: __('hake', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandshake,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandshakeSimple',
        title: __('hake Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandshakeSimple,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandshakeSimpleSlash',
        title: __('hake Simple Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandshakeSimpleSlash,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandshakeSlash',
        title: __('hake Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandshakeSlash,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandsHoldingChild',
        title: __('Holding Child', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandsHoldingChild,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandsHoldingCircle',
        title: __('Holding Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandsHoldingCircle,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandsHolding',
        title: __('Holding', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandsHolding,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandSparkles',
        title: __('Hand Sparkles', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandSparkles,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandSpock',
        title: __('Hand Spock', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandSpock,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsHandsPraying',
        title: __('Praying', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsHandsPraying,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsThumbsDown',
        title: __('Thumbs Down', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsThumbsDown,
        categories: ['hands'],
    },
    {
        name: 'iconFontAwesomeHandsThumbsUp',
        title: __('Thumbs Up', 'icon-font-awesome'),
        icon: iconFontAwesomeHandsThumbsUp,
        categories: ['hands'],
    },
];

// holidays
import {
    iconFontAwesomeHolidaysCandyCane,
    iconFontAwesomeHolidaysCarrot,
    iconFontAwesomeHolidaysChampagneGlasses,
    iconFontAwesomeHolidaysCookieBite,
    iconFontAwesomeHolidaysFaceGrinHearts,
    iconFontAwesomeHolidaysFaceKissWinkHeart,
    iconFontAwesomeHolidaysGift,
    iconFontAwesomeHolidaysGifts,
    iconFontAwesomeHolidaysHeart,
    iconFontAwesomeHolidaysHollyBerry,
    iconFontAwesomeHolidaysMenorah,
    iconFontAwesomeHolidaysMugHot,
    iconFontAwesomeHolidaysSleigh,
    iconFontAwesomeHolidaysSnowman,
} from './holidays';

// holidays
const holidaysIcons = [
    {
        name: 'iconFontAwesomeHolidaysCandyCane',
        title: __('Candy Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysCandyCane,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysCarrot',
        title: __('Carrot', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysCarrot,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysChampagneGlasses',
        title: __('Champagne Glasses', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysChampagneGlasses,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysCookieBite',
        title: __('Cookie Bite', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysCookieBite,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysFaceGrinHearts',
        title: __('Face Grin Hearts', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysFaceGrinHearts,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysFaceKissWinkHeart',
        title: __('Face Kiss Wink Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysFaceKissWinkHeart,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysGift',
        title: __('Gift', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysGift,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysGifts',
        title: __('Gifts', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysGifts,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysHeart,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysHollyBerry',
        title: __('Holly Berry', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysHollyBerry,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysMenorah',
        title: __('Menorah', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysMenorah,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysMugHot',
        title: __('Mug Hot', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysMugHot,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysSleigh',
        title: __('Sleigh', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysSleigh,
        categories: ['holidays'],
    },
    {
        name: 'iconFontAwesomeHolidaysSnowman',
        title: __('Snowman', 'icon-font-awesome'),
        icon: iconFontAwesomeHolidaysSnowman,
        categories: ['holidays'],
    },
];

// household
import {
    iconFontAwesomeHouseholdArrowUpFromWaterPump,
    iconFontAwesomeHouseholdBath,
    iconFontAwesomeHouseholdBed,
    iconFontAwesomeHouseholdBell,
    iconFontAwesomeHouseholdBlender,
    iconFontAwesomeHouseholdBoxTissue,
    iconFontAwesomeHouseholdChair,
    iconFontAwesomeHouseholdComputer,
    iconFontAwesomeHouseholdCouch,
    iconFontAwesomeHouseholdDoorClosed,
    iconFontAwesomeHouseholdDoorOpen,
    iconFontAwesomeHouseholdDungeon,
    iconFontAwesomeHouseholdFan,
    iconFontAwesomeHouseholdFaucetDrip,
    iconFontAwesomeHouseholdFaucet,
    iconFontAwesomeHouseholdFireBurner,
    iconFontAwesomeHouseholdHouseChimneyUser,
    iconFontAwesomeHouseholdHouseChimneyWindow,
    iconFontAwesomeHouseholdHouseFire,
    iconFontAwesomeHouseholdHouseLaptop,
    iconFontAwesomeHouseholdHouseLock,
    iconFontAwesomeHouseholdHouseSignal,
    iconFontAwesomeHouseholdHouseUser,
    iconFontAwesomeHouseholdJar,
    iconFontAwesomeHouseholdJarWheat,
    iconFontAwesomeHouseholdJugDetergent,
    iconFontAwesomeHouseholdKitchenSet,
    iconFontAwesomeHouseholdLightbulb,
    iconFontAwesomeHouseholdMattressPillow,
    iconFontAwesomeHouseholdMugSaucer,
    iconFontAwesomeHouseholdPeopleRoof,
    iconFontAwesomeHouseholdPlug,
    iconFontAwesomeHouseholdPumpSoap,
    iconFontAwesomeHouseholdRug,
    iconFontAwesomeHouseholdSheetPlastic,
    iconFontAwesomeHouseholdShower,
    iconFontAwesomeHouseholdSink,
    iconFontAwesomeHouseholdSnowflake,
    iconFontAwesomeHouseholdSoap,
    iconFontAwesomeHouseholdSpoon,
    iconFontAwesomeHouseholdStairs,
    iconFontAwesomeHouseholdTemperatureArrowDown,
    iconFontAwesomeHouseholdTemperatureArrowUp,
    iconFontAwesomeHouseholdToilet,
    iconFontAwesomeHouseholdToiletPaper,
    iconFontAwesomeHouseholdToiletPaperSlash,
    iconFontAwesomeHouseholdTv,
    iconFontAwesomeHouseholdUtensils,
} from './household';

// household
const householdIcons = [
    {
        name: 'iconFontAwesomeHouseholdArrowUpFromWaterPump',
        title: __('Arrow Up From Water Pump', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdArrowUpFromWaterPump,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdBath',
        title: __('Bath', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdBath,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdBed',
        title: __('Bed', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdBed,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdBell',
        title: __('Bell', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdBell,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdBlender',
        title: __('Blender', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdBlender,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdBoxTissue',
        title: __('Box Tissue', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdBoxTissue,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdChair',
        title: __('Chair', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdChair,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdComputer',
        title: __('Computer', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdComputer,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdCouch',
        title: __('Couch', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdCouch,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdDoorClosed',
        title: __('Door Closed', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdDoorClosed,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdDoorOpen',
        title: __('Door Open', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdDoorOpen,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdDungeon',
        title: __('Dungeon', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdDungeon,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdFan',
        title: __('Fan', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdFan,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdFaucetDrip',
        title: __('Faucet Drip', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdFaucetDrip,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdFaucet',
        title: __('Faucet', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdFaucet,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdFireBurner',
        title: __('Fire Burner', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdFireBurner,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdHouseChimneyUser',
        title: __('House Chimney User', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdHouseChimneyUser,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdHouseChimneyWindow',
        title: __('House Chimney Window', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdHouseChimneyWindow,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdHouseFire',
        title: __('House Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdHouseFire,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdHouseLaptop',
        title: __('House Laptop', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdHouseLaptop,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdHouseLock',
        title: __('House Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdHouseLock,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdHouseSignal',
        title: __('House Signal', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdHouseSignal,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdHouseUser',
        title: __('House User', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdHouseUser,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdJar',
        title: __('Jar', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdJar,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdJarWheat',
        title: __('Jar Wheat', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdJarWheat,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdJugDetergent',
        title: __('Jug Detergent', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdJugDetergent,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdKitchenSet',
        title: __('Kitchen Set', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdKitchenSet,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdLightbulb',
        title: __('Lightbulb', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdLightbulb,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdMattressPillow',
        title: __('Mattress Pillow', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdMattressPillow,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdMugSaucer',
        title: __('Mug Saucer', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdMugSaucer,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdPeopleRoof',
        title: __('People Roof', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdPeopleRoof,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdPlug',
        title: __('Plug', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdPlug,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdPumpSoap',
        title: __('Pump Soap', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdPumpSoap,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdRug',
        title: __('Rug', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdRug,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdSheetPlastic',
        title: __('Sheet Plastic', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdSheetPlastic,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdShower',
        title: __('Shower', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdShower,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdSink',
        title: __('Sink', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdSink,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdSnowflake',
        title: __('Snowflake', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdSnowflake,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdSoap',
        title: __('Soap', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdSoap,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdSpoon',
        title: __('Spoon', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdSpoon,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdStairs',
        title: __('Stairs', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdStairs,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdTemperatureArrowDown',
        title: __('Temperature Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdTemperatureArrowDown,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdTemperatureArrowUp',
        title: __('Temperature Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdTemperatureArrowUp,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdToilet',
        title: __('Toilet', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdToilet,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdToiletPaper',
        title: __('Toilet Paper', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdToiletPaper,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdToiletPaperSlash',
        title: __('Toilet Paper Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdToiletPaperSlash,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdTv',
        title: __('Tv', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdTv,
        categories: ['household'],
    },
    {
        name: 'iconFontAwesomeHouseholdUtensils',
        title: __('Utensils', 'icon-font-awesome'),
        icon: iconFontAwesomeHouseholdUtensils,
        categories: ['household'],
    },
];

// humanitarian
import {
    iconFontAwesomeHumanitarianAnchor,
    iconFontAwesomeHumanitarianArrowUpRightFromSquare,
    iconFontAwesomeHumanitarianBaby,
    iconFontAwesomeHumanitarianBuilding,
    iconFontAwesomeHumanitarianCar,
    iconFontAwesomeHumanitarianChurch,
    iconFontAwesomeHumanitarianDroplet,
    iconFontAwesomeHumanitarianEnvelope,
    iconFontAwesomeHumanitarianFile,
    iconFontAwesomeHumanitarianFilePdf,
    iconFontAwesomeHumanitarianFlag,
    iconFontAwesomeHumanitarianGopuram,
    iconFontAwesomeHumanitarianHammer,
    iconFontAwesomeHumanitarianHeadset,
    iconFontAwesomeHumanitarianHospital,
    iconFontAwesomeHumanitarianHotel,
    iconFontAwesomeHumanitarianLandmark,
    iconFontAwesomeHumanitarianLaptop,
    iconFontAwesomeHumanitarianMountainCity,
    iconFontAwesomeHumanitarianMountainSun,
    iconFontAwesomeHumanitarianOilWell,
    iconFontAwesomeHumanitarianParachuteBox,
    iconFontAwesomeHumanitarianPeopleArrows,
    iconFontAwesomeHumanitarianPeopleGroup,
    iconFontAwesomeHumanitarianPeopleLine,
    iconFontAwesomeHumanitarianPeoplePulling,
    iconFontAwesomeHumanitarianPeopleRobbery,
    iconFontAwesomeHumanitarianPeopleRoof,
    iconFontAwesomeHumanitarianPersonArrowDownToLine,
    iconFontAwesomeHumanitarianPersonArrowUpFromLine,
    iconFontAwesomeHumanitarianPersonBreastfeeding,
    iconFontAwesomeHumanitarianPersonBurst,
    iconFontAwesomeHumanitarianPersonCane,
    iconFontAwesomeHumanitarianPersonChalkboard,
    iconFontAwesomeHumanitarianPersonCircleCheck,
    iconFontAwesomeHumanitarianPersonCircleExclamation,
    iconFontAwesomeHumanitarianPersonCircleMinus,
    iconFontAwesomeHumanitarianPersonCirclePlus,
    iconFontAwesomeHumanitarianPersonCircleQuestion,
    iconFontAwesomeHumanitarianPersonCircleXmark,
    iconFontAwesomeHumanitarianPersonDigging,
    iconFontAwesomeHumanitarianPersonDressBurst,
    iconFontAwesomeHumanitarianPersonDress,
    iconFontAwesomeHumanitarianPersonDrowning,
    iconFontAwesomeHumanitarianPersonFallingBurst,
    iconFontAwesomeHumanitarianPersonFalling,
    iconFontAwesomeHumanitarianPersonHalfDress,
    iconFontAwesomeHumanitarianPersonHarassing,
    iconFontAwesomeHumanitarianPerson,
    iconFontAwesomeHumanitarianPersonMilitaryPointing,
    iconFontAwesomeHumanitarianPersonMilitaryRifle,
    iconFontAwesomeHumanitarianPersonMilitaryToPerson,
    iconFontAwesomeHumanitarianPersonPregnant,
    iconFontAwesomeHumanitarianPersonRays,
    iconFontAwesomeHumanitarianPersonRifle,
    iconFontAwesomeHumanitarianPersonShelter,
    iconFontAwesomeHumanitarianPersonThroughWindow,
    iconFontAwesomeHumanitarianPersonWalkingArrowLoopLeft,
    iconFontAwesomeHumanitarianPersonWalkingArrowRight,
    iconFontAwesomeHumanitarianPersonWalkingDashedLineArrowRight,
    iconFontAwesomeHumanitarianPersonWalking,
    iconFontAwesomeHumanitarianPersonWalkingLuggage,
    iconFontAwesomeHumanitarianPills,
    iconFontAwesomeHumanitarianPlaneCircleCheck,
    iconFontAwesomeHumanitarianPlaneCircleExclamation,
    iconFontAwesomeHumanitarianPlaneCircleXmark,
    iconFontAwesomeHumanitarianPlaneLock,
    iconFontAwesomeHumanitarianPlaneUp,
    iconFontAwesomeHumanitarianPlantWilt,
    iconFontAwesomeHumanitarianPlateWheat,
    iconFontAwesomeHumanitarianPlugCircleBolt,
    iconFontAwesomeHumanitarianPlugCircleCheck,
    iconFontAwesomeHumanitarianPlugCircleExclamation,
    iconFontAwesomeHumanitarianPlugCircleMinus,
    iconFontAwesomeHumanitarianPlugCirclePlus,
    iconFontAwesomeHumanitarianPlugCircleXmark,
    iconFontAwesomeHumanitarianPlug,
    iconFontAwesomeHumanitarianPumpSoap,
    iconFontAwesomeHumanitarianRadiation,
    iconFontAwesomeHumanitarianRadio,
    iconFontAwesomeHumanitarianRankingStar,
    iconFontAwesomeHumanitarianRoadBarrier,
    iconFontAwesomeHumanitarianRoadBridge,
    iconFontAwesomeHumanitarianRoadCircleCheck,
    iconFontAwesomeHumanitarianRoadCircleExclamation,
    iconFontAwesomeHumanitarianRoadCircleXmark,
    iconFontAwesomeHumanitarianRoad,
    iconFontAwesomeHumanitarianRoadLock,
    iconFontAwesomeHumanitarianRoadSpikes,
    iconFontAwesomeHumanitarianRug,
    iconFontAwesomeHumanitarianSackDollar,
    iconFontAwesomeHumanitarianSackXmark,
    iconFontAwesomeHumanitarianSailboat,
    iconFontAwesomeHumanitarianSatelliteDish,
    iconFontAwesomeHumanitarianScaleBalanced,
    iconFontAwesomeHumanitarianSchoolCircleCheck,
    iconFontAwesomeHumanitarianSchoolCircleExclamation,
    iconFontAwesomeHumanitarianSchoolCircleXmark,
    iconFontAwesomeHumanitarianSchoolFlag,
    iconFontAwesomeHumanitarianSchool,
    iconFontAwesomeHumanitarianSchoolLock,
    iconFontAwesomeHumanitarianSeedling,
    iconFontAwesomeHumanitarianSheetPlastic,
    iconFontAwesomeHumanitarianShieldCat,
    iconFontAwesomeHumanitarianShieldDog,
    iconFontAwesomeHumanitarianShieldHeart,
    iconFontAwesomeHumanitarianShip,
    iconFontAwesomeHumanitarianShirt,
    iconFontAwesomeHumanitarianShop,
    iconFontAwesomeHumanitarianShopLock,
    iconFontAwesomeHumanitarianShower,
    iconFontAwesomeHumanitarianSkullCrossbones,
    iconFontAwesomeHumanitarianSnowflake,
    iconFontAwesomeHumanitarianSoap,
    iconFontAwesomeHumanitarianSquareNfi,
    iconFontAwesomeHumanitarianSquarePersonConfined,
    iconFontAwesomeHumanitarianSquareVirus,
    iconFontAwesomeHumanitarianStaffSnake,
    iconFontAwesomeHumanitarianStethoscope,
    iconFontAwesomeHumanitarianSuitcaseMedical,
    iconFontAwesomeHumanitarianSunPlantWilt,
    iconFontAwesomeHumanitarianSyringe,
    iconFontAwesomeHumanitarianTarpDroplet,
    iconFontAwesomeHumanitarianTarp,
    iconFontAwesomeHumanitarianTemperatureArrowDown,
    iconFontAwesomeHumanitarianTemperatureArrowUp,
    iconFontAwesomeHumanitarianTentArrowDownToLine,
    iconFontAwesomeHumanitarianTentArrowLeftRight,
    iconFontAwesomeHumanitarianTentArrowsDown,
    iconFontAwesomeHumanitarianTentArrowTurnLeft,
    iconFontAwesomeHumanitarianTent,
    iconFontAwesomeHumanitarianTents,
    iconFontAwesomeHumanitarianToilet,
    iconFontAwesomeHumanitarianToiletPortable,
    iconFontAwesomeHumanitarianToiletsPortable,
    iconFontAwesomeHumanitarianTornado,
    iconFontAwesomeHumanitarianTowerBroadcast,
    iconFontAwesomeHumanitarianTowerCell,
    iconFontAwesomeHumanitarianTowerObservation,
    iconFontAwesomeHumanitarianTrainSubway,
    iconFontAwesomeHumanitarianTrashCan,
    iconFontAwesomeHumanitarianTreeCity,
    iconFontAwesomeHumanitarianTrowelBricks,
    iconFontAwesomeHumanitarianTrowel,
    iconFontAwesomeHumanitarianTruckArrowRight,
    iconFontAwesomeHumanitarianTruckDroplet,
    iconFontAwesomeHumanitarianTruckField,
    iconFontAwesomeHumanitarianTruckFieldUn,
    iconFontAwesomeHumanitarianTruckFront,
    iconFontAwesomeHumanitarianTruck,
    iconFontAwesomeHumanitarianTruckMedical,
    iconFontAwesomeHumanitarianTruckPlane,
    iconFontAwesomeHumanitarianUserDoctor,
    iconFontAwesomeHumanitarianUserInjured,
    iconFontAwesomeHumanitarianUsersBetweenLines,
    iconFontAwesomeHumanitarianUsersLine,
    iconFontAwesomeHumanitarianUsersRays,
    iconFontAwesomeHumanitarianUsersRectangle,
    iconFontAwesomeHumanitarianUsersViewfinder,
    iconFontAwesomeHumanitarianVialCircleCheck,
    iconFontAwesomeHumanitarianVialVirus,
    iconFontAwesomeHumanitarianVihara,
    iconFontAwesomeHumanitarianVirusCovid,
    iconFontAwesomeHumanitarianVirus,
    iconFontAwesomeHumanitarianVolcano,
    iconFontAwesomeHumanitarianWalkieTalkie,
    iconFontAwesomeHumanitarianWheatAwnCircleExclamation,
    iconFontAwesomeHumanitarianWheatAwn,
    iconFontAwesomeHumanitarianWheelchairMove,
    iconFontAwesomeHumanitarianWifi,
    iconFontAwesomeHumanitarianWind,
    iconFontAwesomeHumanitarianWorm,
    iconFontAwesomeHumanitarianXmarksLines,
} from './humanitarian';

// humanitarian
const humanitarianIcons = [
    {
        name: 'iconFontAwesomeHumanitarianAnchor',
        title: __('Anchor', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianAnchor,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianArrowUpRightFromSquare',
        title: __('Arrow Up Right From Square', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianArrowUpRightFromSquare,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianBaby',
        title: __('Baby', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianBaby,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianBuilding',
        title: __('Building', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianBuilding,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianCar',
        title: __('Car', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianCar,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianChurch',
        title: __('Church', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianChurch,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianDroplet',
        title: __('Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianDroplet,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianEnvelope',
        title: __('Envelope', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianEnvelope,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianFile',
        title: __('File', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianFile,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianFilePdf',
        title: __('File Pdf', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianFilePdf,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianFlag',
        title: __('Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianFlag,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianGopuram',
        title: __('Gopuram', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianGopuram,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianHammer',
        title: __('Hammer', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianHammer,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianHeadset',
        title: __('Headset', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianHeadset,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianHospital',
        title: __('Hospital', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianHospital,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianHotel',
        title: __('Hotel', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianHotel,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianLandmark',
        title: __('Landmark', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianLandmark,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianLaptop',
        title: __('Laptop', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianLaptop,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianMountainCity',
        title: __('Mountain City', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianMountainCity,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianMountainSun',
        title: __('Mountain Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianMountainSun,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianOilWell',
        title: __('Oil Well', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianOilWell,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianParachuteBox',
        title: __('Parachute Box', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianParachuteBox,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPeopleArrows',
        title: __('People Arrows', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPeopleArrows,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPeopleGroup',
        title: __('People Group', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPeopleGroup,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPeopleLine',
        title: __('People Line', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPeopleLine,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPeoplePulling',
        title: __('People Pulling', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPeoplePulling,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPeopleRobbery',
        title: __('People Robbery', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPeopleRobbery,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPeopleRoof',
        title: __('People Roof', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPeopleRoof,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonArrowDownToLine',
        title: __('Person Arrow Down To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonArrowDownToLine,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonArrowUpFromLine',
        title: __('Person Arrow Up From Line', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonArrowUpFromLine,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonBreastfeeding',
        title: __('Person Breastfeeding', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonBreastfeeding,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonBurst',
        title: __('Person Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonBurst,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonCane',
        title: __('Person Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonCane,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonChalkboard',
        title: __('Person Chalkboard', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonChalkboard,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonCircleCheck',
        title: __('Person Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonCircleCheck,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonCircleExclamation',
        title: __('Person Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonCircleExclamation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonCircleMinus',
        title: __('Person Circle Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonCircleMinus,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonCirclePlus',
        title: __('Person Circle Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonCirclePlus,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonCircleQuestion',
        title: __('Person Circle Question', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonCircleQuestion,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonCircleXmark',
        title: __('Person Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonCircleXmark,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonDigging',
        title: __('Person Digging', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonDigging,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonDressBurst',
        title: __('Person Dress Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonDressBurst,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonDress',
        title: __('Person Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonDress,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonDrowning',
        title: __('Person Drowning', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonDrowning,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonFallingBurst',
        title: __('Person Falling Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonFallingBurst,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonFalling',
        title: __('Person Falling', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonFalling,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonHalfDress',
        title: __('Person Half Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonHalfDress,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonHarassing',
        title: __('Person Harassing', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonHarassing,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPerson',
        title: __('Person', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPerson,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonMilitaryPointing',
        title: __('Person Military Pointing', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonMilitaryPointing,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonMilitaryRifle',
        title: __('Person Military Rifle', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonMilitaryRifle,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonMilitaryToPerson',
        title: __('Person Military To Person', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonMilitaryToPerson,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonPregnant',
        title: __('Person Pregnant', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonPregnant,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonRays',
        title: __('Person Rays', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonRays,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonRifle',
        title: __('Person Rifle', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonRifle,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonShelter',
        title: __('Person Shelter', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonShelter,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonThroughWindow',
        title: __('Person Through Window', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonThroughWindow,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonWalkingArrowLoopLeft',
        title: __('Person Walking Arrow Loop Left', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonWalkingArrowLoopLeft,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonWalkingArrowRight',
        title: __('Person Walking Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonWalkingArrowRight,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonWalkingDashedLineArrowRight',
        title: __('Person Walking Dashed Line Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonWalkingDashedLineArrowRight,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonWalking',
        title: __('Person Walking', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonWalking,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPersonWalkingLuggage',
        title: __('Person Walking Luggage', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPersonWalkingLuggage,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPills',
        title: __('Pills', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPills,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlaneCircleCheck',
        title: __('Plane Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlaneCircleCheck,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlaneCircleExclamation',
        title: __('Plane Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlaneCircleExclamation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlaneCircleXmark',
        title: __('Plane Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlaneCircleXmark,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlaneLock',
        title: __('Plane Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlaneLock,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlaneUp',
        title: __('Plane Up', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlaneUp,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlantWilt',
        title: __('Plant Wilt', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlantWilt,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlateWheat',
        title: __('Plate Wheat', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlateWheat,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlugCircleBolt',
        title: __('Plug Circle Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlugCircleBolt,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlugCircleCheck',
        title: __('Plug Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlugCircleCheck,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlugCircleExclamation',
        title: __('Plug Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlugCircleExclamation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlugCircleMinus',
        title: __('Plug Circle Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlugCircleMinus,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlugCirclePlus',
        title: __('Plug Circle Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlugCirclePlus,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlugCircleXmark',
        title: __('Plug Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlugCircleXmark,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPlug',
        title: __('Plug', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPlug,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianPumpSoap',
        title: __('Pump Soap', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianPumpSoap,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRadiation',
        title: __('Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRadiation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRadio',
        title: __('Radio', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRadio,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRankingStar',
        title: __('Ranking Star', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRankingStar,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoadBarrier',
        title: __('Road Barrier', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoadBarrier,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoadBridge',
        title: __('Road Bridge', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoadBridge,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoadCircleCheck',
        title: __('Road Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoadCircleCheck,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoadCircleExclamation',
        title: __('Road Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoadCircleExclamation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoadCircleXmark',
        title: __('Road Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoadCircleXmark,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoad',
        title: __('Road', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoad,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoadLock',
        title: __('Road Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoadLock,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRoadSpikes',
        title: __('Road Spikes', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRoadSpikes,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianRug',
        title: __('Rug', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianRug,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSackDollar',
        title: __('Sack Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSackDollar,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSackXmark',
        title: __('Sack Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSackXmark,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSailboat',
        title: __('Sailboat', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSailboat,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSatelliteDish',
        title: __('Satellite Dish', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSatelliteDish,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianScaleBalanced',
        title: __('Scale Balanced', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianScaleBalanced,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSchoolCircleCheck',
        title: __('School Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSchoolCircleCheck,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSchoolCircleExclamation',
        title: __('School Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSchoolCircleExclamation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSchoolCircleXmark',
        title: __('School Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSchoolCircleXmark,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSchoolFlag',
        title: __('School Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSchoolFlag,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSchool',
        title: __('School', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSchool,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSchoolLock',
        title: __('School Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSchoolLock,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSeedling',
        title: __('Seedling', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSeedling,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSheetPlastic',
        title: __('Sheet Plastic', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSheetPlastic,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShieldCat',
        title: __('Shield Cat', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShieldCat,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShieldDog',
        title: __('Shield Dog', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShieldDog,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShieldHeart',
        title: __('Shield Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShieldHeart,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShip',
        title: __('Ship', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShip,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShirt',
        title: __('Shirt', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShirt,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShop',
        title: __('Shop', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShop,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShopLock',
        title: __('Shop Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShopLock,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianShower',
        title: __('Shower', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianShower,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSkullCrossbones',
        title: __('Skull Crossbones', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSkullCrossbones,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSnowflake',
        title: __('Snowflake', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSnowflake,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSoap',
        title: __('Soap', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSoap,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSquareNfi',
        title: __('Square Nfi', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSquareNfi,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSquarePersonConfined',
        title: __('Square Person Confined', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSquarePersonConfined,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSquareVirus',
        title: __('Square Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSquareVirus,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianStaffSnake',
        title: __('Staff Snake', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianStaffSnake,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianStethoscope',
        title: __('Stethoscope', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianStethoscope,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSuitcaseMedical',
        title: __('Suitcase Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSuitcaseMedical,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSunPlantWilt',
        title: __('Sun Plant Wilt', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSunPlantWilt,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianSyringe',
        title: __('Syringe', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianSyringe,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTarpDroplet',
        title: __('Tarp Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTarpDroplet,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTarp',
        title: __('Tarp', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTarp,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTemperatureArrowDown',
        title: __('Temperature Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTemperatureArrowDown,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTemperatureArrowUp',
        title: __('Temperature Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTemperatureArrowUp,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTentArrowDownToLine',
        title: __('Tent Arrow Down To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTentArrowDownToLine,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTentArrowLeftRight',
        title: __('Tent Arrow Left Right', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTentArrowLeftRight,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTentArrowsDown',
        title: __('Tent Arrows Down', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTentArrowsDown,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTentArrowTurnLeft',
        title: __('Tent Arrow Turn Left', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTentArrowTurnLeft,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTent',
        title: __('Tent', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTent,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTents',
        title: __('Tents', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTents,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianToilet',
        title: __('Toilet', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianToilet,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianToiletPortable',
        title: __('Toilet Portable', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianToiletPortable,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianToiletsPortable',
        title: __('Toilets Portable', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianToiletsPortable,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTornado',
        title: __('Tornado', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTornado,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTowerBroadcast',
        title: __('Tower Broadcast', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTowerBroadcast,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTowerCell',
        title: __('Tower Cell', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTowerCell,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTowerObservation',
        title: __('Tower Observation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTowerObservation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTrainSubway',
        title: __('Train Subway', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTrainSubway,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTrashCan',
        title: __('Trash Can', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTrashCan,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTreeCity',
        title: __('Tree City', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTreeCity,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTrowelBricks',
        title: __('Trowel Bricks', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTrowelBricks,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTrowel',
        title: __('Trowel', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTrowel,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruckArrowRight',
        title: __('Truck Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruckArrowRight,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruckDroplet',
        title: __('Truck Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruckDroplet,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruckField',
        title: __('Truck Field', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruckField,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruckFieldUn',
        title: __('Truck Field Un', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruckFieldUn,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruckFront',
        title: __('Truck Front', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruckFront,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruck',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruck,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruckMedical',
        title: __('Truck Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruckMedical,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianTruckPlane',
        title: __('Truck Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianTruckPlane,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianUserDoctor',
        title: __('User Doctor', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianUserDoctor,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianUserInjured',
        title: __('User Injured', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianUserInjured,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianUsersBetweenLines',
        title: __('Users Between Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianUsersBetweenLines,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianUsersLine',
        title: __('Users Line', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianUsersLine,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianUsersRays',
        title: __('Users Rays', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianUsersRays,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianUsersRectangle',
        title: __('Users Rectangle', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianUsersRectangle,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianUsersViewfinder',
        title: __('Users Viewfinder', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianUsersViewfinder,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianVialCircleCheck',
        title: __('Vial Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianVialCircleCheck,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianVialVirus',
        title: __('Vial Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianVialVirus,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianVihara',
        title: __('Vihara', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianVihara,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianVirusCovid',
        title: __('Virus Covid', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianVirusCovid,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianVirus',
        title: __('Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianVirus,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianVolcano',
        title: __('Volcano', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianVolcano,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianWalkieTalkie',
        title: __('Walkie Talkie', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianWalkieTalkie,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianWheatAwnCircleExclamation',
        title: __('Wheat Awn Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianWheatAwnCircleExclamation,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianWheatAwn',
        title: __('Wheat Awn', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianWheatAwn,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianWheelchairMove',
        title: __('Wheelchair Move', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianWheelchairMove,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianWifi',
        title: __('Wifi', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianWifi,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianWind',
        title: __('Wind', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianWind,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianWorm',
        title: __('Worm', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianWorm,
        categories: ['humanitarian'],
    },
    {
        name: 'iconFontAwesomeHumanitarianXmarksLines',
        title: __('Xmarks Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeHumanitarianXmarksLines,
        categories: ['humanitarian'],
    },
];

// logistics
import {
    iconFontAwesomeLogisticsAnchorCircleCheck,
    iconFontAwesomeLogisticsAnchorCircleExclamation,
    iconFontAwesomeLogisticsAnchorCircleXmark,
    iconFontAwesomeLogisticsAnchor,
    iconFontAwesomeLogisticsAnchorLock,
    iconFontAwesomeLogisticsBoxesPacking,
    iconFontAwesomeLogisticsBoxesStacked,
    iconFontAwesomeLogisticsBox,
    iconFontAwesomeLogisticsBridgeCircleCheck,
    iconFontAwesomeLogisticsBridgeCircleExclamation,
    iconFontAwesomeLogisticsBridgeCircleXmark,
    iconFontAwesomeLogisticsBridge,
    iconFontAwesomeLogisticsBridgeLock,
    iconFontAwesomeLogisticsBridgeWater,
    iconFontAwesomeLogisticsBus,
    iconFontAwesomeLogisticsBusSimple,
    iconFontAwesomeLogisticsCar,
    iconFontAwesomeLogisticsCartFlatbed,
    iconFontAwesomeLogisticsCarTunnel,
    iconFontAwesomeLogisticsChartSimple,
    iconFontAwesomeLogisticsClipboardCheck,
    iconFontAwesomeLogisticsClipboardList,
    iconFontAwesomeLogisticsClipboardQuestion,
    iconFontAwesomeLogisticsDolly,
    iconFontAwesomeLogisticsFerry,
    iconFontAwesomeLogisticsGasPump,
    iconFontAwesomeLogisticsGears,
    iconFontAwesomeLogisticsHelicopter,
    iconFontAwesomeLogisticsHelicopterSymbol,
    iconFontAwesomeLogisticsHelmetSafety,
    iconFontAwesomeLogisticsJetFighterUp,
    iconFontAwesomeLogisticsPallet,
    iconFontAwesomeLogisticsPlaneCircleCheck,
    iconFontAwesomeLogisticsPlaneCircleExclamation,
    iconFontAwesomeLogisticsPlaneCircleXmark,
    iconFontAwesomeLogisticsPlaneLock,
    iconFontAwesomeLogisticsRoadBarrier,
    iconFontAwesomeLogisticsRoadBridge,
    iconFontAwesomeLogisticsRoadCircleCheck,
    iconFontAwesomeLogisticsRoadCircleExclamation,
    iconFontAwesomeLogisticsRoadCircleXmark,
    iconFontAwesomeLogisticsRoad,
    iconFontAwesomeLogisticsRoadLock,
    iconFontAwesomeLogisticsSailboat,
    iconFontAwesomeLogisticsSquareNfi,
    iconFontAwesomeLogisticsTrain,
    iconFontAwesomeLogisticsTrainSubway,
    iconFontAwesomeLogisticsTruckArrowRight,
    iconFontAwesomeLogisticsTruckFast,
    iconFontAwesomeLogisticsTruckField,
    iconFontAwesomeLogisticsTruckFieldUn,
    iconFontAwesomeLogisticsTruckFront,
    iconFontAwesomeLogisticsTruck,
    iconFontAwesomeLogisticsTruckPlane,
    iconFontAwesomeLogisticsWarehouse,
    iconFontAwesomeLogisticsXmarksLines,
} from './logistics';

// logistics
const logisticsIcons = [
    {
        name: 'iconFontAwesomeLogisticsAnchorCircleCheck',
        title: __('Anchor Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsAnchorCircleCheck,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsAnchorCircleExclamation',
        title: __('Anchor Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsAnchorCircleExclamation,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsAnchorCircleXmark',
        title: __('Anchor Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsAnchorCircleXmark,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsAnchor',
        title: __('Anchor', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsAnchor,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsAnchorLock',
        title: __('Anchor Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsAnchorLock,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBoxesPacking',
        title: __('Boxes Packing', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBoxesPacking,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBoxesStacked',
        title: __('Boxes Stacked', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBoxesStacked,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBox',
        title: __('Box', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBox,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBridgeCircleCheck',
        title: __('Bridge Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBridgeCircleCheck,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBridgeCircleExclamation',
        title: __('Bridge Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBridgeCircleExclamation,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBridgeCircleXmark',
        title: __('Bridge Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBridgeCircleXmark,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBridge',
        title: __('Bridge', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBridge,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBridgeLock',
        title: __('Bridge Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBridgeLock,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBridgeWater',
        title: __('Bridge Water', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBridgeWater,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBus',
        title: __('Bus', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBus,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsBusSimple',
        title: __('Bus Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsBusSimple,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsCar',
        title: __('Car', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsCar,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsCartFlatbed',
        title: __('Cart Flatbed', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsCartFlatbed,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsCarTunnel',
        title: __('Car Tunnel', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsCarTunnel,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsChartSimple',
        title: __('Chart Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsChartSimple,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsClipboardCheck',
        title: __('Clipboard Check', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsClipboardCheck,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsClipboardList',
        title: __('Clipboard List', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsClipboardList,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsClipboardQuestion',
        title: __('Clipboard Question', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsClipboardQuestion,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsDolly',
        title: __('Dolly', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsDolly,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsFerry',
        title: __('Ferry', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsFerry,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsGasPump',
        title: __('Gas Pump', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsGasPump,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsGears',
        title: __('Gears', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsGears,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsHelicopter',
        title: __('Helicopter', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsHelicopter,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsHelicopterSymbol',
        title: __('Helicopter Symbol', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsHelicopterSymbol,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsHelmetSafety',
        title: __('Helmet Safety', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsHelmetSafety,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsJetFighterUp',
        title: __('Jet Fighter Up', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsJetFighterUp,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsPallet',
        title: __('Pallet', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsPallet,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsPlaneCircleCheck',
        title: __('Plane Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsPlaneCircleCheck,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsPlaneCircleExclamation',
        title: __('Plane Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsPlaneCircleExclamation,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsPlaneCircleXmark',
        title: __('Plane Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsPlaneCircleXmark,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsPlaneLock',
        title: __('Plane Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsPlaneLock,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsRoadBarrier',
        title: __('Road Barrier', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsRoadBarrier,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsRoadBridge',
        title: __('Road Bridge', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsRoadBridge,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsRoadCircleCheck',
        title: __('Road Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsRoadCircleCheck,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsRoadCircleExclamation',
        title: __('Road Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsRoadCircleExclamation,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsRoadCircleXmark',
        title: __('Road Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsRoadCircleXmark,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsRoad',
        title: __('Road', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsRoad,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsRoadLock',
        title: __('Road Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsRoadLock,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsSailboat',
        title: __('Sailboat', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsSailboat,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsSquareNfi',
        title: __('Square Nfi', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsSquareNfi,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTrain',
        title: __('Train', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTrain,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTrainSubway',
        title: __('Train Subway', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTrainSubway,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTruckArrowRight',
        title: __('Truck Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTruckArrowRight,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTruckFast',
        title: __('Truck Fast', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTruckFast,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTruckField',
        title: __('Truck Field', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTruckField,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTruckFieldUn',
        title: __('Truck Field Un', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTruckFieldUn,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTruckFront',
        title: __('Truck Front', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTruckFront,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTruck',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTruck,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsTruckPlane',
        title: __('Truck Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsTruckPlane,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsWarehouse',
        title: __('Warehouse', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsWarehouse,
        categories: ['logistics'],
    },
    {
        name: 'iconFontAwesomeLogisticsXmarksLines',
        title: __('Xmarks Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeLogisticsXmarksLines,
        categories: ['logistics'],
    },
];

// maps
import {
    iconFontAwesomeMapsAnchor,
    iconFontAwesomeMapsBagShopping,
    iconFontAwesomeMapsBasketShopping,
    iconFontAwesomeMapsBath,
    iconFontAwesomeMapsBed,
    iconFontAwesomeMapsBeerMugEmpty,
    iconFontAwesomeMapsBell,
    iconFontAwesomeMapsBellSlash,
    iconFontAwesomeMapsBicycle,
    iconFontAwesomeMapsBinoculars,
    iconFontAwesomeMapsBomb,
    iconFontAwesomeMapsBookAtlas,
    iconFontAwesomeMapsBook,
    iconFontAwesomeMapsBookmark,
    iconFontAwesomeMapsBridge,
    iconFontAwesomeMapsBridgeWater,
    iconFontAwesomeMapsBriefcase,
    iconFontAwesomeMapsBuildingColumns,
    iconFontAwesomeMapsBuilding,
    iconFontAwesomeMapsCakeCandles,
    iconFontAwesomeMapsCar,
    iconFontAwesomeMapsCartShopping,
    iconFontAwesomeMapsCircleInfo,
    iconFontAwesomeMapsCrosshairs,
    iconFontAwesomeMapsDiamondTurnRight,
    iconFontAwesomeMapsDollarSign,
    iconFontAwesomeMapsDrawPolygon,
    iconFontAwesomeMapsDroplet,
    iconFontAwesomeMapsEye,
    iconFontAwesomeMapsEyeLowVision,
    iconFontAwesomeMapsEyeSlash,
    iconFontAwesomeMapsFireExtinguisher,
    iconFontAwesomeMapsFireFlameCurved,
    iconFontAwesomeMapsFire,
    iconFontAwesomeMapsFlagCheckered,
    iconFontAwesomeMapsFlag,
    iconFontAwesomeMapsFlask,
    iconFontAwesomeMapsGamepad,
    iconFontAwesomeMapsGavel,
    iconFontAwesomeMapsGift,
    iconFontAwesomeMapsGlobe,
    iconFontAwesomeMapsGraduationCap,
    iconFontAwesomeMapsHeart,
    iconFontAwesomeMapsHeartPulse,
    iconFontAwesomeMapsHelicopter,
    iconFontAwesomeMapsHelicopterSymbol,
    iconFontAwesomeMapsHospital,
    iconFontAwesomeMapsHouse,
    iconFontAwesomeMapsImage,
    iconFontAwesomeMapsImages,
    iconFontAwesomeMapsIndustry,
    iconFontAwesomeMapsInfo,
    iconFontAwesomeMapsJetFighter,
    iconFontAwesomeMapsKey,
    iconFontAwesomeMapsLandmarkFlag,
    iconFontAwesomeMapsLandmark,
    iconFontAwesomeMapsLayerGroup,
    iconFontAwesomeMapsLeaf,
    iconFontAwesomeMapsLemon,
    iconFontAwesomeMapsLifeRing,
    iconFontAwesomeMapsLightbulb,
    iconFontAwesomeMapsLocationArrow,
    iconFontAwesomeMapsLocationCrosshairs,
    iconFontAwesomeMapsLocationDot,
    iconFontAwesomeMapsLocationPin,
    iconFontAwesomeMapsLocationPinLock,
    iconFontAwesomeMapsMagnet,
    iconFontAwesomeMapsMagnifyingGlass,
    iconFontAwesomeMapsMagnifyingGlassLocation,
    iconFontAwesomeMapsMagnifyingGlassMinus,
    iconFontAwesomeMapsMagnifyingGlassPlus,
    iconFontAwesomeMapsMap,
    iconFontAwesomeMapsMapPin,
    iconFontAwesomeMapsMartiniGlassEmpty,
    iconFontAwesomeMapsMoneyBill1,
    iconFontAwesomeMapsMoneyBill,
    iconFontAwesomeMapsMonument,
    iconFontAwesomeMapsMotorcycle,
    iconFontAwesomeMapsMountainSun,
    iconFontAwesomeMapsMugSaucer,
    iconFontAwesomeMapsMusic,
    iconFontAwesomeMapsNewspaper,
    iconFontAwesomeMapsPaw,
    iconFontAwesomeMapsPerson,
    iconFontAwesomeMapsPersonWalkingWithCane,
    iconFontAwesomeMapsPhoneFlip,
    iconFontAwesomeMapsPhone,
    iconFontAwesomeMapsPhoneVolume,
    iconFontAwesomeMapsPlane,
    iconFontAwesomeMapsPlug,
    iconFontAwesomeMapsPlus,
    iconFontAwesomeMapsPrint,
    iconFontAwesomeMapsRecycle,
    iconFontAwesomeMapsRestroom,
    iconFontAwesomeMapsRoad,
    iconFontAwesomeMapsRocket,
    iconFontAwesomeMapsRoute,
    iconFontAwesomeMapsScaleBalanced,
    iconFontAwesomeMapsScaleUnbalancedFlip,
    iconFontAwesomeMapsScaleUnbalanced,
    iconFontAwesomeMapsShip,
    iconFontAwesomeMapsShoePrints,
    iconFontAwesomeMapsShower,
    iconFontAwesomeMapsSignsPost,
    iconFontAwesomeMapsSnowplow,
    iconFontAwesomeMapsSpoon,
    iconFontAwesomeMapsSquareH,
    iconFontAwesomeMapsSquareParking,
    iconFontAwesomeMapsSquarePhoneFlip,
    iconFontAwesomeMapsSquarePhone,
    iconFontAwesomeMapsSquarePlus,
    iconFontAwesomeMapsStreetView,
    iconFontAwesomeMapsSuitcase,
    iconFontAwesomeMapsSuitcaseMedical,
    iconFontAwesomeMapsTag,
    iconFontAwesomeMapsTags,
    iconFontAwesomeMapsTaxi,
    iconFontAwesomeMapsThumbtack,
    iconFontAwesomeMapsTicket,
    iconFontAwesomeMapsTicketSimple,
    iconFontAwesomeMapsTrafficLight,
    iconFontAwesomeMapsTrain,
    iconFontAwesomeMapsTrainSubway,
    iconFontAwesomeMapsTrainTram,
    iconFontAwesomeMapsTree,
    iconFontAwesomeMapsTrophy,
    iconFontAwesomeMapsTruck,
    iconFontAwesomeMapsTruckMedical,
    iconFontAwesomeMapsTty,
    iconFontAwesomeMapsUmbrella,
    iconFontAwesomeMapsUtensils,
    iconFontAwesomeMapsVest,
    iconFontAwesomeMapsVestPatches,
    iconFontAwesomeMapsWheelchair,
    iconFontAwesomeMapsWheelchairMove,
    iconFontAwesomeMapsWifi,
    iconFontAwesomeMapsWineGlass,
    iconFontAwesomeMapsWrench,
} from './maps';

// maps
const mapsIcons = [
    {
        name: 'iconFontAwesomeMapsAnchor',
        title: __('Anchor', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsAnchor,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBagShopping',
        title: __('Bag Shopping', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBagShopping,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBasketShopping',
        title: __('Basket Shopping', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBasketShopping,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBath',
        title: __('Bath', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBath,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBed',
        title: __('Bed', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBed,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBeerMugEmpty',
        title: __('Beer Mug Empty', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBeerMugEmpty,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBell',
        title: __('Bell', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBell,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBellSlash',
        title: __('Bell Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBellSlash,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBicycle',
        title: __('Bicycle', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBicycle,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBinoculars',
        title: __('Binoculars', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBinoculars,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBomb',
        title: __('Bomb', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBomb,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBookAtlas',
        title: __('Book Atlas', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBookAtlas,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBook',
        title: __('Book', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBook,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBookmark',
        title: __('Bookmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBookmark,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBridge',
        title: __('Bridge', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBridge,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBridgeWater',
        title: __('Bridge Water', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBridgeWater,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBriefcase',
        title: __('Briefcase', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBriefcase,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBuildingColumns',
        title: __('Building Columns', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBuildingColumns,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsBuilding',
        title: __('Building', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsBuilding,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsCakeCandles',
        title: __('Cake Candles', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsCakeCandles,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsCar',
        title: __('Car', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsCar,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsCartShopping',
        title: __('Cart Shopping', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsCartShopping,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsCircleInfo',
        title: __('Circle Info', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsCircleInfo,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsCrosshairs',
        title: __('Crosshairs', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsCrosshairs,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsDiamondTurnRight',
        title: __('Diamond Turn Right', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsDiamondTurnRight,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsDollarSign',
        title: __('Dollar Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsDollarSign,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsDrawPolygon',
        title: __('Draw Polygon', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsDrawPolygon,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsDroplet',
        title: __('Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsDroplet,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsEye',
        title: __('Eye', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsEye,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsEyeLowVision',
        title: __('Eye Low Vision', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsEyeLowVision,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsEyeSlash',
        title: __('Eye Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsEyeSlash,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsFireExtinguisher',
        title: __('Fire Extinguisher', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsFireExtinguisher,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsFireFlameCurved',
        title: __('Fire Flame Curved', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsFireFlameCurved,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsFire',
        title: __('Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsFire,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsFlagCheckered',
        title: __('Flag Checkered', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsFlagCheckered,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsFlag',
        title: __('Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsFlag,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsFlask',
        title: __('Flask', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsFlask,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsGamepad',
        title: __('Gamepad', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsGamepad,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsGavel',
        title: __('Gavel', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsGavel,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsGift',
        title: __('Gift', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsGift,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsGlobe',
        title: __('Globe', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsGlobe,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsGraduationCap',
        title: __('Graduation Cap', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsGraduationCap,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsHeart,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsHeartPulse',
        title: __('Heart Pulse', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsHeartPulse,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsHelicopter',
        title: __('Helicopter', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsHelicopter,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsHelicopterSymbol',
        title: __('Helicopter Symbol', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsHelicopterSymbol,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsHospital',
        title: __('Hospital', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsHospital,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsHouse',
        title: __('House', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsHouse,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsImage',
        title: __('Image', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsImage,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsImages',
        title: __('Images', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsImages,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsIndustry',
        title: __('Industry', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsIndustry,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsInfo',
        title: __('Info', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsInfo,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsJetFighter',
        title: __('Jet Fighter', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsJetFighter,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsKey',
        title: __('Key', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsKey,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLandmarkFlag',
        title: __('Landmark Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLandmarkFlag,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLandmark',
        title: __('Landmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLandmark,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLayerGroup',
        title: __('Layer Group', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLayerGroup,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLeaf',
        title: __('Leaf', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLeaf,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLemon',
        title: __('Lemon', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLemon,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLifeRing',
        title: __('Life Ring', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLifeRing,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLightbulb',
        title: __('Lightbulb', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLightbulb,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLocationArrow',
        title: __('Location Arrow', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLocationArrow,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLocationCrosshairs',
        title: __('Location Crosshairs', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLocationCrosshairs,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLocationDot',
        title: __('Location Dot', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLocationDot,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLocationPin',
        title: __('Location Pin', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLocationPin,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsLocationPinLock',
        title: __('Location Pin Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsLocationPinLock,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMagnet',
        title: __('Magnet', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMagnet,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMagnifyingGlass',
        title: __('Magnifying Glass', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMagnifyingGlass,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMagnifyingGlassLocation',
        title: __('Magnifying Glass Location', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMagnifyingGlassLocation,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMagnifyingGlassMinus',
        title: __('Magnifying Glass Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMagnifyingGlassMinus,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMagnifyingGlassPlus',
        title: __('Magnifying Glass Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMagnifyingGlassPlus,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMap',
        title: __('Map', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMap,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMapPin',
        title: __('Map Pin', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMapPin,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMartiniGlassEmpty',
        title: __('Martini Glass Empty', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMartiniGlassEmpty,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMoneyBill1',
        title: __('Money Bill1', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMoneyBill1,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMoneyBill',
        title: __('Money Bill', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMoneyBill,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMonument',
        title: __('Monument', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMonument,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMotorcycle',
        title: __('Motorcycle', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMotorcycle,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMountainSun',
        title: __('Mountain Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMountainSun,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMugSaucer',
        title: __('Mug Saucer', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMugSaucer,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsMusic',
        title: __('Music', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsMusic,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsNewspaper',
        title: __('Newspaper', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsNewspaper,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPaw',
        title: __('Paw', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPaw,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPerson',
        title: __('Person', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPerson,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPersonWalkingWithCane',
        title: __('Person Walking With Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPersonWalkingWithCane,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPhoneFlip',
        title: __('Phone Flip', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPhoneFlip,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPhone',
        title: __('Phone', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPhone,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPhoneVolume',
        title: __('Phone Volume', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPhoneVolume,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPlane',
        title: __('Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPlane,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPlug',
        title: __('Plug', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPlug,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPlus',
        title: __('Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPlus,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsPrint',
        title: __('Print', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsPrint,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsRecycle',
        title: __('Recycle', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsRecycle,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsRestroom',
        title: __('Restroom', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsRestroom,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsRoad',
        title: __('Road', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsRoad,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsRocket',
        title: __('Rocket', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsRocket,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsRoute',
        title: __('Route', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsRoute,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsScaleBalanced',
        title: __('Scale Balanced', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsScaleBalanced,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsScaleUnbalancedFlip',
        title: __('Scale Unbalanced Flip', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsScaleUnbalancedFlip,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsScaleUnbalanced',
        title: __('Scale Unbalanced', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsScaleUnbalanced,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsShip',
        title: __('Ship', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsShip,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsShoePrints',
        title: __('Shoe Prints', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsShoePrints,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsShower',
        title: __('Shower', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsShower,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSignsPost',
        title: __('Signs Post', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSignsPost,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSnowplow',
        title: __('Snowplow', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSnowplow,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSpoon',
        title: __('Spoon', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSpoon,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSquareH',
        title: __('Square H', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSquareH,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSquareParking',
        title: __('Square Parking', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSquareParking,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSquarePhoneFlip',
        title: __('Square Phone Flip', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSquarePhoneFlip,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSquarePhone',
        title: __('Square Phone', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSquarePhone,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSquarePlus',
        title: __('Square Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSquarePlus,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsStreetView',
        title: __('Street View', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsStreetView,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSuitcase',
        title: __('Suitcase', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSuitcase,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsSuitcaseMedical',
        title: __('Suitcase Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsSuitcaseMedical,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTag',
        title: __('Tag', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTag,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTags',
        title: __('Tags', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTags,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTaxi',
        title: __('Taxi', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTaxi,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsThumbtack',
        title: __('Thumbtack', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsThumbtack,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTicket',
        title: __('Ticket', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTicket,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTicketSimple',
        title: __('Ticket Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTicketSimple,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTrafficLight',
        title: __('Traffic Light', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTrafficLight,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTrain',
        title: __('Train', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTrain,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTrainSubway',
        title: __('Train Subway', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTrainSubway,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTrainTram',
        title: __('Train Tram', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTrainTram,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTree',
        title: __('Tree', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTree,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTrophy',
        title: __('Trophy', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTrophy,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTruck',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTruck,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTruckMedical',
        title: __('Truck Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTruckMedical,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsTty',
        title: __('Tty', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsTty,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsUmbrella',
        title: __('Umbrella', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsUmbrella,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsUtensils',
        title: __('Utensils', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsUtensils,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsVest',
        title: __('Vest', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsVest,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsVestPatches',
        title: __('Vest Patches', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsVestPatches,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsWheelchair',
        title: __('Wheelchair', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsWheelchair,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsWheelchairMove',
        title: __('Wheelchair Move', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsWheelchairMove,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsWifi',
        title: __('Wifi', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsWifi,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsWineGlass',
        title: __('Wine Glass', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsWineGlass,
        categories: ['maps'],
    },
    {
        name: 'iconFontAwesomeMapsWrench',
        title: __('Wrench', 'icon-font-awesome'),
        icon: iconFontAwesomeMapsWrench,
        categories: ['maps'],
    },
];

// maritime
import {
    iconFontAwesomeMaritimeAnchorCircleCheck,
    iconFontAwesomeMaritimeAnchorCircleExclamation,
    iconFontAwesomeMaritimeAnchorCircleXmark,
    iconFontAwesomeMaritimeAnchor,
    iconFontAwesomeMaritimeAnchorLock,
    iconFontAwesomeMaritimeFerry,
    iconFontAwesomeMaritimeFishFins,
    iconFontAwesomeMaritimeFish,
    iconFontAwesomeMaritimeOtter,
    iconFontAwesomeMaritimePersonSwimming,
    iconFontAwesomeMaritimeSailboat,
    iconFontAwesomeMaritimeShip,
    iconFontAwesomeMaritimeShrimp,
    iconFontAwesomeMaritimeWater,
} from './maritime';

// maritime
const maritimeIcons = [
    {
        name: 'iconFontAwesomeMaritimeAnchorCircleCheck',
        title: __('Anchor Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeAnchorCircleCheck,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeAnchorCircleExclamation',
        title: __('Anchor Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeAnchorCircleExclamation,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeAnchorCircleXmark',
        title: __('Anchor Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeAnchorCircleXmark,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeAnchor',
        title: __('Anchor', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeAnchor,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeAnchorLock',
        title: __('Anchor Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeAnchorLock,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeFerry',
        title: __('Ferry', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeFerry,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeFishFins',
        title: __('Fish Fins', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeFishFins,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeFish',
        title: __('Fish', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeFish,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeOtter',
        title: __('Otter', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeOtter,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimePersonSwimming',
        title: __('Person Swimming', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimePersonSwimming,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeSailboat',
        title: __('Sailboat', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeSailboat,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeShip',
        title: __('Ship', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeShip,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeShrimp',
        title: __('Shrimp', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeShrimp,
        categories: ['maritime'],
    },
    {
        name: 'iconFontAwesomeMaritimeWater',
        title: __('Water', 'icon-font-awesome'),
        icon: iconFontAwesomeMaritimeWater,
        categories: ['maritime'],
    },
];

// marketing
import {
    iconFontAwesomeMarketingAnchorCircleCheck,
    iconFontAwesomeMarketingAnchorCircleExclamation,
    iconFontAwesomeMarketingAnchorCircleXmark,
    iconFontAwesomeMarketingAnchor,
    iconFontAwesomeMarketingAnchorLock,
    iconFontAwesomeMarketingFerry,
    iconFontAwesomeMarketingFishFins,
    iconFontAwesomeMarketingFish,
    iconFontAwesomeMarketingOtter,
    iconFontAwesomeMarketingPersonSwimming,
    iconFontAwesomeMarketingSailboat,
    iconFontAwesomeMarketingShip,
    iconFontAwesomeMarketingShrimp,
    iconFontAwesomeMarketingWater,
} from './marketing';

// marketing
const marketingIcons = [
    {
        name: 'iconFontAwesomeMarketingAnchorCircleCheck',
        title: __('Anchor Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingAnchorCircleCheck,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingAnchorCircleExclamation',
        title: __('Anchor Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingAnchorCircleExclamation,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingAnchorCircleXmark',
        title: __('Anchor Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingAnchorCircleXmark,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingAnchor',
        title: __('Anchor', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingAnchor,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingAnchorLock',
        title: __('Anchor Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingAnchorLock,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingFerry',
        title: __('Ferry', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingFerry,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingFishFins',
        title: __('Fish Fins', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingFishFins,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingFish',
        title: __('Fish', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingFish,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingOtter',
        title: __('Otter', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingOtter,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingPersonSwimming',
        title: __('Person Swimming', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingPersonSwimming,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingSailboat',
        title: __('Sailboat', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingSailboat,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingShip',
        title: __('Ship', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingShip,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingShrimp',
        title: __('Shrimp', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingShrimp,
        categories: ['marketing'],
    },
    {
        name: 'iconFontAwesomeMarketingWater',
        title: __('Water', 'icon-font-awesome'),
        icon: iconFontAwesomeMarketingWater,
        categories: ['marketing'],
    },
];

// mathematics
import {
    iconFontAwesomeMathematicsCalculator,
    iconFontAwesomeMathematicsCircleMinus,
    iconFontAwesomeMathematicsCirclePlus,
    iconFontAwesomeMathematicsCircleXmark,
    iconFontAwesomeMathematicsDivide,
    iconFontAwesomeMathematicsEquals,
    iconFontAwesomeMathematicsGreaterThanEqual,
    iconFontAwesomeMathematicsGreaterThan,
    iconFontAwesomeMathematicsInfinity,
    iconFontAwesomeMathematicsLessThanEqual,
    iconFontAwesomeMathematicsLessThan,
    iconFontAwesomeMathematicsMinus,
    iconFontAwesomeMathematicsNotEqual,
    iconFontAwesomeMathematicsPercent,
    iconFontAwesomeMathematicsPlus,
    iconFontAwesomeMathematicsPlusMinus,
    iconFontAwesomeMathematicsSquareMinus,
    iconFontAwesomeMathematicsSquareRootVariable,
    iconFontAwesomeMathematicsSquareXmark,
    iconFontAwesomeMathematicsSubscript,
    iconFontAwesomeMathematicsSuperscript,
    iconFontAwesomeMathematicsWaveSquare,
    iconFontAwesomeMathematicsXmark,
} from './mathematics';

// mathematics
const mathematicsIcons = [
    {
        name: 'iconFontAwesomeMathematicsCalculator',
        title: __('Calculator', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsCalculator,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsCircleMinus',
        title: __('Circle Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsCircleMinus,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsCirclePlus',
        title: __('Circle Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsCirclePlus,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsCircleXmark',
        title: __('Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsCircleXmark,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsDivide',
        title: __('Divide', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsDivide,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsEquals',
        title: __('Equals', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsEquals,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsGreaterThanEqual',
        title: __('Greater Than Equal', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsGreaterThanEqual,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsGreaterThan',
        title: __('Greater Than', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsGreaterThan,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsInfinity',
        title: __('Infinity', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsInfinity,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsLessThanEqual',
        title: __('Less Than Equal', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsLessThanEqual,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsLessThan',
        title: __('Less Than', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsLessThan,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsMinus',
        title: __('Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsMinus,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsNotEqual',
        title: __('Not Equal', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsNotEqual,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsPercent',
        title: __('Percent', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsPercent,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsPlus',
        title: __('Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsPlus,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsPlusMinus',
        title: __('Plus Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsPlusMinus,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsSquareMinus',
        title: __('Square Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsSquareMinus,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsSquareRootVariable',
        title: __('Square Root Variable', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsSquareRootVariable,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsSquareXmark',
        title: __('Square Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsSquareXmark,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsSubscript',
        title: __('Subscript', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsSubscript,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsSuperscript',
        title: __('Superscript', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsSuperscript,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsWaveSquare',
        title: __('Wave Square', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsWaveSquare,
        categories: ['mathematics'],
    },
    {
        name: 'iconFontAwesomeMathematicsXmark',
        title: __('Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMathematicsXmark,
        categories: ['mathematics'],
    },
];

// media-playback
import {
    iconFontAwesomeMediaplaybackArrowRotateLeft,
    iconFontAwesomeMediaplaybackArrowRotateRight,
    iconFontAwesomeMediaplaybackArrowsRotate,
    iconFontAwesomeMediaplaybackBackwardFast,
    iconFontAwesomeMediaplaybackBackward,
    iconFontAwesomeMediaplaybackBackwardStep,
    iconFontAwesomeMediaplaybackCirclePause,
    iconFontAwesomeMediaplaybackCirclePlay,
    iconFontAwesomeMediaplaybackCircleStop,
    iconFontAwesomeMediaplaybackCompress,
    iconFontAwesomeMediaplaybackDownLeftAndUpRightToCenter,
    iconFontAwesomeMediaplaybackEject,
    iconFontAwesomeMediaplaybackExpand,
    iconFontAwesomeMediaplaybackForwardFast,
    iconFontAwesomeMediaplaybackForward,
    iconFontAwesomeMediaplaybackForwardStep,
    iconFontAwesomeMediaplaybackHand,
    iconFontAwesomeMediaplaybackMaximize,
    iconFontAwesomeMediaplaybackMinimize,
    iconFontAwesomeMediaplaybackMusic,
    iconFontAwesomeMediaplaybackPause,
    iconFontAwesomeMediaplaybackPhoneVolume,
    iconFontAwesomeMediaplaybackPlay,
    iconFontAwesomeMediaplaybackPlusMinus,
    iconFontAwesomeMediaplaybackRepeat,
    iconFontAwesomeMediaplaybackRotate,
    iconFontAwesomeMediaplaybackRotateLeft,
    iconFontAwesomeMediaplaybackRotateRight,
    iconFontAwesomeMediaplaybackRss,
    iconFontAwesomeMediaplaybackShuffle,
    iconFontAwesomeMediaplaybackSliders,
    iconFontAwesomeMediaplaybackStop,
    iconFontAwesomeMediaplaybackUpRightAndDownLeftFromCenter,
    iconFontAwesomeMediaplaybackVolumeHigh,
    iconFontAwesomeMediaplaybackVolumeLow,
    iconFontAwesomeMediaplaybackVolumeOff,
    iconFontAwesomeMediaplaybackVolumeXmark,
} from './media-playback';

// media-playback
const mediaPlaybackIcons = [
    {
        name: 'iconFontAwesomeMediaplaybackArrowRotateLeft',
        title: __('Mediaplayback Arrow Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackArrowRotateLeft,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackArrowRotateRight',
        title: __('Mediaplayback Arrow Rotate Right', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackArrowRotateRight,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackArrowsRotate',
        title: __('Mediaplayback Arrows Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackArrowsRotate,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackBackwardFast',
        title: __('Mediaplayback Backward Fast', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackBackwardFast,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackBackward',
        title: __('Mediaplayback Backward', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackBackward,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackBackwardStep',
        title: __('Mediaplayback Backward Step', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackBackwardStep,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackCirclePause',
        title: __('Mediaplayback Circle Pause', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackCirclePause,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackCirclePlay',
        title: __('Mediaplayback Circle Play', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackCirclePlay,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackCircleStop',
        title: __('Mediaplayback Circle Stop', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackCircleStop,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackCompress',
        title: __('Mediaplayback Compress', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackCompress,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackDownLeftAndUpRightToCenter',
        title: __('Mediaplayback Down Left And Up Right To Center', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackDownLeftAndUpRightToCenter,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackEject',
        title: __('Mediaplayback Eject', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackEject,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackExpand',
        title: __('Mediaplayback Expand', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackExpand,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackForwardFast',
        title: __('Mediaplayback Forward Fast', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackForwardFast,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackForward',
        title: __('Mediaplayback Forward', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackForward,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackForwardStep',
        title: __('Mediaplayback Forward Step', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackForwardStep,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackHand',
        title: __('Mediaplayback Hand', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackHand,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackMaximize',
        title: __('Mediaplayback Maximize', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackMaximize,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackMinimize',
        title: __('Mediaplayback Minimize', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackMinimize,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackMusic',
        title: __('Mediaplayback Music', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackMusic,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackPause',
        title: __('Mediaplayback Pause', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackPause,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackPhoneVolume',
        title: __('Mediaplayback Phone Volume', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackPhoneVolume,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackPlay',
        title: __('Mediaplayback Play', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackPlay,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackPlusMinus',
        title: __('Mediaplayback Plus Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackPlusMinus,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackRepeat',
        title: __('Mediaplayback Repeat', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackRepeat,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackRotate',
        title: __('Mediaplayback Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackRotate,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackRotateLeft',
        title: __('Mediaplayback Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackRotateLeft,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackRotateRight',
        title: __('Mediaplayback Rotate Right', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackRotateRight,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackRss',
        title: __('Mediaplayback Rss', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackRss,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackShuffle',
        title: __('Mediaplayback Shuffle', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackShuffle,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackSliders',
        title: __('Mediaplayback Sliders', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackSliders,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackStop',
        title: __('Mediaplayback Stop', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackStop,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackUpRightAndDownLeftFromCenter',
        title: __('Mediaplayback Up Right And Down Left From Center', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackUpRightAndDownLeftFromCenter,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackVolumeHigh',
        title: __('Mediaplayback Volume High', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackVolumeHigh,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackVolumeLow',
        title: __('Mediaplayback Volume Low', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackVolumeLow,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackVolumeOff',
        title: __('Mediaplayback Volume Off', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackVolumeOff,
        categories: ['media-playback'],
    },
    {
        name: 'iconFontAwesomeMediaplaybackVolumeXmark',
        title: __('Mediaplayback Volume Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMediaplaybackVolumeXmark,
        categories: ['media-playback'],
    },
];

// medical+health
import {
    iconFontAwesomeMedicalHealthAccessibleIcon,
    iconFontAwesomeMedicalHealthBacteria,
    iconFontAwesomeMedicalHealthBacterium,
    iconFontAwesomeMedicalHealthBandage,
    iconFontAwesomeMedicalHealthBanSmoking,
    iconFontAwesomeMedicalHealthBedPulse,
    iconFontAwesomeMedicalHealthBiohazard,
    iconFontAwesomeMedicalHealthBone,
    iconFontAwesomeMedicalHealthBong,
    iconFontAwesomeMedicalHealthBookMedical,
    iconFontAwesomeMedicalHealthBrain,
    iconFontAwesomeMedicalHealthBriefcaseMedical,
    iconFontAwesomeMedicalHealthCannabis,
    iconFontAwesomeMedicalHealthCapsules,
    iconFontAwesomeMedicalHealthCircleH,
    iconFontAwesomeMedicalHealthCircleRadiation,
    iconFontAwesomeMedicalHealthClipboardUser,
    iconFontAwesomeMedicalHealthClockRotateLeft,
    iconFontAwesomeMedicalHealthCommentMedical,
    iconFontAwesomeMedicalHealthCrutch,
    iconFontAwesomeMedicalHealthDisease,
    iconFontAwesomeMedicalHealthDna,
    iconFontAwesomeMedicalHealthDroplet,
    iconFontAwesomeMedicalHealthDropletSlash,
    iconFontAwesomeMedicalHealthEyeDropper,
    iconFontAwesomeMedicalHealthEye,
    iconFontAwesomeMedicalHealthFileMedical,
    iconFontAwesomeMedicalHealthFilePrescription,
    iconFontAwesomeMedicalHealthFileWaveform,
    iconFontAwesomeMedicalHealthFireFlameSimple,
    iconFontAwesomeMedicalHealthFlask,
    iconFontAwesomeMedicalHealthFlaskVial,
    iconFontAwesomeMedicalHealthHandDots,
    iconFontAwesomeMedicalHealthHandHoldingDroplet,
    iconFontAwesomeMedicalHealthHandHoldingMedical,
    iconFontAwesomeMedicalHealthHeadSideCough,
    iconFontAwesomeMedicalHealthHeadSideCoughSlash,
    iconFontAwesomeMedicalHealthHeadSideMask,
    iconFontAwesomeMedicalHealthHeadSideVirus,
    iconFontAwesomeMedicalHealthHeartCircleBolt,
    iconFontAwesomeMedicalHealthHeartCircleCheck,
    iconFontAwesomeMedicalHealthHeartCircleExclamation,
    iconFontAwesomeMedicalHealthHeartCircleMinus,
    iconFontAwesomeMedicalHealthHeartCirclePlus,
    iconFontAwesomeMedicalHealthHeartCircleXmark,
    iconFontAwesomeMedicalHealthHeart,
    iconFontAwesomeMedicalHealthHeartPulse,
    iconFontAwesomeMedicalHealthHospital,
    iconFontAwesomeMedicalHealthHospitalUser,
    iconFontAwesomeMedicalHealthHouseChimneyMedical,
    iconFontAwesomeMedicalHealthHouseMedicalCircleCheck,
    iconFontAwesomeMedicalHealthHouseMedicalCircleExclamation,
    iconFontAwesomeMedicalHealthHouseMedicalCircleXmark,
    iconFontAwesomeMedicalHealthHouseMedicalFlag,
    iconFontAwesomeMedicalHealthHouseMedical,
    iconFontAwesomeMedicalHealthIdCardClip,
    iconFontAwesomeMedicalHealthJoint,
    iconFontAwesomeMedicalHealthKitMedical,
    iconFontAwesomeMedicalHealthLaptopMedical,
    iconFontAwesomeMedicalHealthLungs,
    iconFontAwesomeMedicalHealthLungsVirus,
    iconFontAwesomeMedicalHealthMaskFace,
    iconFontAwesomeMedicalHealthMaskVentilator,
    iconFontAwesomeMedicalHealthMicroscope,
    iconFontAwesomeMedicalHealthMortarPestle,
    iconFontAwesomeMedicalHealthNotesMedical,
    iconFontAwesomeMedicalHealthPager,
    iconFontAwesomeMedicalHealthPersonBreastfeeding,
    iconFontAwesomeMedicalHealthPersonCane,
    iconFontAwesomeMedicalHealthPersonDotsFromLine,
    iconFontAwesomeMedicalHealthPersonHalfDress,
    iconFontAwesomeMedicalHealthPills,
    iconFontAwesomeMedicalHealthPlus,
    iconFontAwesomeMedicalHealthPoop,
    iconFontAwesomeMedicalHealthPrescriptionBottle,
    iconFontAwesomeMedicalHealthPrescriptionBottleMedical,
    iconFontAwesomeMedicalHealthPrescription,
    iconFontAwesomeMedicalHealthPumpMedical,
    iconFontAwesomeMedicalHealthRadiation,
    iconFontAwesomeMedicalHealthReceipt,
    iconFontAwesomeMedicalHealthShieldVirus,
    iconFontAwesomeMedicalHealthSkullCrossbones,
    iconFontAwesomeMedicalHealthSkull,
    iconFontAwesomeMedicalHealthSmoking,
    iconFontAwesomeMedicalHealthSquareH,
    iconFontAwesomeMedicalHealthSquarePlus,
    iconFontAwesomeMedicalHealthSquareVirus,
    iconFontAwesomeMedicalHealthStaffSnake,
    iconFontAwesomeMedicalHealthStarOfLife,
    iconFontAwesomeMedicalHealthStethoscope,
    iconFontAwesomeMedicalHealthSuitcaseMedical,
    iconFontAwesomeMedicalHealthSyringe,
    iconFontAwesomeMedicalHealthTablets,
    iconFontAwesomeMedicalHealthTeeth,
    iconFontAwesomeMedicalHealthTeethOpen,
    iconFontAwesomeMedicalHealthThermometer,
    iconFontAwesomeMedicalHealthTooth,
    iconFontAwesomeMedicalHealthTruckDroplet,
    iconFontAwesomeMedicalHealthTruckMedical,
    iconFontAwesomeMedicalHealthUserDoctor,
    iconFontAwesomeMedicalHealthUserNurse,
    iconFontAwesomeMedicalHealthVialCircleCheck,
    iconFontAwesomeMedicalHealthVial,
    iconFontAwesomeMedicalHealthVials,
    iconFontAwesomeMedicalHealthVialVirus,
    iconFontAwesomeMedicalHealthVirusCovid,
    iconFontAwesomeMedicalHealthVirusCovidSlash,
    iconFontAwesomeMedicalHealthViruses,
    iconFontAwesomeMedicalHealthVirus,
    iconFontAwesomeMedicalHealthVirusSlash,
    iconFontAwesomeMedicalHealthWeightScale,
    iconFontAwesomeMedicalHealthWheelchair,
    iconFontAwesomeMedicalHealthWheelchairMove,
    iconFontAwesomeMedicalHealthXRay,
} from './medical+health';

// medical+health
const medicalHealthIcons = [
    {
        name: 'iconFontAwesomeMedicalHealthAccessibleIcon',
        title: __('Accessible Icon', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthAccessibleIcon,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBacteria',
        title: __('Bacteria', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBacteria,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBacterium',
        title: __('Bacterium', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBacterium,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBandage',
        title: __('Bandage', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBandage,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBanSmoking',
        title: __('Ban Smoking', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBanSmoking,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBedPulse',
        title: __('Bed Pulse', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBedPulse,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBiohazard',
        title: __('Biohazard', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBiohazard,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBone',
        title: __('Bone', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBone,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBong',
        title: __('Bong', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBong,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBookMedical',
        title: __('Book Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBookMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBrain',
        title: __('Brain', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBrain,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthBriefcaseMedical',
        title: __('Briefcase Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthBriefcaseMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthCannabis',
        title: __('Cannabis', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthCannabis,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthCapsules',
        title: __('Capsules', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthCapsules,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthCircleH',
        title: __('Circle H', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthCircleH,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthCircleRadiation',
        title: __('Circle Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthCircleRadiation,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthClipboardUser',
        title: __('Clipboard User', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthClipboardUser,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthClockRotateLeft',
        title: __('Clock Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthClockRotateLeft,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthCommentMedical',
        title: __('Comment Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthCommentMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthCrutch',
        title: __('Crutch', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthCrutch,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthDisease',
        title: __('Disease', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthDisease,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthDna',
        title: __('Dna', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthDna,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthDroplet',
        title: __('Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthDroplet,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthDropletSlash',
        title: __('Droplet Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthDropletSlash,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthEyeDropper',
        title: __('Eye Dropper', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthEyeDropper,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthEye',
        title: __('Eye', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthEye,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthFileMedical',
        title: __('File Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthFileMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthFilePrescription',
        title: __('File Prescription', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthFilePrescription,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthFileWaveform',
        title: __('File Waveform', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthFileWaveform,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthFireFlameSimple',
        title: __('Fire Flame Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthFireFlameSimple,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthFlask',
        title: __('Flask', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthFlask,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthFlaskVial',
        title: __('Flask Vial', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthFlaskVial,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHandDots',
        title: __('Hand Dots', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHandDots,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHandHoldingDroplet',
        title: __('Hand Holding Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHandHoldingDroplet,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHandHoldingMedical',
        title: __('Hand Holding Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHandHoldingMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeadSideCough',
        title: __('Head Side Cough', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeadSideCough,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeadSideCoughSlash',
        title: __('Head Side Cough Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeadSideCoughSlash,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeadSideMask',
        title: __('Head Side Mask', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeadSideMask,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeadSideVirus',
        title: __('Head Side Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeadSideVirus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeartCircleBolt',
        title: __('Heart Circle Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeartCircleBolt,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeartCircleCheck',
        title: __('Heart Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeartCircleCheck,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeartCircleExclamation',
        title: __('Heart Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeartCircleExclamation,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeartCircleMinus',
        title: __('Heart Circle Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeartCircleMinus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeartCirclePlus',
        title: __('Heart Circle Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeartCirclePlus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeartCircleXmark',
        title: __('Heart Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeartCircleXmark,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeart,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHeartPulse',
        title: __('Heart Pulse', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHeartPulse,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHospital',
        title: __('Hospital', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHospital,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHospitalUser',
        title: __('Hospital User', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHospitalUser,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHouseChimneyMedical',
        title: __('House Chimney Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHouseChimneyMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHouseMedicalCircleCheck',
        title: __('House Medical Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHouseMedicalCircleCheck,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHouseMedicalCircleExclamation',
        title: __('House Medical Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHouseMedicalCircleExclamation,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHouseMedicalCircleXmark',
        title: __('House Medical Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHouseMedicalCircleXmark,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHouseMedicalFlag',
        title: __('House Medical Flag', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHouseMedicalFlag,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthHouseMedical',
        title: __('House Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthHouseMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthIdCardClip',
        title: __('Id Card Clip', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthIdCardClip,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthJoint',
        title: __('Joint', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthJoint,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthKitMedical',
        title: __('Kit Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthKitMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthLaptopMedical',
        title: __('Laptop Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthLaptopMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthLungs',
        title: __('Lungs', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthLungs,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthLungsVirus',
        title: __('Lungs Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthLungsVirus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthMaskFace',
        title: __('Mask Face', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthMaskFace,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthMaskVentilator',
        title: __('Mask Ventilator', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthMaskVentilator,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthMicroscope',
        title: __('Microscope', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthMicroscope,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthMortarPestle',
        title: __('Mortar Pestle', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthMortarPestle,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthNotesMedical',
        title: __('Notes Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthNotesMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPager',
        title: __('Pager', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPager,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPersonBreastfeeding',
        title: __('Person Breastfeeding', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPersonBreastfeeding,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPersonCane',
        title: __('Person Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPersonCane,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPersonDotsFromLine',
        title: __('Person Dots From Line', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPersonDotsFromLine,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPersonHalfDress',
        title: __('Person Half Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPersonHalfDress,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPills',
        title: __('Pills', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPills,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPlus',
        title: __('Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPlus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPoop',
        title: __('Poop', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPoop,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPrescriptionBottle',
        title: __('Prescription Bottle', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPrescriptionBottle,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPrescriptionBottleMedical',
        title: __('Prescription Bottle Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPrescriptionBottleMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPrescription',
        title: __('Prescription', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPrescription,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthPumpMedical',
        title: __('Pump Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthPumpMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthRadiation',
        title: __('Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthRadiation,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthReceipt',
        title: __('Receipt', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthReceipt,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthShieldVirus',
        title: __('Shield Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthShieldVirus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSkullCrossbones',
        title: __('Skull Crossbones', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSkullCrossbones,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSkull',
        title: __('Skull', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSkull,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSmoking',
        title: __('Smoking', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSmoking,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSquareH',
        title: __('Square H', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSquareH,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSquarePlus',
        title: __('Square Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSquarePlus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSquareVirus',
        title: __('Square Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSquareVirus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthStaffSnake',
        title: __('Staff Snake', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthStaffSnake,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthStarOfLife',
        title: __('Star Of Life', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthStarOfLife,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthStethoscope',
        title: __('Stethoscope', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthStethoscope,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSuitcaseMedical',
        title: __('Suitcase Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSuitcaseMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthSyringe',
        title: __('Syringe', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthSyringe,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthTablets',
        title: __('Tablets', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthTablets,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthTeeth',
        title: __('Teeth', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthTeeth,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthTeethOpen',
        title: __('Teeth Open', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthTeethOpen,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthThermometer',
        title: __('Thermometer', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthThermometer,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthTooth',
        title: __('Tooth', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthTooth,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthTruckDroplet',
        title: __('Truck Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthTruckDroplet,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthTruckMedical',
        title: __('Truck Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthTruckMedical,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthUserDoctor',
        title: __('User Doctor', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthUserDoctor,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthUserNurse',
        title: __('User Nurse', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthUserNurse,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVialCircleCheck',
        title: __('Vial Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVialCircleCheck,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVial',
        title: __('Vial', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVial,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVials',
        title: __('Vials', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVials,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVialVirus',
        title: __('Vial Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVialVirus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVirusCovid',
        title: __('Virus Covid', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVirusCovid,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVirusCovidSlash',
        title: __('Virus Covid Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVirusCovidSlash,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthViruses',
        title: __('Viruses', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthViruses,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVirus',
        title: __('Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVirus,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthVirusSlash',
        title: __('Virus Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthVirusSlash,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthWeightScale',
        title: __('Weight Scale', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthWeightScale,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthWheelchair',
        title: __('Wheelchair', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthWheelchair,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthWheelchairMove',
        title: __('Wheelchair Move', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthWheelchairMove,
        categories: ['medical+health'],
    },
    {
        name: 'iconFontAwesomeMedicalHealthXRay',
        title: __('XRay', 'icon-font-awesome'),
        icon: iconFontAwesomeMedicalHealthXRay,
        categories: ['medical+health'],
    },
];

// money
import {
    iconFontAwesomeMoneyAustralSign,
    iconFontAwesomeMoneyBahtSign,
    iconFontAwesomeMoneyBangladeshiTakaSign,
    iconFontAwesomeMoneyBitcoin,
    iconFontAwesomeMoneyBitcoinSign,
    iconFontAwesomeMoneyBrazilianRealSign,
    iconFontAwesomeMoneyBtc,
    iconFontAwesomeMoneyCashRegister,
    iconFontAwesomeMoneyCediSign,
    iconFontAwesomeMoneyCentSign,
    iconFontAwesomeMoneyChartLine,
    iconFontAwesomeMoneyChartPie,
    iconFontAwesomeMoneyCircleDollarToSlot,
    iconFontAwesomeMoneyCoins,
    iconFontAwesomeMoneyColonSign,
    iconFontAwesomeMoneyCommentDollar,
    iconFontAwesomeMoneyCommentsDollar,
    iconFontAwesomeMoneyCreditCard,
    iconFontAwesomeMoneyCruzeiroSign,
    iconFontAwesomeMoneyDollarSign,
    iconFontAwesomeMoneyDongSign,
    iconFontAwesomeMoneyEthereum,
    iconFontAwesomeMoneyEuroSign,
    iconFontAwesomeMoneyFileInvoiceDollar,
    iconFontAwesomeMoneyFileInvoice,
    iconFontAwesomeMoneyFlorinSign,
    iconFontAwesomeMoneyFrancSign,
    iconFontAwesomeMoneyGgCircle,
    iconFontAwesomeMoneyGg,
    iconFontAwesomeMoneyGuaraniSign,
    iconFontAwesomeMoneyHandHoldingDollar,
    iconFontAwesomeMoneyHryvniaSign,
    iconFontAwesomeMoneyIndianRupeeSign,
    iconFontAwesomeMoneyKipSign,
    iconFontAwesomeMoneyLandmark,
    iconFontAwesomeMoneyLariSign,
    iconFontAwesomeMoneyLiraSign,
    iconFontAwesomeMoneyLitecoinSign,
    iconFontAwesomeMoneyManatSign,
    iconFontAwesomeMoneyMillSign,
    iconFontAwesomeMoneyMoneyBill1,
    iconFontAwesomeMoneyMoneyBill1Wave,
    iconFontAwesomeMoneyMoneyBill,
    iconFontAwesomeMoneyMoneyBills,
    iconFontAwesomeMoneyMoneyBillTransfer,
    iconFontAwesomeMoneyMoneyBillTrendUp,
    iconFontAwesomeMoneyMoneyBillWave,
    iconFontAwesomeMoneyMoneyBillWheat,
    iconFontAwesomeMoneyMoneyCheckDollar,
    iconFontAwesomeMoneyMoneyCheck,
    iconFontAwesomeMoneyNairaSign,
    iconFontAwesomeMoneyPercent,
    iconFontAwesomeMoneyPesetaSign,
    iconFontAwesomeMoneyPesoSign,
    iconFontAwesomeMoneyPiggyBank,
    iconFontAwesomeMoneyReceipt,
    iconFontAwesomeMoneyRubleSign,
    iconFontAwesomeMoneyRupeeSign,
    iconFontAwesomeMoneyRupiahSign,
    iconFontAwesomeMoneySackDollar,
    iconFontAwesomeMoneySackXmark,
    iconFontAwesomeMoneyScaleBalanced,
    iconFontAwesomeMoneyScaleUnbalancedFlip,
    iconFontAwesomeMoneyScaleUnbalanced,
    iconFontAwesomeMoneyShekelSign,
    iconFontAwesomeMoneyStamp,
    iconFontAwesomeMoneySterlingSign,
    iconFontAwesomeMoneyTengeSign,
    iconFontAwesomeMoneyTurkishLiraSign,
    iconFontAwesomeMoneyVault,
    iconFontAwesomeMoneyWallet,
    iconFontAwesomeMoneyWonSign,
    iconFontAwesomeMoneyYenSign,
} from './money';

// money
const moneyIcons = [
    {
        name: 'iconFontAwesomeMoneyAustralSign',
        title: __('Austral Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyAustralSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyBahtSign',
        title: __('Baht Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyBahtSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyBangladeshiTakaSign',
        title: __('Bangladeshi Taka Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyBangladeshiTakaSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyBitcoin',
        title: __('Bitcoin', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyBitcoin,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyBitcoinSign',
        title: __('Bitcoin Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyBitcoinSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyBrazilianRealSign',
        title: __('Brazilian Real Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyBrazilianRealSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyBtc',
        title: __('Btc', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyBtc,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCashRegister',
        title: __('Cash Register', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCashRegister,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCediSign',
        title: __('Cedi Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCediSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCentSign',
        title: __('Cent Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCentSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyChartLine',
        title: __('Chart Line', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyChartLine,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyChartPie',
        title: __('Chart Pie', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyChartPie,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCircleDollarToSlot',
        title: __('Circle Dollar To Slot', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCircleDollarToSlot,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCoins',
        title: __('Coins', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCoins,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyColonSign',
        title: __('Colon Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyColonSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCommentDollar',
        title: __('Comment Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCommentDollar,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCommentsDollar',
        title: __('Comments Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCommentsDollar,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCreditCard',
        title: __('Credit Card', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCreditCard,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyCruzeiroSign',
        title: __('Cruzeiro Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyCruzeiroSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyDollarSign',
        title: __('Dollar Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyDollarSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyDongSign',
        title: __('Dong Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyDongSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyEthereum',
        title: __('Ethereum', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyEthereum,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyEuroSign',
        title: __('Euro Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyEuroSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyFileInvoiceDollar',
        title: __('File Invoice Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyFileInvoiceDollar,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyFileInvoice',
        title: __('File Invoice', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyFileInvoice,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyFlorinSign',
        title: __('Florin Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyFlorinSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyFrancSign',
        title: __('Franc Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyFrancSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyGgCircle',
        title: __('Gg Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyGgCircle,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyGg',
        title: __('Gg', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyGg,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyGuaraniSign',
        title: __('Guarani Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyGuaraniSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyHandHoldingDollar',
        title: __('Hand Holding Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyHandHoldingDollar,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyHryvniaSign',
        title: __('Hryvnia Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyHryvniaSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyIndianRupeeSign',
        title: __('Indian Rupee Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyIndianRupeeSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyKipSign',
        title: __('Kip Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyKipSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyLandmark',
        title: __('Landmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyLandmark,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyLariSign',
        title: __('Lari Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyLariSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyLiraSign',
        title: __('Lira Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyLiraSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyLitecoinSign',
        title: __('Litecoin Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyLitecoinSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyManatSign',
        title: __('Manat Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyManatSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMillSign',
        title: __('Mill Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMillSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBill1',
        title: __('Bill1', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBill1,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBill1Wave',
        title: __('Bill1Wave', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBill1Wave,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBill',
        title: __('Bill', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBill,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBills',
        title: __('Bills', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBills,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBillTransfer',
        title: __('Bill Transfer', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBillTransfer,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBillTrendUp',
        title: __('Bill Trend Up', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBillTrendUp,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBillWave',
        title: __('Bill Wave', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBillWave,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyBillWheat',
        title: __('Bill Wheat', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyBillWheat,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyCheckDollar',
        title: __('Check Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyCheckDollar,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyMoneyCheck',
        title: __('Check', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyMoneyCheck,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyNairaSign',
        title: __('Naira Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyNairaSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyPercent',
        title: __('Percent', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyPercent,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyPesetaSign',
        title: __('Peseta Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyPesetaSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyPesoSign',
        title: __('Peso Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyPesoSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyPiggyBank',
        title: __('Piggy Bank', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyPiggyBank,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyReceipt',
        title: __('Receipt', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyReceipt,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyRubleSign',
        title: __('Ruble Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyRubleSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyRupeeSign',
        title: __('Rupee Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyRupeeSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyRupiahSign',
        title: __('Rupiah Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyRupiahSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneySackDollar',
        title: __('Sack Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneySackDollar,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneySackXmark',
        title: __('Sack Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneySackXmark,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyScaleBalanced',
        title: __('Scale Balanced', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyScaleBalanced,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyScaleUnbalancedFlip',
        title: __('Scale Unbalanced Flip', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyScaleUnbalancedFlip,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyScaleUnbalanced',
        title: __('Scale Unbalanced', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyScaleUnbalanced,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyShekelSign',
        title: __('Shekel Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyShekelSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyStamp',
        title: __('Stamp', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyStamp,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneySterlingSign',
        title: __('Sterling Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneySterlingSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyTengeSign',
        title: __('Tenge Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyTengeSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyTurkishLiraSign',
        title: __('Turkish Lira Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyTurkishLiraSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyVault',
        title: __('Vault', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyVault,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyWallet',
        title: __('Wallet', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyWallet,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyWonSign',
        title: __('Won Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyWonSign,
        categories: ['money'],
    },
    {
        name: 'iconFontAwesomeMoneyYenSign',
        title: __('Yen Sign', 'icon-font-awesome'),
        icon: iconFontAwesomeMoneyYenSign,
        categories: ['money'],
    },
];

// moving
import {
    iconFontAwesomeMovingBoxArchive,
    iconFontAwesomeMovingBoxesPacking,
    iconFontAwesomeMovingBoxOpen,
    iconFontAwesomeMovingCaravan,
    iconFontAwesomeMovingCouch,
    iconFontAwesomeMovingDolly,
    iconFontAwesomeMovingHouseChimney,
    iconFontAwesomeMovingPeopleCarryBox,
    iconFontAwesomeMovingRoute,
    iconFontAwesomeMovingSignHanging,
    iconFontAwesomeMovingSuitcase,
    iconFontAwesomeMovingTape,
    iconFontAwesomeMovingTrailer,
    iconFontAwesomeMovingTruckMoving,
    iconFontAwesomeMovingTruckRampBox,
    iconFontAwesomeMovingWineGlass,
} from './moving';

// moving
const movingIcons = [
    {
        name: 'iconFontAwesomeMovingBoxArchive',
        title: __('Box Archive', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingBoxArchive,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingBoxesPacking',
        title: __('Boxes Packing', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingBoxesPacking,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingBoxOpen',
        title: __('Box Open', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingBoxOpen,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingCaravan',
        title: __('Caravan', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingCaravan,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingCouch',
        title: __('Couch', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingCouch,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingDolly',
        title: __('Dolly', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingDolly,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingHouseChimney',
        title: __('House Chimney', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingHouseChimney,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingPeopleCarryBox',
        title: __('People Carry Box', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingPeopleCarryBox,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingRoute',
        title: __('Route', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingRoute,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingSignHanging',
        title: __('Sign Hanging', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingSignHanging,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingSuitcase',
        title: __('Suitcase', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingSuitcase,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingTape',
        title: __('Tape', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingTape,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingTrailer',
        title: __('Trailer', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingTrailer,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingTruckMoving',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingTruckMoving,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingTruckRampBox',
        title: __('Truck Ramp Box', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingTruckRampBox,
        categories: ['moving'],
    },
    {
        name: 'iconFontAwesomeMovingWineGlass',
        title: __('Wine Glass', 'icon-font-awesome'),
        icon: iconFontAwesomeMovingWineGlass,
        categories: ['moving'],
    },
];

// music+video
import {
    iconFontAwesomeMusicVideoCompactDisc,
    iconFontAwesomeMusicVideoDrum,
    iconFontAwesomeMusicVideoDrumSteelpan,
    iconFontAwesomeMusicVideoFileAudio,
    iconFontAwesomeMusicVideoGuitar,
    iconFontAwesomeMusicVideoHeadphones,
    iconFontAwesomeMusicVideoHeadphonesSimple,
    iconFontAwesomeMusicVideoMicrophone,
    iconFontAwesomeMusicVideoMicrophoneLines,
    iconFontAwesomeMusicVideoMicrophoneLinesSlash,
    iconFontAwesomeMusicVideoMicrophoneSlash,
    iconFontAwesomeMusicVideoMusic,
    iconFontAwesomeMusicVideoNapster,
    iconFontAwesomeMusicVideoRadio,
    iconFontAwesomeMusicVideoRecordVinyl,
    iconFontAwesomeMusicVideoSliders,
    iconFontAwesomeMusicVideoSoundcloud,
    iconFontAwesomeMusicVideoSpotify,
    iconFontAwesomeMusicVideoVolumeHigh,
    iconFontAwesomeMusicVideoVolumeLow,
    iconFontAwesomeMusicVideoVolumeOff,
    iconFontAwesomeMusicVideoVolumeXmark,
    iconFontAwesomeMusicVideoWaveSquare,
} from './music+video';

// music+video
const musicVideoIcons = [
    {
        name: 'iconFontAwesomeMusicVideoCompactDisc',
        title: __('Compact Disc', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoCompactDisc,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoDrum',
        title: __('Drum', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoDrum,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoDrumSteelpan',
        title: __('Drum Steelpan', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoDrumSteelpan,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoFileAudio',
        title: __('File Audio', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoFileAudio,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoGuitar',
        title: __('Guitar', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoGuitar,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoHeadphones',
        title: __('Headphones', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoHeadphones,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoHeadphonesSimple',
        title: __('Headphones Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoHeadphonesSimple,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoMicrophone',
        title: __('Microphone', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoMicrophone,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoMicrophoneLines',
        title: __('Microphone Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoMicrophoneLines,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoMicrophoneLinesSlash',
        title: __('Microphone Lines Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoMicrophoneLinesSlash,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoMicrophoneSlash',
        title: __('Microphone Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoMicrophoneSlash,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoMusic',
        title: __('Music', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoMusic,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoNapster',
        title: __('Napster', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoNapster,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoRadio',
        title: __('Radio', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoRadio,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoRecordVinyl',
        title: __('Record Vinyl', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoRecordVinyl,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoSliders',
        title: __('Sliders', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoSliders,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoSoundcloud',
        title: __('Soundcloud', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoSoundcloud,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoSpotify',
        title: __('Spotify', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoSpotify,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoVolumeHigh',
        title: __('Volume High', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoVolumeHigh,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoVolumeLow',
        title: __('Volume Low', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoVolumeLow,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoVolumeOff',
        title: __('Volume Off', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoVolumeOff,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoVolumeXmark',
        title: __('Volume Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoVolumeXmark,
        categories: ['music+video'],
    },
    {
        name: 'iconFontAwesomeMusicVideoWaveSquare',
        title: __('Wave Square', 'icon-font-awesome'),
        icon: iconFontAwesomeMusicVideoWaveSquare,
        categories: ['music+video'],
    },
];

// nature
import {
    iconFontAwesomeNatureBinoculars,
    iconFontAwesomeNatureBug,
    iconFontAwesomeNatureBugs,
    iconFontAwesomeNatureCannabis,
    iconFontAwesomeNatureCloudSun,
    iconFontAwesomeNatureClover,
    iconFontAwesomeNatureFeather,
    iconFontAwesomeNatureFeatherPointed,
    iconFontAwesomeNatureFire,
    iconFontAwesomeNatureFrog,
    iconFontAwesomeNatureIcicles,
    iconFontAwesomeNatureLeaf,
    iconFontAwesomeNatureLocust,
    iconFontAwesomeNatureMosquito,
    iconFontAwesomeNatureMound,
    iconFontAwesomeNatureMountainCity,
    iconFontAwesomeNatureMountain,
    iconFontAwesomeNatureMountainSun,
    iconFontAwesomeNaturePersonHiking,
    iconFontAwesomeNaturePlantWilt,
    iconFontAwesomeNatureSeedling,
    iconFontAwesomeNatureSignsPost,
    iconFontAwesomeNatureSpider,
    iconFontAwesomeNatureTree,
    iconFontAwesomeNatureVolcano,
    iconFontAwesomeNatureWater,
    iconFontAwesomeNatureWind,
    iconFontAwesomeNatureWorm,
} from './nature';

// nature
const natureIcons = [
    {
        name: 'iconFontAwesomeNatureBinoculars',
        title: __('Binoculars', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureBinoculars,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureBug',
        title: __('Bug', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureBug,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureBugs',
        title: __('Bugs', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureBugs,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureCannabis',
        title: __('Cannabis', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureCannabis,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureCloudSun',
        title: __('Cloud Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureCloudSun,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureClover',
        title: __('Clover', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureClover,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureFeather',
        title: __('Feather', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureFeather,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureFeatherPointed',
        title: __('Feather Pointed', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureFeatherPointed,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureFire',
        title: __('Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureFire,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureFrog',
        title: __('Frog', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureFrog,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureIcicles',
        title: __('Icicles', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureIcicles,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureLeaf',
        title: __('Leaf', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureLeaf,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureLocust',
        title: __('Locust', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureLocust,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureMosquito',
        title: __('Mosquito', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureMosquito,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureMound',
        title: __('Mound', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureMound,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureMountainCity',
        title: __('Mountain City', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureMountainCity,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureMountain',
        title: __('Mountain', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureMountain,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureMountainSun',
        title: __('Mountain Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureMountainSun,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNaturePersonHiking',
        title: __('Person Hiking', 'icon-font-awesome'),
        icon: iconFontAwesomeNaturePersonHiking,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNaturePlantWilt',
        title: __('Plant Wilt', 'icon-font-awesome'),
        icon: iconFontAwesomeNaturePlantWilt,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureSeedling',
        title: __('Seedling', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureSeedling,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureSignsPost',
        title: __('Signs Post', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureSignsPost,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureSpider',
        title: __('Spider', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureSpider,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureTree',
        title: __('Tree', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureTree,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureVolcano',
        title: __('Volcano', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureVolcano,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureWater',
        title: __('Water', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureWater,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureWind',
        title: __('Wind', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureWind,
        categories: ['nature'],
    },
    {
        name: 'iconFontAwesomeNatureWorm',
        title: __('Worm', 'icon-font-awesome'),
        icon: iconFontAwesomeNatureWorm,
        categories: ['nature'],
    },
];

// numbers
import {
    iconFontAwesomeNumbers0,
    iconFontAwesomeNumbers1,
    iconFontAwesomeNumbers2,
    iconFontAwesomeNumbers3,
    iconFontAwesomeNumbers4,
    iconFontAwesomeNumbers5,
    iconFontAwesomeNumbers6,
    iconFontAwesomeNumbers7,
    iconFontAwesomeNumbers8,
    iconFontAwesomeNumbers9,
} from './numbers';

// numbers
const numbersIcons = [
    {
        name: 'iconFontAwesomeNumbers0',
        title: __('0', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers0,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers1',
        title: __('1', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers1,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers2',
        title: __('2', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers2,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers3',
        title: __('3', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers3,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers4',
        title: __('4', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers4,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers5',
        title: __('5', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers5,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers6',
        title: __('6', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers6,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers7',
        title: __('7', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers7,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers8',
        title: __('8', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers8,
        categories: ['numbers'],
    },
    {
        name: 'iconFontAwesomeNumbers9',
        title: __('9', 'icon-font-awesome'),
        icon: iconFontAwesomeNumbers9,
        categories: ['numbers'],
    },
];

// photos+images
import {
    iconFontAwesomePhotosImagesBolt,
    iconFontAwesomePhotosImagesBoltLightning,
    iconFontAwesomePhotosImagesCamera,
    iconFontAwesomePhotosImagesCameraRetro,
    iconFontAwesomePhotosImagesCameraRotate,
    iconFontAwesomePhotosImagesChalkboard,
    iconFontAwesomePhotosImagesCircleHalfStroke,
    iconFontAwesomePhotosImagesClone,
    iconFontAwesomePhotosImagesDroplet,
    iconFontAwesomePhotosImagesEyeDropper,
    iconFontAwesomePhotosImagesEye,
    iconFontAwesomePhotosImagesEyeSlash,
    iconFontAwesomePhotosImagesFileImage,
    iconFontAwesomePhotosImagesFilm,
    iconFontAwesomePhotosImagesIdBadge,
    iconFontAwesomePhotosImagesIdCard,
    iconFontAwesomePhotosImagesImage,
    iconFontAwesomePhotosImagesImagePortrait,
    iconFontAwesomePhotosImagesImages,
    iconFontAwesomePhotosImagesMinimize,
    iconFontAwesomePhotosImagesPanorama,
    iconFontAwesomePhotosImagesPhotoFilm,
    iconFontAwesomePhotosImagesSliders,
    iconFontAwesomePhotosImagesUnsplash,
} from './photos+images';

// photos+images
const photosImagesIcons = [
    {
        name: 'iconFontAwesomePhotosImagesBolt',
        title: __('Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesBolt,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesBoltLightning',
        title: __('Bolt Lightning', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesBoltLightning,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesCamera',
        title: __('Camera', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesCamera,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesCameraRetro',
        title: __('Camera Retro', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesCameraRetro,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesCameraRotate',
        title: __('Camera Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesCameraRotate,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesChalkboard',
        title: __('Chalkboard', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesChalkboard,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesCircleHalfStroke',
        title: __('Circle Half Stroke', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesCircleHalfStroke,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesClone',
        title: __('Clone', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesClone,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesDroplet',
        title: __('Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesDroplet,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesEyeDropper',
        title: __('Eye Dropper', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesEyeDropper,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesEye',
        title: __('Eye', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesEye,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesEyeSlash',
        title: __('Eye Slash', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesEyeSlash,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesFileImage',
        title: __('File Image', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesFileImage,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesFilm',
        title: __('Film', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesFilm,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesIdBadge',
        title: __('Id Badge', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesIdBadge,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesIdCard',
        title: __('Id Card', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesIdCard,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesImage',
        title: __('Image', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesImage,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesImagePortrait',
        title: __('Image Portrait', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesImagePortrait,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesImages',
        title: __('Images', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesImages,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesMinimize',
        title: __('Minimize', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesMinimize,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesPanorama',
        title: __('Panorama', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesPanorama,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesPhotoFilm',
        title: __('Photo Film', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesPhotoFilm,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesSliders',
        title: __('Sliders', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesSliders,
        categories: ['photos+images'],
    },
    {
        name: 'iconFontAwesomePhotosImagesUnsplash',
        title: __('Unsplash', 'icon-font-awesome'),
        icon: iconFontAwesomePhotosImagesUnsplash,
        categories: ['photos+images'],
    },
];

// political
import {
    iconFontAwesomePoliticalAward,
    iconFontAwesomePoliticalBuildingFlag,
    iconFontAwesomePoliticalBullhorn,
    iconFontAwesomePoliticalCheckDouble,
    iconFontAwesomePoliticalCheckToSlot,
    iconFontAwesomePoliticalCircleDollarToSlot,
    iconFontAwesomePoliticalDemocrat,
    iconFontAwesomePoliticalDove,
    iconFontAwesomePoliticalDumpsterFire,
    iconFontAwesomePoliticalFlagUsa,
    iconFontAwesomePoliticalHandFist,
    iconFontAwesomePoliticalHandshake,
    iconFontAwesomePoliticalLandmarkDome,
    iconFontAwesomePoliticalLandmarkFlag,
    iconFontAwesomePoliticalPersonBooth,
    iconFontAwesomePoliticalPiggyBank,
    iconFontAwesomePoliticalRepublican,
    iconFontAwesomePoliticalScaleBalanced,
    iconFontAwesomePoliticalScaleUnbalancedFlip,
    iconFontAwesomePoliticalScaleUnbalanced,
} from './political';

// political
const politicalIcons = [
    {
        name: 'iconFontAwesomePoliticalAward',
        title: __('Award', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalAward,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalBuildingFlag',
        title: __('Building Flag', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalBuildingFlag,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalBullhorn',
        title: __('Bullhorn', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalBullhorn,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalCheckDouble',
        title: __('Check Double', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalCheckDouble,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalCheckToSlot',
        title: __('Check To Slot', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalCheckToSlot,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalCircleDollarToSlot',
        title: __('Circle Dollar To Slot', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalCircleDollarToSlot,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalDemocrat',
        title: __('Democrat', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalDemocrat,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalDove',
        title: __('Dove', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalDove,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalDumpsterFire',
        title: __('Dumpster Fire', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalDumpsterFire,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalFlagUsa',
        title: __('Flag Usa', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalFlagUsa,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalHandFist',
        title: __('Hand Fist', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalHandFist,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalHandshake',
        title: __('Handshake', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalHandshake,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalLandmarkDome',
        title: __('Landmark Dome', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalLandmarkDome,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalLandmarkFlag',
        title: __('Landmark Flag', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalLandmarkFlag,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalPersonBooth',
        title: __('Person Booth', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalPersonBooth,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalPiggyBank',
        title: __('Piggy Bank', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalPiggyBank,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalRepublican',
        title: __('Republican', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalRepublican,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalScaleBalanced',
        title: __('Scale Balanced', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalScaleBalanced,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalScaleUnbalancedFlip',
        title: __('Scale Unbalanced Flip', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalScaleUnbalancedFlip,
        categories: ['political'],
    },
    {
        name: 'iconFontAwesomePoliticalScaleUnbalanced',
        title: __('Scale Unbalanced', 'icon-font-awesome'),
        icon: iconFontAwesomePoliticalScaleUnbalanced,
        categories: ['political'],
    },
];

// punctuation+symbols
import {
    iconFontAwesomePunctuationSymbolsAsterisk,
    iconFontAwesomePunctuationSymbolsAt,
    iconFontAwesomePunctuationSymbolsCheckDouble,
    iconFontAwesomePunctuationSymbolsCheck,
    iconFontAwesomePunctuationSymbolsCircleExclamation,
    iconFontAwesomePunctuationSymbolsCircleQuestion,
    iconFontAwesomePunctuationSymbolsEquals,
    iconFontAwesomePunctuationSymbolsExclamation,
    iconFontAwesomePunctuationSymbolsGreaterThan,
    iconFontAwesomePunctuationSymbolsHashtag,
    iconFontAwesomePunctuationSymbolsLessThan,
    iconFontAwesomePunctuationSymbolsMinus,
    iconFontAwesomePunctuationSymbolsPercent,
    iconFontAwesomePunctuationSymbolsPlus,
    iconFontAwesomePunctuationSymbolsQuestion,
    iconFontAwesomePunctuationSymbolsQuoteLeft,
    iconFontAwesomePunctuationSymbolsQuoteRight,
    iconFontAwesomePunctuationSymbolsSection,
} from './punctuation+symbols';

// punctuation+symbols
const punctuationSymbolsIcons = [
    {
        name: 'iconFontAwesomePunctuationSymbolsAsterisk',
        title: __('Asterisk', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsAsterisk,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsAt',
        title: __('At', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsAt,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsCheckDouble',
        title: __('Check Double', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsCheckDouble,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsCheck',
        title: __('Check', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsCheck,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsCircleExclamation',
        title: __('Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsCircleExclamation,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsCircleQuestion',
        title: __('Circle Question', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsCircleQuestion,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsEquals',
        title: __('Equals', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsEquals,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsExclamation',
        title: __('Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsExclamation,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsGreaterThan',
        title: __('Greater Than', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsGreaterThan,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsHashtag',
        title: __('Hashtag', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsHashtag,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsLessThan',
        title: __('Less Than', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsLessThan,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsMinus',
        title: __('Minus', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsMinus,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsPercent',
        title: __('Percent', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsPercent,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsPlus',
        title: __('Plus', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsPlus,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsQuestion',
        title: __('Question', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsQuestion,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsQuoteLeft',
        title: __('Quote Left', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsQuoteLeft,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsQuoteRight',
        title: __('Quote Right', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsQuoteRight,
        categories: ['punctuation+symbols'],
    },
    {
        name: 'iconFontAwesomePunctuationSymbolsSection',
        title: __('Section', 'icon-font-awesome'),
        icon: iconFontAwesomePunctuationSymbolsSection,
        categories: ['punctuation+symbols'],
    },
];

// religion
import {
    iconFontAwesomeReligionAnkh,
    iconFontAwesomeReligionAtom,
    iconFontAwesomeReligionBahai,
    iconFontAwesomeReligionBookBible,
    iconFontAwesomeReligionBookJournalWhills,
    iconFontAwesomeReligionBookQuran,
    iconFontAwesomeReligionBookTanakh,
    iconFontAwesomeReligionChurch,
    iconFontAwesomeReligionCross,
    iconFontAwesomeReligionDharmachakra,
    iconFontAwesomeReligionDove,
    iconFontAwesomeReligionGopuram,
    iconFontAwesomeReligionHamsa,
    iconFontAwesomeReligionHandsPraying,
    iconFontAwesomeReligionHanukiah,
    iconFontAwesomeReligionJedi,
    iconFontAwesomeReligionKaaba,
    iconFontAwesomeReligionKhanda,
    iconFontAwesomeReligionMenorah,
    iconFontAwesomeReligionMosque,
    iconFontAwesomeReligionOm,
    iconFontAwesomeReligionPeace,
    iconFontAwesomeReligionPersonPraying,
    iconFontAwesomeReligionPlaceOfWorship,
    iconFontAwesomeReligionScrollTorah,
    iconFontAwesomeReligionSpaghettiMonsterFlying,
    iconFontAwesomeReligionStarAndCrescent,
    iconFontAwesomeReligionStarOfDavid,
    iconFontAwesomeReligionSynagogue,
    iconFontAwesomeReligionToriiGate,
    iconFontAwesomeReligionVihara,
    iconFontAwesomeReligionYinYang,
} from './religion';

// religion
const religionIcons = [
    {
        name: 'iconFontAwesomeReligionAnkh',
        title: __('Ankh', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionAnkh,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionAtom',
        title: __('Atom', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionAtom,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionBahai',
        title: __('Bahai', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionBahai,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionBookBible',
        title: __('Book Bible', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionBookBible,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionBookJournalWhills',
        title: __('Book Journal Whills', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionBookJournalWhills,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionBookQuran',
        title: __('Book Quran', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionBookQuran,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionBookTanakh',
        title: __('Book Tanakh', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionBookTanakh,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionChurch',
        title: __('Church', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionChurch,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionCross',
        title: __('Cross', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionCross,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionDharmachakra',
        title: __('Dharmachakra', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionDharmachakra,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionDove',
        title: __('Dove', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionDove,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionGopuram',
        title: __('Gopuram', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionGopuram,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionHamsa',
        title: __('Hamsa', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionHamsa,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionHandsPraying',
        title: __('Hands Praying', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionHandsPraying,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionHanukiah',
        title: __('Hanukiah', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionHanukiah,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionJedi',
        title: __('Jedi', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionJedi,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionKaaba',
        title: __('Kaaba', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionKaaba,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionKhanda',
        title: __('Khanda', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionKhanda,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionMenorah',
        title: __('Menorah', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionMenorah,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionMosque',
        title: __('Mosque', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionMosque,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionOm',
        title: __('Om', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionOm,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionPeace',
        title: __('Peace', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionPeace,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionPersonPraying',
        title: __('Person Praying', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionPersonPraying,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionPlaceOfWorship',
        title: __('Place Of Worship', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionPlaceOfWorship,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionScrollTorah',
        title: __('Scroll Torah', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionScrollTorah,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionSpaghettiMonsterFlying',
        title: __('Spaghetti Monster Flying', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionSpaghettiMonsterFlying,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionStarAndCrescent',
        title: __('Star And Crescent', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionStarAndCrescent,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionStarOfDavid',
        title: __('Star Of David', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionStarOfDavid,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionSynagogue',
        title: __('Synagogue', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionSynagogue,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionToriiGate',
        title: __('Torii Gate', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionToriiGate,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionVihara',
        title: __('Vihara', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionVihara,
        categories: ['religion'],
    },
    {
        name: 'iconFontAwesomeReligionYinYang',
        title: __('Yin Yang', 'icon-font-awesome'),
        icon: iconFontAwesomeReligionYinYang,
        categories: ['religion'],
    },
];

// science
import {
    iconFontAwesomeScienceAtom,
    iconFontAwesomeScienceBiohazard,
    iconFontAwesomeScienceBrain,
    iconFontAwesomeScienceCapsules,
    iconFontAwesomeScienceCircleRadiation,
    iconFontAwesomeScienceClipboardCheck,
    iconFontAwesomeScienceDisease,
    iconFontAwesomeScienceDna,
    iconFontAwesomeScienceEyeDropper,
    iconFontAwesomeScienceFilter,
    iconFontAwesomeScienceFireFlameCurved,
    iconFontAwesomeScienceFireFlameSimple,
    iconFontAwesomeScienceFire,
    iconFontAwesomeScienceFlask,
    iconFontAwesomeScienceFlaskVial,
    iconFontAwesomeScienceFrog,
    iconFontAwesomeScienceMagnet,
    iconFontAwesomeScienceMicroscope,
    iconFontAwesomeScienceMortarPestle,
    iconFontAwesomeSciencePills,
    iconFontAwesomeSciencePrescriptionBottle,
    iconFontAwesomeScienceRadiation,
    iconFontAwesomeScienceSeedling,
    iconFontAwesomeScienceSkullCrossbones,
    iconFontAwesomeScienceSquareVirus,
    iconFontAwesomeScienceSyringe,
    iconFontAwesomeScienceTablets,
    iconFontAwesomeScienceTemperatureHigh,
    iconFontAwesomeScienceTemperatureLow,
    iconFontAwesomeScienceVialCircleCheck,
    iconFontAwesomeScienceVial,
    iconFontAwesomeScienceVials,
    iconFontAwesomeScienceVialVirus,
} from './science';

// science
const scienceIcons = [
    {
        name: 'iconFontAwesomeScienceAtom',
        title: __('Atom', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceAtom,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceBiohazard',
        title: __('Biohazard', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceBiohazard,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceBrain',
        title: __('Brain', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceBrain,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceCapsules',
        title: __('Capsules', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceCapsules,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceCircleRadiation',
        title: __('Circle Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceCircleRadiation,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceClipboardCheck',
        title: __('Clipboard Check', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceClipboardCheck,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceDisease',
        title: __('Disease', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceDisease,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceDna',
        title: __('Dna', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceDna,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceEyeDropper',
        title: __('Eye Dropper', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceEyeDropper,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceFilter',
        title: __('Filter', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceFilter,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceFireFlameCurved',
        title: __('Fire Flame Curved', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceFireFlameCurved,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceFireFlameSimple',
        title: __('Fire Flame Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceFireFlameSimple,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceFire',
        title: __('Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceFire,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceFlask',
        title: __('Flask', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceFlask,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceFlaskVial',
        title: __('Flask Vial', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceFlaskVial,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceFrog',
        title: __('Frog', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceFrog,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceMagnet',
        title: __('Magnet', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceMagnet,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceMicroscope',
        title: __('Microscope', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceMicroscope,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceMortarPestle',
        title: __('Mortar Pestle', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceMortarPestle,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeSciencePills',
        title: __('Pills', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencePills,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeSciencePrescriptionBottle',
        title: __('Prescription Bottle', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencePrescriptionBottle,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceRadiation',
        title: __('Radiation', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceRadiation,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceSeedling',
        title: __('Seedling', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceSeedling,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceSkullCrossbones',
        title: __('Skull Crossbones', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceSkullCrossbones,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceSquareVirus',
        title: __('Square Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceSquareVirus,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceSyringe',
        title: __('Syringe', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceSyringe,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceTablets',
        title: __('Tablets', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceTablets,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceTemperatureHigh',
        title: __('Temperature High', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceTemperatureHigh,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceTemperatureLow',
        title: __('Temperature Low', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceTemperatureLow,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceVialCircleCheck',
        title: __('Vial Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceVialCircleCheck,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceVial',
        title: __('Vial', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceVial,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceVials',
        title: __('Vials', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceVials,
        categories: ['science'],
    },
    {
        name: 'iconFontAwesomeScienceVialVirus',
        title: __('Vial Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeScienceVialVirus,
        categories: ['science'],
    },
];

// science-fiction
import {
    iconFontAwesomeSciencefictionAtom,
    iconFontAwesomeSciencefictionBookJournalWhills,
    iconFontAwesomeSciencefictionExplosion,
    iconFontAwesomeSciencefictionGalacticRepublic,
    iconFontAwesomeSciencefictionGalacticSenate,
    iconFontAwesomeSciencefictionHandSpock,
    iconFontAwesomeSciencefictionJedi,
    iconFontAwesomeSciencefictionJediOrder,
    iconFontAwesomeSciencefictionOldRepublic,
    iconFontAwesomeSciencefictionRobot,
    iconFontAwesomeSciencefictionRocket,
    iconFontAwesomeSciencefictionSpaceAwesome,
    iconFontAwesomeSciencefictionUserAstronaut,
} from './science-fiction';

// science-fiction
const scienceFictionIcons = [
    {
        name: 'iconFontAwesomeSciencefictionAtom',
        title: __('Sciencefiction Atom', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionAtom,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionBookJournalWhills',
        title: __('Sciencefiction Book Journal Whills', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionBookJournalWhills,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionExplosion',
        title: __('Sciencefiction Explosion', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionExplosion,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionGalacticRepublic',
        title: __('Sciencefiction Galactic Republic', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionGalacticRepublic,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionGalacticSenate',
        title: __('Sciencefiction Galactic Senate', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionGalacticSenate,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionHandSpock',
        title: __('Sciencefiction Hand Spock', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionHandSpock,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionJedi',
        title: __('Sciencefiction Jedi', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionJedi,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionJediOrder',
        title: __('Sciencefiction Jedi Order', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionJediOrder,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionOldRepublic',
        title: __('Sciencefiction Old Republic', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionOldRepublic,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionRobot',
        title: __('Sciencefiction Robot', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionRobot,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionRocket',
        title: __('Sciencefiction Rocket', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionRocket,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionSpaceAwesome',
        title: __('Sciencefiction Space Awesome', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionSpaceAwesome,
        categories: ['science-fiction'],
    },
    {
        name: 'iconFontAwesomeSciencefictionUserAstronaut',
        title: __('Sciencefiction User Astronaut', 'icon-font-awesome'),
        icon: iconFontAwesomeSciencefictionUserAstronaut,
        categories: ['science-fiction'],
    },
];

// security
import {
    iconFontAwesomeSecurityBan,
    iconFontAwesomeSecurityBug,
    iconFontAwesomeSecurityBugSlash,
    iconFontAwesomeSecurityBuildingLock,
    iconFontAwesomeSecurityBuildingShield,
    iconFontAwesomeSecurityBurst,
    iconFontAwesomeSecurityCarOn,
    iconFontAwesomeSecurityDoorClosed,
    iconFontAwesomeSecurityDoorOpen,
    iconFontAwesomeSecurityDungeon,
    iconFontAwesomeSecurityExplosion,
    iconFontAwesomeSecurityEye,
    iconFontAwesomeSecurityEyeSlash,
    iconFontAwesomeSecurityFileContract,
    iconFontAwesomeSecurityFileShield,
    iconFontAwesomeSecurityFileSignature,
    iconFontAwesomeSecurityFingerprint,
    iconFontAwesomeSecurityGun,
    iconFontAwesomeSecurityHandcuffs,
    iconFontAwesomeSecurityHandsBound,
    iconFontAwesomeSecurityHandsHoldingChild,
    iconFontAwesomeSecurityHandsHoldingCircle,
    iconFontAwesomeSecurityHouseFire,
    iconFontAwesomeSecurityHouseLock,
    iconFontAwesomeSecurityIdBadge,
    iconFontAwesomeSecurityIdCardClip,
    iconFontAwesomeSecurityIdCard,
    iconFontAwesomeSecurityKey,
    iconFontAwesomeSecurityLandMineOn,
    iconFontAwesomeSecurityLock,
    iconFontAwesomeSecurityLockOpen,
    iconFontAwesomeSecurityMarsAndVenusBurst,
    iconFontAwesomeSecurityMask,
    iconFontAwesomeSecurityPassport,
    iconFontAwesomeSecurityPeoplePulling,
    iconFontAwesomeSecurityPeopleRobbery,
    iconFontAwesomeSecurityPersonBurst,
    iconFontAwesomeSecurityPersonDressBurst,
    iconFontAwesomeSecurityPersonFallingBurst,
    iconFontAwesomeSecurityPersonHarassing,
    iconFontAwesomeSecurityPersonMilitaryPointing,
    iconFontAwesomeSecurityPersonMilitaryRifle,
    iconFontAwesomeSecurityPersonMilitaryToPerson,
    iconFontAwesomeSecurityPersonRifle,
    iconFontAwesomeSecurityPersonShelter,
    iconFontAwesomeSecurityPersonThroughWindow,
    iconFontAwesomeSecurityRoadSpikes,
    iconFontAwesomeSecurityShieldCat,
    iconFontAwesomeSecurityShieldDog,
    iconFontAwesomeSecurityShieldHalved,
    iconFontAwesomeSecurityShieldHeart,
    iconFontAwesomeSecurityShield,
    iconFontAwesomeSecuritySkullCrossbones,
    iconFontAwesomeSecuritySquarePersonConfined,
    iconFontAwesomeSecurityTowerObservation,
    iconFontAwesomeSecurityUnlock,
    iconFontAwesomeSecurityUnlockKeyhole,
    iconFontAwesomeSecurityUserLock,
    iconFontAwesomeSecurityUserSecret,
    iconFontAwesomeSecurityUserShield,
    iconFontAwesomeSecurityVault,
} from './security';

// security
const securityIcons = [
    {
        name: 'iconFontAwesomeSecurityBan',
        title: __('Ban', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityBan,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityBug',
        title: __('Bug', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityBug,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityBugSlash',
        title: __('Bug Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityBugSlash,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityBuildingLock',
        title: __('Building Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityBuildingLock,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityBuildingShield',
        title: __('Building Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityBuildingShield,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityBurst',
        title: __('Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityBurst,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityCarOn',
        title: __('Car On', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityCarOn,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityDoorClosed',
        title: __('Door Closed', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityDoorClosed,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityDoorOpen',
        title: __('Door Open', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityDoorOpen,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityDungeon',
        title: __('Dungeon', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityDungeon,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityExplosion',
        title: __('Explosion', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityExplosion,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityEye',
        title: __('Eye', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityEye,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityEyeSlash',
        title: __('Eye Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityEyeSlash,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityFileContract',
        title: __('File Contract', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityFileContract,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityFileShield',
        title: __('File Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityFileShield,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityFileSignature',
        title: __('File Signature', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityFileSignature,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityFingerprint',
        title: __('Fingerprint', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityFingerprint,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityGun',
        title: __('Gun', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityGun,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityHandcuffs',
        title: __('Handcuffs', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityHandcuffs,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityHandsBound',
        title: __('Hands Bound', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityHandsBound,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityHandsHoldingChild',
        title: __('Hands Holding Child', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityHandsHoldingChild,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityHandsHoldingCircle',
        title: __('Hands Holding Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityHandsHoldingCircle,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityHouseFire',
        title: __('House Fire', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityHouseFire,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityHouseLock',
        title: __('House Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityHouseLock,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityIdBadge',
        title: __('Id Badge', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityIdBadge,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityIdCardClip',
        title: __('Id Card Clip', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityIdCardClip,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityIdCard',
        title: __('Id Card', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityIdCard,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityKey',
        title: __('Key', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityKey,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityLandMineOn',
        title: __('Land Mine On', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityLandMineOn,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityLock',
        title: __('Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityLock,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityLockOpen',
        title: __('Lock Open', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityLockOpen,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityMarsAndVenusBurst',
        title: __('Mars And Venus Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityMarsAndVenusBurst,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityMask',
        title: __('Mask', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityMask,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPassport',
        title: __('Passport', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPassport,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPeoplePulling',
        title: __('People Pulling', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPeoplePulling,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPeopleRobbery',
        title: __('People Robbery', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPeopleRobbery,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonBurst',
        title: __('Person Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonBurst,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonDressBurst',
        title: __('Person Dress Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonDressBurst,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonFallingBurst',
        title: __('Person Falling Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonFallingBurst,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonHarassing',
        title: __('Person Harassing', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonHarassing,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonMilitaryPointing',
        title: __('Person Military Pointing', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonMilitaryPointing,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonMilitaryRifle',
        title: __('Person Military Rifle', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonMilitaryRifle,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonMilitaryToPerson',
        title: __('Person Military To Person', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonMilitaryToPerson,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonRifle',
        title: __('Person Rifle', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonRifle,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonShelter',
        title: __('Person Shelter', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonShelter,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityPersonThroughWindow',
        title: __('Person Through Window', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityPersonThroughWindow,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityRoadSpikes',
        title: __('Road Spikes', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityRoadSpikes,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityShieldCat',
        title: __('Shield Cat', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityShieldCat,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityShieldDog',
        title: __('Shield Dog', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityShieldDog,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityShieldHalved',
        title: __('Shield Halved', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityShieldHalved,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityShieldHeart',
        title: __('Shield Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityShieldHeart,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityShield',
        title: __('Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityShield,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecuritySkullCrossbones',
        title: __('Skull Crossbones', 'icon-font-awesome'),
        icon: iconFontAwesomeSecuritySkullCrossbones,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecuritySquarePersonConfined',
        title: __('Square Person Confined', 'icon-font-awesome'),
        icon: iconFontAwesomeSecuritySquarePersonConfined,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityTowerObservation',
        title: __('Tower Observation', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityTowerObservation,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityUnlock',
        title: __('Unlock', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityUnlock,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityUnlockKeyhole',
        title: __('Unlock Keyhole', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityUnlockKeyhole,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityUserLock',
        title: __('User Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityUserLock,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityUserSecret',
        title: __('User Secret', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityUserSecret,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityUserShield',
        title: __('User Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityUserShield,
        categories: ['security'],
    },
    {
        name: 'iconFontAwesomeSecurityVault',
        title: __('Vault', 'icon-font-awesome'),
        icon: iconFontAwesomeSecurityVault,
        categories: ['security'],
    },
];

// shapes
import {
    iconFontAwesomeShapesBookmark,
    iconFontAwesomeShapesBurst,
    iconFontAwesomeShapesCalendar,
    iconFontAwesomeShapesCertificate,
    iconFontAwesomeShapesCircleHalfStroke,
    iconFontAwesomeShapesCircle,
    iconFontAwesomeShapesCloud,
    iconFontAwesomeShapesClover,
    iconFontAwesomeShapesComment,
    iconFontAwesomeShapesCrown,
    iconFontAwesomeShapesCubesStacked,
    iconFontAwesomeShapesDiamond,
    iconFontAwesomeShapesFile,
    iconFontAwesomeShapesFolder,
    iconFontAwesomeShapesHeartCrack,
    iconFontAwesomeShapesHeart,
    iconFontAwesomeShapesLinesLeaning,
    iconFontAwesomeShapesLocationPin,
    iconFontAwesomeShapesPlay,
    iconFontAwesomeShapesShapes,
    iconFontAwesomeShapesShield,
    iconFontAwesomeShapesSquare,
    iconFontAwesomeShapesStar,
    iconFontAwesomeShapesTicketSimple,
} from './shapes';

// shapes
const shapesIcons = [
    {
        name: 'iconFontAwesomeShapesBookmark',
        title: __('Bookmark', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesBookmark,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesBurst',
        title: __('Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesBurst,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesCalendar',
        title: __('Calendar', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesCalendar,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesCertificate',
        title: __('Certificate', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesCertificate,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesCircleHalfStroke',
        title: __('Circle Half Stroke', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesCircleHalfStroke,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesCircle',
        title: __('Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesCircle,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesCloud',
        title: __('Cloud', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesCloud,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesClover',
        title: __('Clover', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesClover,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesComment',
        title: __('Comment', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesComment,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesCrown',
        title: __('Crown', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesCrown,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesCubesStacked',
        title: __('Cubes Stacked', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesCubesStacked,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesDiamond',
        title: __('Diamond', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesDiamond,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesFile',
        title: __('File', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesFile,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesFolder',
        title: __('Folder', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesFolder,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesHeartCrack',
        title: __('Heart Crack', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesHeartCrack,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesHeart,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesLinesLeaning',
        title: __('Lines Leaning', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesLinesLeaning,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesLocationPin',
        title: __('Location Pin', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesLocationPin,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesPlay',
        title: __('Play', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesPlay,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesShapes',
        title: __('', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesShapes,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesShield',
        title: __('Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesShield,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesSquare',
        title: __('Square', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesSquare,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesStar',
        title: __('Star', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesStar,
        categories: ['shapes'],
    },
    {
        name: 'iconFontAwesomeShapesTicketSimple',
        title: __('Ticket Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeShapesTicketSimple,
        categories: ['shapes'],
    },
];

// shopping
import {
    iconFontAwesomeShoppingAlipay,
    iconFontAwesomeShoppingAmazonPay,
    iconFontAwesomeShoppingApplePay,
    iconFontAwesomeShoppingBagShopping,
    iconFontAwesomeShoppingBarcode,
    iconFontAwesomeShoppingBasketShopping,
    iconFontAwesomeShoppingBell,
    iconFontAwesomeShoppingBitcoin,
    iconFontAwesomeShoppingBookmark,
    iconFontAwesomeShoppingBtc,
    iconFontAwesomeShoppingBullhorn,
    iconFontAwesomeShoppingCamera,
    iconFontAwesomeShoppingCameraRetro,
    iconFontAwesomeShoppingCartArrowDown,
    iconFontAwesomeShoppingCartPlus,
    iconFontAwesomeShoppingCartShopping,
    iconFontAwesomeShoppingCashRegister,
    iconFontAwesomeShoppingCcAmazonPay,
    iconFontAwesomeShoppingCcAmex,
    iconFontAwesomeShoppingCcApplePay,
    iconFontAwesomeShoppingCcDinersClub,
    iconFontAwesomeShoppingCcDiscover,
    iconFontAwesomeShoppingCcJcb,
    iconFontAwesomeShoppingCcMastercard,
    iconFontAwesomeShoppingCcPaypal,
    iconFontAwesomeShoppingCcStripe,
    iconFontAwesomeShoppingCcVisa,
    iconFontAwesomeShoppingCertificate,
    iconFontAwesomeShoppingCreditCard,
    iconFontAwesomeShoppingEthereum,
    iconFontAwesomeShoppingGem,
    iconFontAwesomeShoppingGift,
    iconFontAwesomeShoppingGifts,
    iconFontAwesomeShoppingGooglePay,
    iconFontAwesomeShoppingGoogleWallet,
    iconFontAwesomeShoppingHandshake,
    iconFontAwesomeShoppingHeart,
    iconFontAwesomeShoppingKey,
    iconFontAwesomeShoppingMoneyCheckDollar,
    iconFontAwesomeShoppingMoneyCheck,
    iconFontAwesomeShoppingNfcDirectional,
    iconFontAwesomeShoppingNfcSymbol,
    iconFontAwesomeShoppingPaypal,
    iconFontAwesomeShoppingPersonBooth,
    iconFontAwesomeShoppingReceipt,
    iconFontAwesomeShoppingShirt,
    iconFontAwesomeShoppingShop,
    iconFontAwesomeShoppingShopLock,
    iconFontAwesomeShoppingShopSlash,
    iconFontAwesomeShoppingStar,
    iconFontAwesomeShoppingStore,
    iconFontAwesomeShoppingStoreSlash,
    iconFontAwesomeShoppingStripe,
    iconFontAwesomeShoppingStripeS,
    iconFontAwesomeShoppingTag,
    iconFontAwesomeShoppingTags,
    iconFontAwesomeShoppingThumbsDown,
    iconFontAwesomeShoppingThumbsUp,
    iconFontAwesomeShoppingTrophy,
    iconFontAwesomeShoppingTruckFast,
    iconFontAwesomeShoppingTruck,
} from './shopping';

// shopping
const shoppingIcons = [
    {
        name: 'iconFontAwesomeShoppingAlipay',
        title: __('Alipay', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingAlipay,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingAmazonPay',
        title: __('Amazon Pay', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingAmazonPay,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingApplePay',
        title: __('Apple Pay', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingApplePay,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBagShopping',
        title: __('Bag', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBagShopping,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBarcode',
        title: __('Barcode', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBarcode,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBasketShopping',
        title: __('Basket', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBasketShopping,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBell',
        title: __('Bell', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBell,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBitcoin',
        title: __('Bitcoin', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBitcoin,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBookmark',
        title: __('Bookmark', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBookmark,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBtc',
        title: __('Btc', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBtc,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingBullhorn',
        title: __('Bullhorn', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingBullhorn,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCamera',
        title: __('Camera', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCamera,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCameraRetro',
        title: __('Camera Retro', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCameraRetro,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCartArrowDown',
        title: __('Cart Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCartArrowDown,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCartPlus',
        title: __('Cart Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCartPlus,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCartShopping',
        title: __('Cart', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCartShopping,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCashRegister',
        title: __('Cash Register', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCashRegister,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcAmazonPay',
        title: __('Cc Amazon Pay', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcAmazonPay,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcAmex',
        title: __('Cc Amex', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcAmex,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcApplePay',
        title: __('Cc Apple Pay', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcApplePay,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcDinersClub',
        title: __('Cc Diners Club', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcDinersClub,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcDiscover',
        title: __('Cc Discover', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcDiscover,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcJcb',
        title: __('Cc Jcb', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcJcb,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcMastercard',
        title: __('Cc Mastercard', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcMastercard,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcPaypal',
        title: __('Cc Paypal', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcPaypal,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcStripe',
        title: __('Cc Stripe', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcStripe,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCcVisa',
        title: __('Cc Visa', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCcVisa,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCertificate',
        title: __('Certificate', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCertificate,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingCreditCard',
        title: __('Credit Card', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingCreditCard,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingEthereum',
        title: __('Ethereum', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingEthereum,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingGem',
        title: __('Gem', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingGem,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingGift',
        title: __('Gift', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingGift,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingGifts',
        title: __('Gifts', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingGifts,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingGooglePay',
        title: __('Google Pay', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingGooglePay,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingGoogleWallet',
        title: __('Google Wallet', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingGoogleWallet,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingHandshake',
        title: __('Handshake', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingHandshake,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingHeart,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingKey',
        title: __('Key', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingKey,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingMoneyCheckDollar',
        title: __('Money Check Dollar', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingMoneyCheckDollar,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingMoneyCheck',
        title: __('Money Check', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingMoneyCheck,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingNfcDirectional',
        title: __('Nfc Directional', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingNfcDirectional,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingNfcSymbol',
        title: __('Nfc Symbol', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingNfcSymbol,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingPaypal',
        title: __('Paypal', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingPaypal,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingPersonBooth',
        title: __('Person Booth', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingPersonBooth,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingReceipt',
        title: __('Receipt', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingReceipt,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingShirt',
        title: __('Shirt', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingShirt,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingShop',
        title: __('Shop', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingShop,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingShopLock',
        title: __('Shop Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingShopLock,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingShopSlash',
        title: __('Shop Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingShopSlash,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingStar',
        title: __('Star', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingStar,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingStore',
        title: __('Store', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingStore,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingStoreSlash',
        title: __('Store Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingStoreSlash,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingStripe',
        title: __('Stripe', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingStripe,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingStripeS',
        title: __('Stripe S', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingStripeS,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingTag',
        title: __('Tag', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingTag,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingTags',
        title: __('Tags', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingTags,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingThumbsDown',
        title: __('Thumbs Down', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingThumbsDown,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingThumbsUp',
        title: __('Thumbs Up', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingThumbsUp,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingTrophy',
        title: __('Trophy', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingTrophy,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingTruckFast',
        title: __('Truck Fast', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingTruckFast,
        categories: ['shopping'],
    },
    {
        name: 'iconFontAwesomeShoppingTruck',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeShoppingTruck,
        categories: ['shopping'],
    },
];

// social
import {
    iconFontAwesomeSocialBell,
    iconFontAwesomeSocialCakeCandles,
    iconFontAwesomeSocialCamera,
    iconFontAwesomeSocialCircleUser,
    iconFontAwesomeSocialComment,
    iconFontAwesomeSocialEnvelope,
    iconFontAwesomeSocialHashtag,
    iconFontAwesomeSocialHeart,
    iconFontAwesomeSocialIcons,
    iconFontAwesomeSocialImage,
    iconFontAwesomeSocialImages,
    iconFontAwesomeSocialLocationDot,
    iconFontAwesomeSocialLocationPin,
    iconFontAwesomeSocialMessage,
    iconFontAwesomeSocialPhotoFilm,
    iconFontAwesomeSocialRetweet,
    iconFontAwesomeSocialShareFromSquare,
    iconFontAwesomeSocialShare,
    iconFontAwesomeSocialShareNodes,
    iconFontAwesomeSocialSquarePollHorizontal,
    iconFontAwesomeSocialSquarePollVertical,
    iconFontAwesomeSocialSquareShareNodes,
    iconFontAwesomeSocialStar,
    iconFontAwesomeSocialThumbsDown,
    iconFontAwesomeSocialThumbsUp,
    iconFontAwesomeSocialThumbtack,
    iconFontAwesomeSocialUserGroup,
    iconFontAwesomeSocialUser,
    iconFontAwesomeSocialUserPlus,
    iconFontAwesomeSocialUsers,
    iconFontAwesomeSocialVideo,
} from './social';

// social
const socialIcons = [
    {
        name: 'iconFontAwesomeSocialBell',
        title: __('Bell', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialBell,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialCakeCandles',
        title: __('Cake Candles', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialCakeCandles,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialCamera',
        title: __('Camera', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialCamera,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialCircleUser',
        title: __('Circle User', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialCircleUser,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialComment',
        title: __('Comment', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialComment,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialEnvelope',
        title: __('Envelope', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialEnvelope,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialHashtag',
        title: __('Hashtag', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialHashtag,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialHeart,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialIcons',
        title: __('Icons', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialIcons,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialImage',
        title: __('Image', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialImage,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialImages',
        title: __('Images', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialImages,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialLocationDot',
        title: __('Location Dot', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialLocationDot,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialLocationPin',
        title: __('Location Pin', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialLocationPin,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialMessage',
        title: __('Message', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialMessage,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialPhotoFilm',
        title: __('Photo Film', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialPhotoFilm,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialRetweet',
        title: __('Retweet', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialRetweet,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialShareFromSquare',
        title: __('Share From Square', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialShareFromSquare,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialShare',
        title: __('Share', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialShare,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialShareNodes',
        title: __('Share Nodes', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialShareNodes,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialSquarePollHorizontal',
        title: __('Square Poll Horizontal', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialSquarePollHorizontal,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialSquarePollVertical',
        title: __('Square Poll Vertical', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialSquarePollVertical,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialSquareShareNodes',
        title: __('Square Share Nodes', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialSquareShareNodes,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialStar',
        title: __('Star', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialStar,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialThumbsDown',
        title: __('Thumbs Down', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialThumbsDown,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialThumbsUp',
        title: __('Thumbs Up', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialThumbsUp,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialThumbtack',
        title: __('Thumbtack', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialThumbtack,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialUserGroup',
        title: __('User Group', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialUserGroup,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialUser',
        title: __('User', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialUser,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialUserPlus',
        title: __('User Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialUserPlus,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialUsers',
        title: __('Users', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialUsers,
        categories: ['social'],
    },
    {
        name: 'iconFontAwesomeSocialVideo',
        title: __('Video', 'icon-font-awesome'),
        icon: iconFontAwesomeSocialVideo,
        categories: ['social'],
    },
];

// spinners
import {
    iconFontAwesomeSpinnersArrowRotateLeft,
    iconFontAwesomeSpinnersArrowRotateRight,
    iconFontAwesomeSpinnersArrowsRotate,
    iconFontAwesomeSpinnersArrowsSpin,
    iconFontAwesomeSpinnersAsterisk,
    iconFontAwesomeSpinnersAtom,
    iconFontAwesomeSpinnersBahai,
    iconFontAwesomeSpinnersCertificate,
    iconFontAwesomeSpinnersCircleNotch,
    iconFontAwesomeSpinnersCompactDisc,
    iconFontAwesomeSpinnersCompass,
    iconFontAwesomeSpinnersCrosshairs,
    iconFontAwesomeSpinnersDharmachakra,
    iconFontAwesomeSpinnersFan,
    iconFontAwesomeSpinnersGear,
    iconFontAwesomeSpinnersHurricane,
    iconFontAwesomeSpinnersLifeRing,
    iconFontAwesomeSpinnersPalette,
    iconFontAwesomeSpinnersRing,
    iconFontAwesomeSpinnersRotate,
    iconFontAwesomeSpinnersRotateLeft,
    iconFontAwesomeSpinnersRotateRight,
    iconFontAwesomeSpinnersSlash,
    iconFontAwesomeSpinnersSnowflake,
    iconFontAwesomeSpinnersSpinner,
    iconFontAwesomeSpinnersStroopwafel,
    iconFontAwesomeSpinnersSun,
    iconFontAwesomeSpinnersYinYang,
} from './spinners';

// spinners
const spinnersIcons = [
    {
        name: 'iconFontAwesomeSpinnersArrowRotateLeft',
        title: __('Arrow Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersArrowRotateLeft,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersArrowRotateRight',
        title: __('Arrow Rotate Right', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersArrowRotateRight,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersArrowsRotate',
        title: __('Arrows Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersArrowsRotate,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersArrowsSpin',
        title: __('Arrows Spin', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersArrowsSpin,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersAsterisk',
        title: __('Asterisk', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersAsterisk,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersAtom',
        title: __('Atom', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersAtom,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersBahai',
        title: __('Bahai', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersBahai,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersCertificate',
        title: __('Certificate', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersCertificate,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersCircleNotch',
        title: __('Circle Notch', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersCircleNotch,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersCompactDisc',
        title: __('Compact Disc', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersCompactDisc,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersCompass',
        title: __('Compass', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersCompass,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersCrosshairs',
        title: __('Crosshairs', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersCrosshairs,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersDharmachakra',
        title: __('Dharmachakra', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersDharmachakra,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersFan',
        title: __('Fan', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersFan,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersGear',
        title: __('Gear', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersGear,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersHurricane',
        title: __('Hurricane', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersHurricane,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersLifeRing',
        title: __('Life Ring', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersLifeRing,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersPalette',
        title: __('Palette', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersPalette,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersRing',
        title: __('Ring', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersRing,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersRotate',
        title: __('Rotate', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersRotate,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersRotateLeft',
        title: __('Rotate Left', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersRotateLeft,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersRotateRight',
        title: __('Rotate Right', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersRotateRight,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersSlash',
        title: __('Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersSlash,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersSnowflake',
        title: __('Snowflake', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersSnowflake,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersSpinner',
        title: __('Spinner', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersSpinner,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersStroopwafel',
        title: __('Stroopwafel', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersStroopwafel,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersSun',
        title: __('Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersSun,
        categories: ['spinners'],
    },
    {
        name: 'iconFontAwesomeSpinnersYinYang',
        title: __('Yin Yang', 'icon-font-awesome'),
        icon: iconFontAwesomeSpinnersYinYang,
        categories: ['spinners'],
    },
];

// sports+fitness
import {
    iconFontAwesomeSportsFitnessBaseballBatBall,
    iconFontAwesomeSportsFitnessBaseball,
    iconFontAwesomeSportsFitnessBasketball,
    iconFontAwesomeSportsFitnessBicycle,
    iconFontAwesomeSportsFitnessBowlingBall,
    iconFontAwesomeSportsFitnessBroomBall,
    iconFontAwesomeSportsFitnessDumbbell,
    iconFontAwesomeSportsFitnessFireFlameCurved,
    iconFontAwesomeSportsFitnessFireFlameSimple,
    iconFontAwesomeSportsFitnessFootball,
    iconFontAwesomeSportsFitnessFutbol,
    iconFontAwesomeSportsFitnessGolfBallTee,
    iconFontAwesomeSportsFitnessHeart,
    iconFontAwesomeSportsFitnessHeartPulse,
    iconFontAwesomeSportsFitnessHockeyPuck,
    iconFontAwesomeSportsFitnessMedal,
    iconFontAwesomeSportsFitnessMound,
    iconFontAwesomeSportsFitnessPersonBiking,
    iconFontAwesomeSportsFitnessPersonHiking,
    iconFontAwesomeSportsFitnessPersonRunning,
    iconFontAwesomeSportsFitnessPersonSkating,
    iconFontAwesomeSportsFitnessPersonSkiing,
    iconFontAwesomeSportsFitnessPersonSkiingNordic,
    iconFontAwesomeSportsFitnessPersonSnowboarding,
    iconFontAwesomeSportsFitnessPersonSwimming,
    iconFontAwesomeSportsFitnessPersonWalking,
    iconFontAwesomeSportsFitnessRankingStar,
    iconFontAwesomeSportsFitnessShoePrints,
    iconFontAwesomeSportsFitnessSpa,
    iconFontAwesomeSportsFitnessStopwatch20,
    iconFontAwesomeSportsFitnessTableTennisPaddleBall,
    iconFontAwesomeSportsFitnessVolleyball,
    iconFontAwesomeSportsFitnessWeightHanging,
} from './sports+fitness';

// sports+fitness
const sportsFitnessIcons = [
    {
        name: 'iconFontAwesomeSportsFitnessBaseballBatBall',
        title: __('Baseball Bat Ball', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessBaseballBatBall,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessBaseball',
        title: __('Baseball', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessBaseball,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessBasketball',
        title: __('Basketball', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessBasketball,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessBicycle',
        title: __('Bicycle', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessBicycle,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessBowlingBall',
        title: __('Bowling Ball', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessBowlingBall,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessBroomBall',
        title: __('Broom Ball', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessBroomBall,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessDumbbell',
        title: __('Dumbbell', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessDumbbell,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessFireFlameCurved',
        title: __('Fire Flame Curved', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessFireFlameCurved,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessFireFlameSimple',
        title: __('Fire Flame Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessFireFlameSimple,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessFootball',
        title: __('Football', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessFootball,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessFutbol',
        title: __('Futbol', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessFutbol,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessGolfBallTee',
        title: __('Golf Ball Tee', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessGolfBallTee,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessHeart',
        title: __('Heart', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessHeart,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessHeartPulse',
        title: __('Heart Pulse', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessHeartPulse,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessHockeyPuck',
        title: __('Hockey Puck', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessHockeyPuck,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessMedal',
        title: __('Medal', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessMedal,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessMound',
        title: __('Mound', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessMound,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonBiking',
        title: __('Person Biking', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonBiking,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonHiking',
        title: __('Person Hiking', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonHiking,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonRunning',
        title: __('Person Running', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonRunning,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonSkating',
        title: __('Person Skating', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonSkating,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonSkiing',
        title: __('Person Skiing', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonSkiing,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonSkiingNordic',
        title: __('Person Skiing Nordic', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonSkiingNordic,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonSnowboarding',
        title: __('Person Snowboarding', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonSnowboarding,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonSwimming',
        title: __('Person Swimming', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonSwimming,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessPersonWalking',
        title: __('Person Walking', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessPersonWalking,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessRankingStar',
        title: __('Ranking Star', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessRankingStar,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessShoePrints',
        title: __('Shoe Prints', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessShoePrints,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessSpa',
        title: __('Spa', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessSpa,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessStopwatch20',
        title: __('Stopwatch20', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessStopwatch20,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessTableTennisPaddleBall',
        title: __('Table Tennis Paddle Ball', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessTableTennisPaddleBall,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessVolleyball',
        title: __('Volleyball', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessVolleyball,
        categories: ['sports+fitness'],
    },
    {
        name: 'iconFontAwesomeSportsFitnessWeightHanging',
        title: __('Weight Hanging', 'icon-font-awesome'),
        icon: iconFontAwesomeSportsFitnessWeightHanging,
        categories: ['sports+fitness'],
    },
];

// text-formatting
import {
    iconFontAwesomeTextformattingAlignCenter,
    iconFontAwesomeTextformattingAlignJustify,
    iconFontAwesomeTextformattingAlignLeft,
    iconFontAwesomeTextformattingAlignRight,
    iconFontAwesomeTextformattingBold,
    iconFontAwesomeTextformattingBorderAll,
    iconFontAwesomeTextformattingBorderNone,
    iconFontAwesomeTextformattingBorderTopLeft,
    iconFontAwesomeTextformattingCheckDouble,
    iconFontAwesomeTextformattingCheck,
    iconFontAwesomeTextformattingCircleCheck,
    iconFontAwesomeTextformattingFilterCircleXmark,
    iconFontAwesomeTextformattingFont,
    iconFontAwesomeTextformattingHeading,
    iconFontAwesomeTextformattingHighlighter,
    iconFontAwesomeTextformattingIcons,
    iconFontAwesomeTextformattingICursor,
    iconFontAwesomeTextformattingIndent,
    iconFontAwesomeTextformattingItalic,
    iconFontAwesomeTextformattingListCheck,
    iconFontAwesomeTextformattingList,
    iconFontAwesomeTextformattingListOl,
    iconFontAwesomeTextformattingListUl,
    iconFontAwesomeTextformattingOutdent,
    iconFontAwesomeTextformattingParagraph,
    iconFontAwesomeTextformattingRectangleList,
    iconFontAwesomeTextformattingSpellCheck,
    iconFontAwesomeTextformattingSquareCheck,
    iconFontAwesomeTextformattingStrikethrough,
    iconFontAwesomeTextformattingSubscript,
    iconFontAwesomeTextformattingSuperscript,
    iconFontAwesomeTextformattingTableCellsColumnLock,
    iconFontAwesomeTextformattingTableCells,
    iconFontAwesomeTextformattingTableCellsLarge,
    iconFontAwesomeTextformattingTableCellsRowLock,
    iconFontAwesomeTextformattingTableColumns,
    iconFontAwesomeTextformattingTable,
    iconFontAwesomeTextformattingTableList,
    iconFontAwesomeTextformattingTextHeight,
    iconFontAwesomeTextformattingTextSlash,
    iconFontAwesomeTextformattingTextWidth,
    iconFontAwesomeTextformattingUnderline,
} from './text-formatting';

// text-formatting
const textFormattingIcons = [
    {
        name: 'iconFontAwesomeTextformattingAlignCenter',
        title: __('Textformatting Align Center', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingAlignCenter,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingAlignJustify',
        title: __('Textformatting Align Justify', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingAlignJustify,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingAlignLeft',
        title: __('Textformatting Align Left', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingAlignLeft,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingAlignRight',
        title: __('Textformatting Align Right', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingAlignRight,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingBold',
        title: __('Textformatting Bold', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingBold,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingBorderAll',
        title: __('Textformatting Border All', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingBorderAll,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingBorderNone',
        title: __('Textformatting Border None', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingBorderNone,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingBorderTopLeft',
        title: __('Textformatting Border Top Left', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingBorderTopLeft,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingCheckDouble',
        title: __('Textformatting Check Double', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingCheckDouble,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingCheck',
        title: __('Textformatting Check', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingCheck,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingCircleCheck',
        title: __('Textformatting Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingCircleCheck,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingFilterCircleXmark',
        title: __('Textformatting Filter Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingFilterCircleXmark,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingFont',
        title: __('Textformatting Font', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingFont,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingHeading',
        title: __('Textformatting Heading', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingHeading,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingHighlighter',
        title: __('Textformatting Highlighter', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingHighlighter,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingIcons',
        title: __('Textformatting Icons', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingIcons,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingICursor',
        title: __('Textformatting ICursor', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingICursor,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingIndent',
        title: __('Textformatting Indent', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingIndent,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingItalic',
        title: __('Textformatting Italic', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingItalic,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingListCheck',
        title: __('Textformatting List Check', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingListCheck,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingList',
        title: __('Textformatting List', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingList,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingListOl',
        title: __('Textformatting List Ol', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingListOl,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingListUl',
        title: __('Textformatting List Ul', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingListUl,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingOutdent',
        title: __('Textformatting Outdent', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingOutdent,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingParagraph',
        title: __('Textformatting Paragraph', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingParagraph,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingRectangleList',
        title: __('Textformatting Rectangle List', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingRectangleList,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingSpellCheck',
        title: __('Textformatting Spell Check', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingSpellCheck,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingSquareCheck',
        title: __('Textformatting Square Check', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingSquareCheck,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingStrikethrough',
        title: __('Textformatting Strikethrough', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingStrikethrough,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingSubscript',
        title: __('Textformatting Subscript', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingSubscript,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingSuperscript',
        title: __('Textformatting Superscript', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingSuperscript,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTableCellsColumnLock',
        title: __('Textformatting Table Cells Column Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTableCellsColumnLock,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTableCells',
        title: __('Textformatting Table Cells', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTableCells,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTableCellsLarge',
        title: __('Textformatting Table Cells Large', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTableCellsLarge,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTableCellsRowLock',
        title: __('Textformatting Table Cells Row Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTableCellsRowLock,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTableColumns',
        title: __('Textformatting Table Columns', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTableColumns,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTable',
        title: __('Textformatting Table', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTable,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTableList',
        title: __('Textformatting Table List', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTableList,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTextHeight',
        title: __('Textformatting Text Height', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTextHeight,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTextSlash',
        title: __('Textformatting Text Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTextSlash,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingTextWidth',
        title: __('Textformatting Text Width', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingTextWidth,
        categories: ['text-formatting'],
    },
    {
        name: 'iconFontAwesomeTextformattingUnderline',
        title: __('Textformatting Underline', 'icon-font-awesome'),
        icon: iconFontAwesomeTextformattingUnderline,
        categories: ['text-formatting'],
    },
];

// time
import {
    iconFontAwesomeTimeBell,
    iconFontAwesomeTimeBellSlash,
    iconFontAwesomeTimeCalendarCheck,
    iconFontAwesomeTimeCalendarDay,
    iconFontAwesomeTimeCalendarDays,
    iconFontAwesomeTimeCalendar,
    iconFontAwesomeTimeCalendarMinus,
    iconFontAwesomeTimeCalendarPlus,
    iconFontAwesomeTimeCalendarWeek,
    iconFontAwesomeTimeCalendarXmark,
    iconFontAwesomeTimeClock,
    iconFontAwesomeTimeHourglassEnd,
    iconFontAwesomeTimeHourglassHalf,
    iconFontAwesomeTimeHourglass,
    iconFontAwesomeTimeHourglassStart,
    iconFontAwesomeTimeStopwatch20,
    iconFontAwesomeTimeStopwatch,
} from './time';

// time
const timeIcons = [
    {
        name: 'iconFontAwesomeTimeBell',
        title: __('Bell', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeBell,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeBellSlash',
        title: __('Bell Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeBellSlash,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendarCheck',
        title: __('Calendar Check', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendarCheck,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendarDay',
        title: __('Calendar Day', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendarDay,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendarDays',
        title: __('Calendar Days', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendarDays,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendar',
        title: __('Calendar', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendar,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendarMinus',
        title: __('Calendar Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendarMinus,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendarPlus',
        title: __('Calendar Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendarPlus,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendarWeek',
        title: __('Calendar Week', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendarWeek,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeCalendarXmark',
        title: __('Calendar Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeCalendarXmark,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeClock',
        title: __('Clock', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeClock,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeHourglassEnd',
        title: __('Hourglass End', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeHourglassEnd,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeHourglassHalf',
        title: __('Hourglass Half', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeHourglassHalf,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeHourglass',
        title: __('Hourglass', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeHourglass,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeHourglassStart',
        title: __('Hourglass Start', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeHourglassStart,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeStopwatch20',
        title: __('Stopwatch20', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeStopwatch20,
        categories: ['time'],
    },
    {
        name: 'iconFontAwesomeTimeStopwatch',
        title: __('Stopwatch', 'icon-font-awesome'),
        icon: iconFontAwesomeTimeStopwatch,
        categories: ['time'],
    },
];

// toggle
import {
    iconFontAwesomeToggleBullseye,
    iconFontAwesomeToggleCircleCheck,
    iconFontAwesomeToggleCircleDot,
    iconFontAwesomeToggleCircle,
    iconFontAwesomeToggleLocationCrosshairs,
    iconFontAwesomeToggleMicrophone,
    iconFontAwesomeToggleMicrophoneSlash,
    iconFontAwesomeTogglePlaneUp,
    iconFontAwesomeToggleSignal,
    iconFontAwesomeToggleStarHalf,
    iconFontAwesomeToggleStarHalfStroke,
    iconFontAwesomeToggleStar,
    iconFontAwesomeToggleToggleOff,
    iconFontAwesomeToggleToggleOn,
    iconFontAwesomeToggleWifi,
} from './toggle';

// toggle
const toggleIcons = [
    {
        name: 'iconFontAwesomeToggleBullseye',
        title: __('Bullseye', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleBullseye,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleCircleCheck',
        title: __('Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleCircleCheck,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleCircleDot',
        title: __('Circle Dot', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleCircleDot,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleCircle',
        title: __('Circle', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleCircle,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleLocationCrosshairs',
        title: __('Location Crosshairs', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleLocationCrosshairs,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleMicrophone',
        title: __('Microphone', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleMicrophone,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleMicrophoneSlash',
        title: __('Microphone Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleMicrophoneSlash,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeTogglePlaneUp',
        title: __('Plane Up', 'icon-font-awesome'),
        icon: iconFontAwesomeTogglePlaneUp,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleSignal',
        title: __('Signal', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleSignal,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleStarHalf',
        title: __('Star Half', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleStarHalf,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleStarHalfStroke',
        title: __('Star Half Stroke', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleStarHalfStroke,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleStar',
        title: __('Star', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleStar,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleToggleOff',
        title: __('Off', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleToggleOff,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleToggleOn',
        title: __('On', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleToggleOn,
        categories: ['toggle'],
    },
    {
        name: 'iconFontAwesomeToggleWifi',
        title: __('Wifi', 'icon-font-awesome'),
        icon: iconFontAwesomeToggleWifi,
        categories: ['toggle'],
    },
];

// transportation
import {
    iconFontAwesomeTransportationAccessibleIcon,
    iconFontAwesomeTransportationBabyCarriage,
    iconFontAwesomeTransportationBicycle,
    iconFontAwesomeTransportationBus,
    iconFontAwesomeTransportationBusSimple,
    iconFontAwesomeTransportationCableCar,
    iconFontAwesomeTransportationCarBurst,
    iconFontAwesomeTransportationCar,
    iconFontAwesomeTransportationCarRear,
    iconFontAwesomeTransportationCarSide,
    iconFontAwesomeTransportationCartShopping,
    iconFontAwesomeTransportationCarTunnel,
    iconFontAwesomeTransportationFerry,
    iconFontAwesomeTransportationHelicopter,
    iconFontAwesomeTransportationHorse,
    iconFontAwesomeTransportationJetFighter,
    iconFontAwesomeTransportationJetFighterUp,
    iconFontAwesomeTransportationMotorcycle,
    iconFontAwesomeTransportationMound,
    iconFontAwesomeTransportationPaperPlane,
    iconFontAwesomeTransportationPlane,
    iconFontAwesomeTransportationPlaneSlash,
    iconFontAwesomeTransportationPlaneUp,
    iconFontAwesomeTransportationRoadBarrier,
    iconFontAwesomeTransportationRoad,
    iconFontAwesomeTransportationRoadSpikes,
    iconFontAwesomeTransportationRocket,
    iconFontAwesomeTransportationSailboat,
    iconFontAwesomeTransportationShip,
    iconFontAwesomeTransportationShuttleSpace,
    iconFontAwesomeTransportationSleigh,
    iconFontAwesomeTransportationSnowplow,
    iconFontAwesomeTransportationTaxi,
    iconFontAwesomeTransportationTractor,
    iconFontAwesomeTransportationTrain,
    iconFontAwesomeTransportationTrainSubway,
    iconFontAwesomeTransportationTrainTram,
    iconFontAwesomeTransportationTruckArrowRight,
    iconFontAwesomeTransportationTruckDroplet,
    iconFontAwesomeTransportationTruckField,
    iconFontAwesomeTransportationTruckFieldUn,
    iconFontAwesomeTransportationTruckFront,
    iconFontAwesomeTransportationTruck,
    iconFontAwesomeTransportationTruckMedical,
    iconFontAwesomeTransportationTruckMonster,
    iconFontAwesomeTransportationTruckPickup,
    iconFontAwesomeTransportationTruckPlane,
    iconFontAwesomeTransportationVanShuttle,
    iconFontAwesomeTransportationWheelchair,
    iconFontAwesomeTransportationWheelchairMove,
} from './transportation';

// transportation
const transportationIcons = [
    {
        name: 'iconFontAwesomeTransportationAccessibleIcon',
        title: __('Accessible Icon', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationAccessibleIcon,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationBabyCarriage',
        title: __('Baby Carriage', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationBabyCarriage,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationBicycle',
        title: __('Bicycle', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationBicycle,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationBus',
        title: __('Bus', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationBus,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationBusSimple',
        title: __('Bus Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationBusSimple,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationCableCar',
        title: __('Cable Car', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationCableCar,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationCarBurst',
        title: __('Car Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationCarBurst,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationCar',
        title: __('Car', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationCar,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationCarRear',
        title: __('Car Rear', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationCarRear,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationCarSide',
        title: __('Car Side', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationCarSide,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationCartShopping',
        title: __('Cart Shopping', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationCartShopping,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationCarTunnel',
        title: __('Car Tunnel', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationCarTunnel,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationFerry',
        title: __('Ferry', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationFerry,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationHelicopter',
        title: __('Helicopter', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationHelicopter,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationHorse',
        title: __('Horse', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationHorse,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationJetFighter',
        title: __('Jet Fighter', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationJetFighter,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationJetFighterUp',
        title: __('Jet Fighter Up', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationJetFighterUp,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationMotorcycle',
        title: __('Motorcycle', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationMotorcycle,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationMound',
        title: __('Mound', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationMound,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationPaperPlane',
        title: __('Paper Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationPaperPlane,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationPlane',
        title: __('Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationPlane,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationPlaneSlash',
        title: __('Plane Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationPlaneSlash,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationPlaneUp',
        title: __('Plane Up', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationPlaneUp,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationRoadBarrier',
        title: __('Road Barrier', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationRoadBarrier,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationRoad',
        title: __('Road', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationRoad,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationRoadSpikes',
        title: __('Road Spikes', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationRoadSpikes,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationRocket',
        title: __('Rocket', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationRocket,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationSailboat',
        title: __('Sailboat', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationSailboat,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationShip',
        title: __('Ship', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationShip,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationShuttleSpace',
        title: __('Shuttle Space', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationShuttleSpace,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationSleigh',
        title: __('Sleigh', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationSleigh,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationSnowplow',
        title: __('Snowplow', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationSnowplow,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTaxi',
        title: __('Taxi', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTaxi,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTractor',
        title: __('Tractor', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTractor,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTrain',
        title: __('Train', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTrain,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTrainSubway',
        title: __('Train Subway', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTrainSubway,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTrainTram',
        title: __('Train Tram', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTrainTram,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckArrowRight',
        title: __('Truck Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckArrowRight,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckDroplet',
        title: __('Truck Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckDroplet,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckField',
        title: __('Truck Field', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckField,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckFieldUn',
        title: __('Truck Field Un', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckFieldUn,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckFront',
        title: __('Truck Front', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckFront,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruck',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruck,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckMedical',
        title: __('Truck Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckMedical,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckMonster',
        title: __('Truck Monster', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckMonster,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckPickup',
        title: __('Truck Pickup', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckPickup,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationTruckPlane',
        title: __('Truck Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationTruckPlane,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationVanShuttle',
        title: __('Van Shuttle', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationVanShuttle,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationWheelchair',
        title: __('Wheelchair', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationWheelchair,
        categories: ['transportation'],
    },
    {
        name: 'iconFontAwesomeTransportationWheelchairMove',
        title: __('Wheelchair Move', 'icon-font-awesome'),
        icon: iconFontAwesomeTransportationWheelchairMove,
        categories: ['transportation'],
    },
];

// travel+hotel
import {
    iconFontAwesomeTravelHotelAccessibleIcon,
    iconFontAwesomeTravelHotelBabyCarriage,
    iconFontAwesomeTravelHotelBicycle,
    iconFontAwesomeTravelHotelBus,
    iconFontAwesomeTravelHotelBusSimple,
    iconFontAwesomeTravelHotelCableCar,
    iconFontAwesomeTravelHotelCarBurst,
    iconFontAwesomeTravelHotelCar,
    iconFontAwesomeTravelHotelCarRear,
    iconFontAwesomeTravelHotelCarSide,
    iconFontAwesomeTravelHotelCartShopping,
    iconFontAwesomeTravelHotelCarTunnel,
    iconFontAwesomeTravelHotelFerry,
    iconFontAwesomeTravelHotelHelicopter,
    iconFontAwesomeTravelHotelHorse,
    iconFontAwesomeTravelHotelJetFighter,
    iconFontAwesomeTravelHotelJetFighterUp,
    iconFontAwesomeTravelHotelMotorcycle,
    iconFontAwesomeTravelHotelMound,
    iconFontAwesomeTravelHotelPaperPlane,
    iconFontAwesomeTravelHotelPlane,
    iconFontAwesomeTravelHotelPlaneSlash,
    iconFontAwesomeTravelHotelPlaneUp,
    iconFontAwesomeTravelHotelRoadBarrier,
    iconFontAwesomeTravelHotelRoad,
    iconFontAwesomeTravelHotelRoadSpikes,
    iconFontAwesomeTravelHotelRocket,
    iconFontAwesomeTravelHotelSailboat,
    iconFontAwesomeTravelHotelShip,
    iconFontAwesomeTravelHotelShuttleSpace,
    iconFontAwesomeTravelHotelSleigh,
    iconFontAwesomeTravelHotelSnowplow,
    iconFontAwesomeTravelHotelTaxi,
    iconFontAwesomeTravelHotelTractor,
    iconFontAwesomeTravelHotelTrain,
    iconFontAwesomeTravelHotelTrainSubway,
    iconFontAwesomeTravelHotelTrainTram,
    iconFontAwesomeTravelHotelTruckArrowRight,
    iconFontAwesomeTravelHotelTruckDroplet,
    iconFontAwesomeTravelHotelTruckField,
    iconFontAwesomeTravelHotelTruckFieldUn,
    iconFontAwesomeTravelHotelTruckFront,
    iconFontAwesomeTravelHotelTruck,
    iconFontAwesomeTravelHotelTruckMedical,
    iconFontAwesomeTravelHotelTruckMonster,
    iconFontAwesomeTravelHotelTruckPickup,
    iconFontAwesomeTravelHotelTruckPlane,
    iconFontAwesomeTravelHotelVanShuttle,
    iconFontAwesomeTravelHotelWheelchair,
    iconFontAwesomeTravelHotelWheelchairMove,
} from './travel+hotel';

// travel+hotel
const travelHotelIcons = [
    {
        name: 'iconFontAwesomeTravelHotelAccessibleIcon',
        title: __('Accessible Icon', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelAccessibleIcon,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelBabyCarriage',
        title: __('Baby Carriage', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelBabyCarriage,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelBicycle',
        title: __('Bicycle', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelBicycle,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelBus',
        title: __('Bus', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelBus,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelBusSimple',
        title: __('Bus Simple', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelBusSimple,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelCableCar',
        title: __('Cable Car', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelCableCar,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelCarBurst',
        title: __('Car Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelCarBurst,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelCar',
        title: __('Car', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelCar,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelCarRear',
        title: __('Car Rear', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelCarRear,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelCarSide',
        title: __('Car Side', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelCarSide,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelCartShopping',
        title: __('Cart Shopping', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelCartShopping,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelCarTunnel',
        title: __('Car Tunnel', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelCarTunnel,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelFerry',
        title: __('Ferry', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelFerry,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelHelicopter',
        title: __('Helicopter', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelHelicopter,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelHorse',
        title: __('Horse', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelHorse,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelJetFighter',
        title: __('Jet Fighter', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelJetFighter,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelJetFighterUp',
        title: __('Jet Fighter Up', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelJetFighterUp,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelMotorcycle',
        title: __('Motorcycle', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelMotorcycle,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelMound',
        title: __('Mound', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelMound,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelPaperPlane',
        title: __('Paper Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelPaperPlane,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelPlane',
        title: __('Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelPlane,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelPlaneSlash',
        title: __('Plane Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelPlaneSlash,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelPlaneUp',
        title: __('Plane Up', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelPlaneUp,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelRoadBarrier',
        title: __('Road Barrier', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelRoadBarrier,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelRoad',
        title: __('Road', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelRoad,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelRoadSpikes',
        title: __('Road Spikes', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelRoadSpikes,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelRocket',
        title: __('Rocket', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelRocket,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelSailboat',
        title: __('Sailboat', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelSailboat,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelShip',
        title: __('Ship', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelShip,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelShuttleSpace',
        title: __('Shuttle Space', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelShuttleSpace,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelSleigh',
        title: __('Sleigh', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelSleigh,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelSnowplow',
        title: __('Snowplow', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelSnowplow,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTaxi',
        title: __('Taxi', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTaxi,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTractor',
        title: __('Tractor', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTractor,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTrain',
        title: __('Train', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTrain,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTrainSubway',
        title: __('Train Subway', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTrainSubway,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTrainTram',
        title: __('Train Tram', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTrainTram,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckArrowRight',
        title: __('Truck Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckArrowRight,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckDroplet',
        title: __('Truck Droplet', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckDroplet,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckField',
        title: __('Truck Field', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckField,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckFieldUn',
        title: __('Truck Field Un', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckFieldUn,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckFront',
        title: __('Truck Front', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckFront,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruck',
        title: __('Truck', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruck,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckMedical',
        title: __('Truck Medical', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckMedical,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckMonster',
        title: __('Truck Monster', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckMonster,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckPickup',
        title: __('Truck Pickup', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckPickup,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelTruckPlane',
        title: __('Truck Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelTruckPlane,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelVanShuttle',
        title: __('Van Shuttle', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelVanShuttle,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelWheelchair',
        title: __('Wheelchair', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelWheelchair,
        categories: ['travel+hotel'],
    },
    {
        name: 'iconFontAwesomeTravelHotelWheelchairMove',
        title: __('Wheelchair Move', 'icon-font-awesome'),
        icon: iconFontAwesomeTravelHotelWheelchairMove,
        categories: ['travel+hotel'],
    },
];

// users+people
import {
    iconFontAwesomeUsersPeopleAccessibleIcon,
    iconFontAwesomeUsersPeopleAddressBook,
    iconFontAwesomeUsersPeopleAddressCard,
    iconFontAwesomeUsersPeopleArrowsDownToPeople,
    iconFontAwesomeUsersPeopleBaby,
    iconFontAwesomeUsersPeopleBed,
    iconFontAwesomeUsersPeopleChalkboardUser,
    iconFontAwesomeUsersPeopleChildDress,
    iconFontAwesomeUsersPeopleChild,
    iconFontAwesomeUsersPeopleChildReaching,
    iconFontAwesomeUsersPeopleChildren,
    iconFontAwesomeUsersPeopleCircleUser,
    iconFontAwesomeUsersPeopleClipboardUser,
    iconFontAwesomeUsersPeopleElevator,
    iconFontAwesomeUsersPeopleFaceFrown,
    iconFontAwesomeUsersPeopleFaceMeh,
    iconFontAwesomeUsersPeopleFaceSmile,
    iconFontAwesomeUsersPeopleHeadSideCough,
    iconFontAwesomeUsersPeopleHeadSideCoughSlash,
    iconFontAwesomeUsersPeopleHeadSideMask,
    iconFontAwesomeUsersPeopleHeadSideVirus,
    iconFontAwesomeUsersPeopleHospitalUser,
    iconFontAwesomeUsersPeopleHotTubPerson,
    iconFontAwesomeUsersPeopleHouseChimneyUser,
    iconFontAwesomeUsersPeopleHouseUser,
    iconFontAwesomeUsersPeopleIdBadge,
    iconFontAwesomeUsersPeopleIdCardClip,
    iconFontAwesomeUsersPeopleIdCard,
    iconFontAwesomeUsersPeopleImagePortrait,
    iconFontAwesomeUsersPeopleMarsAndVenusBurst,
    iconFontAwesomeUsersPeoplePeopleArrows,
    iconFontAwesomeUsersPeoplePeopleCarryBox,
    iconFontAwesomeUsersPeoplePeopleGroup,
    iconFontAwesomeUsersPeoplePeopleLine,
    iconFontAwesomeUsersPeoplePeoplePulling,
    iconFontAwesomeUsersPeoplePeopleRobbery,
    iconFontAwesomeUsersPeoplePeopleRoof,
    iconFontAwesomeUsersPeoplePersonArrowDownToLine,
    iconFontAwesomeUsersPeoplePersonArrowUpFromLine,
    iconFontAwesomeUsersPeoplePersonBiking,
    iconFontAwesomeUsersPeoplePersonBooth,
    iconFontAwesomeUsersPeoplePersonBreastfeeding,
    iconFontAwesomeUsersPeoplePersonBurst,
    iconFontAwesomeUsersPeoplePersonCane,
    iconFontAwesomeUsersPeoplePersonChalkboard,
    iconFontAwesomeUsersPeoplePersonCircleCheck,
    iconFontAwesomeUsersPeoplePersonCircleExclamation,
    iconFontAwesomeUsersPeoplePersonCircleMinus,
    iconFontAwesomeUsersPeoplePersonCirclePlus,
    iconFontAwesomeUsersPeoplePersonCircleQuestion,
    iconFontAwesomeUsersPeoplePersonCircleXmark,
    iconFontAwesomeUsersPeoplePersonDigging,
    iconFontAwesomeUsersPeoplePersonDotsFromLine,
    iconFontAwesomeUsersPeoplePersonDressBurst,
    iconFontAwesomeUsersPeoplePersonDress,
    iconFontAwesomeUsersPeoplePersonDrowning,
    iconFontAwesomeUsersPeoplePersonFallingBurst,
    iconFontAwesomeUsersPeoplePersonFalling,
    iconFontAwesomeUsersPeoplePersonHalfDress,
    iconFontAwesomeUsersPeoplePersonHarassing,
    iconFontAwesomeUsersPeoplePersonHiking,
    iconFontAwesomeUsersPeoplePerson,
    iconFontAwesomeUsersPeoplePersonMilitaryPointing,
    iconFontAwesomeUsersPeoplePersonMilitaryRifle,
    iconFontAwesomeUsersPeoplePersonMilitaryToPerson,
    iconFontAwesomeUsersPeoplePersonPraying,
    iconFontAwesomeUsersPeoplePersonPregnant,
    iconFontAwesomeUsersPeoplePersonRays,
    iconFontAwesomeUsersPeoplePersonRifle,
    iconFontAwesomeUsersPeoplePersonRunning,
    iconFontAwesomeUsersPeoplePersonShelter,
    iconFontAwesomeUsersPeoplePersonSkating,
    iconFontAwesomeUsersPeoplePersonSkiing,
    iconFontAwesomeUsersPeoplePersonSkiingNordic,
    iconFontAwesomeUsersPeoplePersonSnowboarding,
    iconFontAwesomeUsersPeoplePersonSwimming,
    iconFontAwesomeUsersPeoplePersonThroughWindow,
    iconFontAwesomeUsersPeoplePersonWalkingArrowLoopLeft,
    iconFontAwesomeUsersPeoplePersonWalkingArrowRight,
    iconFontAwesomeUsersPeoplePersonWalkingDashedLineArrowRight,
    iconFontAwesomeUsersPeoplePersonWalking,
    iconFontAwesomeUsersPeoplePersonWalkingLuggage,
    iconFontAwesomeUsersPeoplePersonWalkingWithCane,
    iconFontAwesomeUsersPeoplePoo,
    iconFontAwesomeUsersPeopleRestroom,
    iconFontAwesomeUsersPeopleSkull,
    iconFontAwesomeUsersPeopleSquarePersonConfined,
    iconFontAwesomeUsersPeopleStreetView,
    iconFontAwesomeUsersPeopleUserAstronaut,
    iconFontAwesomeUsersPeopleUserCheck,
    iconFontAwesomeUsersPeopleUserClock,
    iconFontAwesomeUsersPeopleUserDoctor,
    iconFontAwesomeUsersPeopleUserGear,
    iconFontAwesomeUsersPeopleUserGraduate,
    iconFontAwesomeUsersPeopleUserGroup,
    iconFontAwesomeUsersPeopleUserInjured,
    iconFontAwesomeUsersPeopleUser,
    iconFontAwesomeUsersPeopleUserLarge,
    iconFontAwesomeUsersPeopleUserLargeSlash,
    iconFontAwesomeUsersPeopleUserLock,
    iconFontAwesomeUsersPeopleUserMinus,
    iconFontAwesomeUsersPeopleUserNinja,
    iconFontAwesomeUsersPeopleUserNurse,
    iconFontAwesomeUsersPeopleUserPen,
    iconFontAwesomeUsersPeopleUserPlus,
    iconFontAwesomeUsersPeopleUsersBetweenLines,
    iconFontAwesomeUsersPeopleUserSecret,
    iconFontAwesomeUsersPeopleUsersGear,
    iconFontAwesomeUsersPeopleUserShield,
    iconFontAwesomeUsersPeopleUsers,
    iconFontAwesomeUsersPeopleUserSlash,
    iconFontAwesomeUsersPeopleUsersLine,
    iconFontAwesomeUsersPeopleUsersRays,
    iconFontAwesomeUsersPeopleUsersRectangle,
    iconFontAwesomeUsersPeopleUsersSlash,
    iconFontAwesomeUsersPeopleUsersViewfinder,
    iconFontAwesomeUsersPeopleUserTag,
    iconFontAwesomeUsersPeopleUserTie,
    iconFontAwesomeUsersPeopleUserXmark,
    iconFontAwesomeUsersPeopleWheelchair,
    iconFontAwesomeUsersPeopleWheelchairMove,
} from './users+people';

// users+people
const usersPeopleIcons = [
    {
        name: 'iconFontAwesomeUsersPeopleAccessibleIcon',
        title: __('Accessible Icon', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleAccessibleIcon,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleAddressBook',
        title: __('Address Book', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleAddressBook,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleAddressCard',
        title: __('Address Card', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleAddressCard,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleArrowsDownToPeople',
        title: __('Arrows Down To People', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleArrowsDownToPeople,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleBaby',
        title: __('Baby', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleBaby,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleBed',
        title: __('Bed', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleBed,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleChalkboardUser',
        title: __('Chalkboard User', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleChalkboardUser,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleChildDress',
        title: __('Child Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleChildDress,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleChild',
        title: __('Child', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleChild,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleChildReaching',
        title: __('Child Reaching', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleChildReaching,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleChildren',
        title: __('Children', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleChildren,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleCircleUser',
        title: __('Circle User', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleCircleUser,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleClipboardUser',
        title: __('Clipboard User', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleClipboardUser,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleElevator',
        title: __('Elevator', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleElevator,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleFaceFrown',
        title: __('Face Frown', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleFaceFrown,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleFaceMeh',
        title: __('Face Meh', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleFaceMeh,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleFaceSmile',
        title: __('Face Smile', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleFaceSmile,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHeadSideCough',
        title: __('Head Side Cough', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHeadSideCough,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHeadSideCoughSlash',
        title: __('Head Side Cough Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHeadSideCoughSlash,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHeadSideMask',
        title: __('Head Side Mask', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHeadSideMask,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHeadSideVirus',
        title: __('Head Side Virus', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHeadSideVirus,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHospitalUser',
        title: __('Hospital User', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHospitalUser,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHotTubPerson',
        title: __('Hot Tub Person', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHotTubPerson,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHouseChimneyUser',
        title: __('House Chimney User', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHouseChimneyUser,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleHouseUser',
        title: __('House User', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleHouseUser,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleIdBadge',
        title: __('Id Badge', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleIdBadge,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleIdCardClip',
        title: __('Id Card Clip', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleIdCardClip,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleIdCard',
        title: __('Id Card', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleIdCard,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleImagePortrait',
        title: __('Image Portrait', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleImagePortrait,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleMarsAndVenusBurst',
        title: __('Mars And Venus Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleMarsAndVenusBurst,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePeopleArrows',
        title: __('People Arrows', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePeopleArrows,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePeopleCarryBox',
        title: __('People Carry Box', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePeopleCarryBox,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePeopleGroup',
        title: __('People Group', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePeopleGroup,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePeopleLine',
        title: __('People Line', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePeopleLine,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePeoplePulling',
        title: __('People Pulling', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePeoplePulling,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePeopleRobbery',
        title: __('People Robbery', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePeopleRobbery,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePeopleRoof',
        title: __('People Roof', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePeopleRoof,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonArrowDownToLine',
        title: __('Person Arrow Down To Line', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonArrowDownToLine,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonArrowUpFromLine',
        title: __('Person Arrow Up From Line', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonArrowUpFromLine,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonBiking',
        title: __('Person Biking', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonBiking,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonBooth',
        title: __('Person Booth', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonBooth,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonBreastfeeding',
        title: __('Person Breastfeeding', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonBreastfeeding,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonBurst',
        title: __('Person Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonBurst,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonCane',
        title: __('Person Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonCane,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonChalkboard',
        title: __('Person Chalkboard', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonChalkboard,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonCircleCheck',
        title: __('Person Circle Check', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonCircleCheck,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonCircleExclamation',
        title: __('Person Circle Exclamation', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonCircleExclamation,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonCircleMinus',
        title: __('Person Circle Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonCircleMinus,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonCirclePlus',
        title: __('Person Circle Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonCirclePlus,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonCircleQuestion',
        title: __('Person Circle Question', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonCircleQuestion,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonCircleXmark',
        title: __('Person Circle Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonCircleXmark,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonDigging',
        title: __('Person Digging', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonDigging,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonDotsFromLine',
        title: __('Person Dots From Line', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonDotsFromLine,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonDressBurst',
        title: __('Person Dress Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonDressBurst,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonDress',
        title: __('Person Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonDress,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonDrowning',
        title: __('Person Drowning', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonDrowning,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonFallingBurst',
        title: __('Person Falling Burst', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonFallingBurst,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonFalling',
        title: __('Person Falling', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonFalling,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonHalfDress',
        title: __('Person Half Dress', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonHalfDress,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonHarassing',
        title: __('Person Harassing', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonHarassing,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonHiking',
        title: __('Person Hiking', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonHiking,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePerson',
        title: __('Person', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePerson,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonMilitaryPointing',
        title: __('Person Military Pointing', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonMilitaryPointing,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonMilitaryRifle',
        title: __('Person Military Rifle', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonMilitaryRifle,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonMilitaryToPerson',
        title: __('Person Military To Person', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonMilitaryToPerson,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonPraying',
        title: __('Person Praying', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonPraying,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonPregnant',
        title: __('Person Pregnant', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonPregnant,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonRays',
        title: __('Person Rays', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonRays,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonRifle',
        title: __('Person Rifle', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonRifle,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonRunning',
        title: __('Person Running', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonRunning,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonShelter',
        title: __('Person Shelter', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonShelter,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonSkating',
        title: __('Person Skating', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonSkating,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonSkiing',
        title: __('Person Skiing', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonSkiing,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonSkiingNordic',
        title: __('Person Skiing Nordic', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonSkiingNordic,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonSnowboarding',
        title: __('Person Snowboarding', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonSnowboarding,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonSwimming',
        title: __('Person Swimming', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonSwimming,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonThroughWindow',
        title: __('Person Through Window', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonThroughWindow,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonWalkingArrowLoopLeft',
        title: __('Person Walking Arrow Loop Left', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonWalkingArrowLoopLeft,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonWalkingArrowRight',
        title: __('Person Walking Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonWalkingArrowRight,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonWalkingDashedLineArrowRight',
        title: __('Person Walking Dashed Line Arrow Right', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonWalkingDashedLineArrowRight,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonWalking',
        title: __('Person Walking', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonWalking,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonWalkingLuggage',
        title: __('Person Walking Luggage', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonWalkingLuggage,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePersonWalkingWithCane',
        title: __('Person Walking With Cane', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePersonWalkingWithCane,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeoplePoo',
        title: __('Poo', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeoplePoo,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleRestroom',
        title: __('Restroom', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleRestroom,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleSkull',
        title: __('Skull', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleSkull,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleSquarePersonConfined',
        title: __('Square Person Confined', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleSquarePersonConfined,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleStreetView',
        title: __('Street View', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleStreetView,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserAstronaut',
        title: __('User Astronaut', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserAstronaut,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserCheck',
        title: __('User Check', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserCheck,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserClock',
        title: __('User Clock', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserClock,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserDoctor',
        title: __('User Doctor', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserDoctor,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserGear',
        title: __('User Gear', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserGear,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserGraduate',
        title: __('User Graduate', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserGraduate,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserGroup',
        title: __('User Group', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserGroup,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserInjured',
        title: __('User Injured', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserInjured,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUser',
        title: __('User', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUser,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserLarge',
        title: __('User Large', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserLarge,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserLargeSlash',
        title: __('User Large Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserLargeSlash,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserLock',
        title: __('User Lock', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserLock,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserMinus',
        title: __('User Minus', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserMinus,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserNinja',
        title: __('User Ninja', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserNinja,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserNurse',
        title: __('User Nurse', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserNurse,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserPen',
        title: __('User Pen', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserPen,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserPlus',
        title: __('User Plus', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserPlus,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsersBetweenLines',
        title: __('Users Between Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsersBetweenLines,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserSecret',
        title: __('User Secret', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserSecret,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsersGear',
        title: __('Users Gear', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsersGear,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserShield',
        title: __('User Shield', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserShield,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsers',
        title: __('Users', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsers,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserSlash',
        title: __('User Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserSlash,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsersLine',
        title: __('Users Line', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsersLine,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsersRays',
        title: __('Users Rays', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsersRays,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsersRectangle',
        title: __('Users Rectangle', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsersRectangle,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsersSlash',
        title: __('Users Slash', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsersSlash,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUsersViewfinder',
        title: __('Users Viewfinder', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUsersViewfinder,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserTag',
        title: __('User Tag', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserTag,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserTie',
        title: __('User Tie', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserTie,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleUserXmark',
        title: __('User Xmark', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleUserXmark,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleWheelchair',
        title: __('Wheelchair', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleWheelchair,
        categories: ['users+people'],
    },
    {
        name: 'iconFontAwesomeUsersPeopleWheelchairMove',
        title: __('Wheelchair Move', 'icon-font-awesome'),
        icon: iconFontAwesomeUsersPeopleWheelchairMove,
        categories: ['users+people'],
    },
];

// weather
import {
    iconFontAwesomeWeatherBolt,
    iconFontAwesomeWeatherBoltLightning,
    iconFontAwesomeWeatherCloudBolt,
    iconFontAwesomeWeatherCloud,
    iconFontAwesomeWeatherCloudMeatball,
    iconFontAwesomeWeatherCloudMoon,
    iconFontAwesomeWeatherCloudMoonRain,
    iconFontAwesomeWeatherCloudRain,
    iconFontAwesomeWeatherCloudShowersHeavy,
    iconFontAwesomeWeatherCloudShowersWater,
    iconFontAwesomeWeatherCloudSun,
    iconFontAwesomeWeatherCloudSunRain,
    iconFontAwesomeWeatherHouseTsunami,
    iconFontAwesomeWeatherHurricane,
    iconFontAwesomeWeatherIcicles,
    iconFontAwesomeWeatherMeteor,
    iconFontAwesomeWeatherMoon,
    iconFontAwesomeWeatherPooStorm,
    iconFontAwesomeWeatherRainbow,
    iconFontAwesomeWeatherSmog,
    iconFontAwesomeWeatherSnowflake,
    iconFontAwesomeWeatherSun,
    iconFontAwesomeWeatherSunPlantWilt,
    iconFontAwesomeWeatherTemperatureArrowDown,
    iconFontAwesomeWeatherTemperatureArrowUp,
    iconFontAwesomeWeatherTemperatureEmpty,
    iconFontAwesomeWeatherTemperatureFull,
    iconFontAwesomeWeatherTemperatureHalf,
    iconFontAwesomeWeatherTemperatureHigh,
    iconFontAwesomeWeatherTemperatureLow,
    iconFontAwesomeWeatherTemperatureQuarter,
    iconFontAwesomeWeatherTemperatureThreeQuarters,
    iconFontAwesomeWeatherTornado,
    iconFontAwesomeWeatherUmbrella,
    iconFontAwesomeWeatherVolcano,
    iconFontAwesomeWeatherWater,
    iconFontAwesomeWeatherWind,
} from './weather';

// weather
const weatherIcons = [
    {
        name: 'iconFontAwesomeWeatherBolt',
        title: __('Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherBolt,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherBoltLightning',
        title: __('Bolt Lightning', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherBoltLightning,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudBolt',
        title: __('Cloud Bolt', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudBolt,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloud',
        title: __('Cloud', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloud,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudMeatball',
        title: __('Cloud Meatball', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudMeatball,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudMoon',
        title: __('Cloud Moon', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudMoon,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudMoonRain',
        title: __('Cloud Moon Rain', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudMoonRain,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudRain',
        title: __('Cloud Rain', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudRain,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudShowersHeavy',
        title: __('Cloud Showers Heavy', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudShowersHeavy,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudShowersWater',
        title: __('Cloud Showers Water', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudShowersWater,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudSun',
        title: __('Cloud Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudSun,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherCloudSunRain',
        title: __('Cloud Sun Rain', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherCloudSunRain,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherHouseTsunami',
        title: __('House Tsunami', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherHouseTsunami,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherHurricane',
        title: __('Hurricane', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherHurricane,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherIcicles',
        title: __('Icicles', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherIcicles,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherMeteor',
        title: __('Meteor', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherMeteor,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherMoon',
        title: __('Moon', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherMoon,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherPooStorm',
        title: __('Poo Storm', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherPooStorm,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherRainbow',
        title: __('Rainbow', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherRainbow,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherSmog',
        title: __('Smog', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherSmog,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherSnowflake',
        title: __('Snowflake', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherSnowflake,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherSun',
        title: __('Sun', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherSun,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherSunPlantWilt',
        title: __('Sun Plant Wilt', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherSunPlantWilt,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureArrowDown',
        title: __('Temperature Arrow Down', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureArrowDown,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureArrowUp',
        title: __('Temperature Arrow Up', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureArrowUp,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureEmpty',
        title: __('Temperature Empty', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureEmpty,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureFull',
        title: __('Temperature Full', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureFull,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureHalf',
        title: __('Temperature Half', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureHalf,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureHigh',
        title: __('Temperature High', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureHigh,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureLow',
        title: __('Temperature Low', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureLow,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureQuarter',
        title: __('Temperature Quarter', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureQuarter,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTemperatureThreeQuarters',
        title: __('Temperature Three Quarters', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTemperatureThreeQuarters,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherTornado',
        title: __('Tornado', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherTornado,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherUmbrella',
        title: __('Umbrella', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherUmbrella,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherVolcano',
        title: __('Volcano', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherVolcano,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherWater',
        title: __('Water', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherWater,
        categories: ['weather'],
    },
    {
        name: 'iconFontAwesomeWeatherWind',
        title: __('Wind', 'icon-font-awesome'),
        icon: iconFontAwesomeWeatherWind,
        categories: ['weather'],
    },
];

// writing
import {
    iconFontAwesomeWritingBlog,
    iconFontAwesomeWritingBookBookmark,
    iconFontAwesomeWritingBook,
    iconFontAwesomeWritingBookmark,
    iconFontAwesomeWritingBoxArchive,
    iconFontAwesomeWritingEnvelope,
    iconFontAwesomeWritingEnvelopeOpen,
    iconFontAwesomeWritingEraser,
    iconFontAwesomeWritingFile,
    iconFontAwesomeWritingFileLines,
    iconFontAwesomeWritingFolder,
    iconFontAwesomeWritingFolderOpen,
    iconFontAwesomeWritingKeyboard,
    iconFontAwesomeWritingNewspaper,
    iconFontAwesomeWritingNotdef,
    iconFontAwesomeWritingNoteSticky,
    iconFontAwesomeWritingPaperclip,
    iconFontAwesomeWritingPaperPlane,
    iconFontAwesomeWritingParagraph,
    iconFontAwesomeWritingPencil,
    iconFontAwesomeWritingPenClip,
    iconFontAwesomeWritingPen,
    iconFontAwesomeWritingPenToSquare,
    iconFontAwesomeWritingQuoteLeft,
    iconFontAwesomeWritingQuoteRight,
    iconFontAwesomeWritingSignature,
    iconFontAwesomeWritingSquarePen,
    iconFontAwesomeWritingThumbtack,
} from './writing';

// writing
const writingIcons = [
    {
        name: 'iconFontAwesomeWritingBlog',
        title: __('Blog', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingBlog,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingBookBookmark',
        title: __('Book Bookmark', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingBookBookmark,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingBook',
        title: __('Book', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingBook,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingBookmark',
        title: __('Bookmark', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingBookmark,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingBoxArchive',
        title: __('Box Archive', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingBoxArchive,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingEnvelope',
        title: __('Envelope', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingEnvelope,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingEnvelopeOpen',
        title: __('Envelope Open', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingEnvelopeOpen,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingEraser',
        title: __('Eraser', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingEraser,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingFile',
        title: __('File', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingFile,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingFileLines',
        title: __('File Lines', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingFileLines,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingFolder',
        title: __('Folder', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingFolder,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingFolderOpen',
        title: __('Folder Open', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingFolderOpen,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingKeyboard',
        title: __('Keyboard', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingKeyboard,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingNewspaper',
        title: __('Newspaper', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingNewspaper,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingNotdef',
        title: __('Notdef', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingNotdef,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingNoteSticky',
        title: __('Note Sticky', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingNoteSticky,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingPaperclip',
        title: __('Paperclip', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingPaperclip,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingPaperPlane',
        title: __('Paper Plane', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingPaperPlane,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingParagraph',
        title: __('Paragraph', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingParagraph,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingPencil',
        title: __('Pencil', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingPencil,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingPenClip',
        title: __('Pen Clip', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingPenClip,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingPen',
        title: __('Pen', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingPen,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingPenToSquare',
        title: __('Pen To Square', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingPenToSquare,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingQuoteLeft',
        title: __('Quote Left', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingQuoteLeft,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingQuoteRight',
        title: __('Quote Right', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingQuoteRight,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingSignature',
        title: __('Signature', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingSignature,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingSquarePen',
        title: __('Square Pen', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingSquarePen,
        categories: ['writing'],
    },
    {
        name: 'iconFontAwesomeWritingThumbtack',
        title: __('Thumbtack', 'icon-font-awesome'),
        icon: iconFontAwesomeWritingThumbtack,
        categories: ['writing'],
    },
];

// Icons
const icons = [
    {
        isDefault: false,
        type: 'Icons',
        title: __('Font Awesome', 'icon-font-awesome'),
        icons: [].concat(accessibilityIcons, alertIcons, alphabetIcons, animalsIcons, arrowsIcons, astronomyIcons, automotiveIcons, buildingsIcons, campingIcons, charityIcons, chartsDiagramsIcons, childhoodIcons, clothingFashionIcons, codingIcons, communicationIcons, connectivityIcons, constructionIcons, designIcons, devicesHardwareIcons, disasterCrisisIcons, editingIcons, educationIcons, emojiIcons, energyIcons, filesIcons, filmVideoIcons, foodBeverageIcons, fruitsVegetablesIcons, gamingIcons, gendersIcons, halloweenIcons, handsIcons, holidaysIcons, householdIcons, humanitarianIcons, logisticsIcons, mapsIcons, maritimeIcons, marketingIcons, mathematicsIcons, mediaPlaybackIcons, medicalHealthIcons, moneyIcons, movingIcons, musicVideoIcons, natureIcons, numbersIcons, photosImagesIcons, politicalIcons, punctuationSymbolsIcons, religionIcons, scienceIcons, scienceFictionIcons, securityIcons, shapesIcons, shoppingIcons, socialIcons, spinnersIcons, sportsFitnessIcons, textFormattingIcons, timeIcons, toggleIcons, transportationIcons, travelHotelIcons, usersPeopleIcons, weatherIcons, writingIcons),
        categories: [
					{
    			name: 'accessibility',
    			title: __('Accessibility', 'icon-font-awesome'),
			},
			{
    			name: 'alert',
    			title: __('Alert', 'icon-font-awesome'),
			},
			{
    			name: 'alphabet',
    			title: __('Alphabet', 'icon-font-awesome'),
			},
			{
    			name: 'animals',
    			title: __('Animals', 'icon-font-awesome'),
			},
			{
    			name: 'arrows',
    			title: __('Arrows', 'icon-font-awesome'),
			},
			{
    			name: 'astronomy',
    			title: __('Astronomy', 'icon-font-awesome'),
			},
			{
    			name: 'automotive',
    			title: __('Automotive', 'icon-font-awesome'),
			},
			{
    			name: 'buildings',
    			title: __('Buildings', 'icon-font-awesome'),
			},
			{
    			name: 'camping',
    			title: __('Camping', 'icon-font-awesome'),
			},
			{
    			name: 'charity',
    			title: __('Charity', 'icon-font-awesome'),
			},
			{
    			name: 'charts+diagrams',
    			title: __('Charts Diagrams', 'icon-font-awesome'),
			},
			{
    			name: 'childhood',
    			title: __('Childhood', 'icon-font-awesome'),
			},
			{
    			name: 'clothing+fashion',
    			title: __('Clothing Fashion', 'icon-font-awesome'),
			},
			{
    			name: 'coding',
    			title: __('Coding', 'icon-font-awesome'),
			},
			{
    			name: 'communication',
    			title: __('Communication', 'icon-font-awesome'),
			},
			{
    			name: 'connectivity',
    			title: __('Connectivity', 'icon-font-awesome'),
			},
			{
    			name: 'construction',
    			title: __('Construction', 'icon-font-awesome'),
			},
			{
    			name: 'design',
    			title: __('Design', 'icon-font-awesome'),
			},
			{
    			name: 'devices+hardware',
    			title: __('Devices Hardware', 'icon-font-awesome'),
			},
			{
    			name: 'disaster+crisis',
    			title: __('Disaster Crisis', 'icon-font-awesome'),
			},
			{
    			name: 'editing',
    			title: __('Editing', 'icon-font-awesome'),
			},
			{
    			name: 'education',
    			title: __('Education', 'icon-font-awesome'),
			},
			{
    			name: 'emoji',
    			title: __('Emoji', 'icon-font-awesome'),
			},
			{
    			name: 'energy',
    			title: __('Energy', 'icon-font-awesome'),
			},
			{
    			name: 'files',
    			title: __('Files', 'icon-font-awesome'),
			},
			{
    			name: 'film+video',
    			title: __('Film Video', 'icon-font-awesome'),
			},
			{
    			name: 'food+beverage',
    			title: __('Food Beverage', 'icon-font-awesome'),
			},
			{
    			name: 'fruits+vegetables',
    			title: __('Fruits Vegetables', 'icon-font-awesome'),
			},
			{
    			name: 'gaming',
    			title: __('Gaming', 'icon-font-awesome'),
			},
			{
    			name: 'genders',
    			title: __('Genders', 'icon-font-awesome'),
			},
			{
    			name: 'halloween',
    			title: __('Halloween', 'icon-font-awesome'),
			},
			{
    			name: 'hands',
    			title: __('Hands', 'icon-font-awesome'),
			},
			{
    			name: 'holidays',
    			title: __('Holidays', 'icon-font-awesome'),
			},
			{
    			name: 'household',
    			title: __('Household', 'icon-font-awesome'),
			},
			{
    			name: 'humanitarian',
    			title: __('Humanitarian', 'icon-font-awesome'),
			},
			{
    			name: 'logistics',
    			title: __('Logistics', 'icon-font-awesome'),
			},
			{
    			name: 'maps',
    			title: __('Maps', 'icon-font-awesome'),
			},
			{
    			name: 'maritime',
    			title: __('Maritime', 'icon-font-awesome'),
			},
			{
    			name: 'marketing',
    			title: __('Marketing', 'icon-font-awesome'),
			},
			{
    			name: 'mathematics',
    			title: __('Mathematics', 'icon-font-awesome'),
			},
			{
    			name: 'media-playback',
    			title: __('Media Playback', 'icon-font-awesome'),
			},
			{
    			name: 'medical+health',
    			title: __('Medical Health', 'icon-font-awesome'),
			},
			{
    			name: 'money',
    			title: __('Money', 'icon-font-awesome'),
			},
			{
    			name: 'moving',
    			title: __('Moving', 'icon-font-awesome'),
			},
			{
    			name: 'music+video',
    			title: __('Music Video', 'icon-font-awesome'),
			},
			{
    			name: 'nature',
    			title: __('Nature', 'icon-font-awesome'),
			},
			{
    			name: 'numbers',
    			title: __('Numbers', 'icon-font-awesome'),
			},
			{
    			name: 'photos+images',
    			title: __('Photos Images', 'icon-font-awesome'),
			},
			{
    			name: 'political',
    			title: __('Political', 'icon-font-awesome'),
			},
			{
    			name: 'punctuation+symbols',
    			title: __('Punctuation Symbols', 'icon-font-awesome'),
			},
			{
    			name: 'religion',
    			title: __('Religion', 'icon-font-awesome'),
			},
			{
    			name: 'science',
    			title: __('Science', 'icon-font-awesome'),
			},
			{
    			name: 'science-fiction',
    			title: __('Science Fiction', 'icon-font-awesome'),
			},
			{
    			name: 'security',
    			title: __('Security', 'icon-font-awesome'),
			},
			{
    			name: 'shapes',
    			title: __('Shapes', 'icon-font-awesome'),
			},
			{
    			name: 'shopping',
    			title: __('Shopping', 'icon-font-awesome'),
			},
			{
    			name: 'social',
    			title: __('Social', 'icon-font-awesome'),
			},
			{
    			name: 'spinners',
    			title: __('Spinners', 'icon-font-awesome'),
			},
			{
    			name: 'sports+fitness',
    			title: __('Sports Fitness', 'icon-font-awesome'),
			},
			{
    			name: 'text-formatting',
    			title: __('Text Formatting', 'icon-font-awesome'),
			},
			{
    			name: 'time',
    			title: __('Time', 'icon-font-awesome'),
			},
			{
    			name: 'toggle',
    			title: __('Toggle', 'icon-font-awesome'),
			},
			{
    			name: 'transportation',
    			title: __('Transportation', 'icon-font-awesome'),
			},
			{
    			name: 'travel+hotel',
    			title: __('Travel Hotel', 'icon-font-awesome'),
			},
			{
    			name: 'users+people',
    			title: __('Users People', 'icon-font-awesome'),
			},
			{
    			name: 'weather',
    			title: __('Weather', 'icon-font-awesome'),
			},
			{
    			name: 'writing',
    			title: __('Writing', 'icon-font-awesome'),
			},
        ],
    },
];

// Allow third parties to add their own icon types via filter.
export default function getIcons() {
    return applyFilters('iconBlock.icons', icons);
}
